import React, { useState, useEffect, useRef } from "react";
import arrow from "../images/Stroke 1.svg";
import arrow2 from "../images/Stroke 2.svg";
import { IoMdArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import Select, { components } from "react-select";
import download_black from "../images/download_balck.png";
import file_upload from "../images/Action Icon Filled.svg";
import sparkle from "../images/sparkle.svg";
import mail from "../images/mail.svg";
import rattingstar from "../images/ratting.svg";
import { IoIosArrowDown } from "react-icons/io";
import Download from "../images/Download.svg";
import { IoIosArrowUp } from "react-icons/io";
import { useDispatch } from "react-redux";
import union from "../images/union.svg";
import { CSVLink, CSVDownload } from "react-csv";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { server_API } from "../config";
import { FaSortUp } from "react-icons/fa6";
import cross from "../images/Vector.svg";
import Tick_Square from "../images/Tick Square.svg";
import Papa from "papaparse";
import { updateCandidateFilters } from "../features/candidateFilters";
import error from "../images/error.png";
import ReactStars from "react-stars";
import { ButtonHollowXs, ButtonXs } from "./ButtonComponents";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { selectActiveInterviewedTab } from "../features/activeInterviewedTab";
import { selectCandidateTab } from "../features/candidateTab";
import { selectCid } from "../features/companyid";
import { getUserPrivilege, selectUuid } from "../features/userid";
import { selectSortedBy } from "../features/sortedBy";
import { selectCandidateFilters } from "../features/candidateFilters";
import { updateSortedBy } from "../features/sortedBy";
import { IoAlertCircleOutline, IoInformationCircle } from "react-icons/io5";
import { MdOutlineDateRange, MdAccessTime } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import googleMeetIcon from "../images/google-meet.svg";
import virtualInterviewIcon from "../images/virtual-interview.svg";
import { VscDebugRestart } from "react-icons/vsc";
import { LuRefreshCcw } from "react-icons/lu";
import DatePicker from "react-datepicker";
import pp from "../images/pp.png";
import JobDetails from "../components/JobDetails";
import { updateCandidateTab } from "../features/candidateTab";
import {
  createNotification,
  deleteBulkNotifications,
} from "./NotificationFunctions";
import axiosInstance from "../axiosInstance";
import { updateActiveInterviewedTab } from "../features/activeInterviewedTab";
import { TailSpin } from "react-loader-spinner";
import share_copy from "../images/copy.png";
import share_x from "../images/share_x.png";
import share_fb from "../images/share_fb.png";
import share_linkedin from "../images/share_linkedin.png";
import share_mail from "../images/share_mail.png";
import expandedrow from "../images/expanded row.png";
import collapserow from "../images/collapse row.png";
import {
  EmailIcon,
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import share_whatsapp from "../images/whatsapp icon.svg";
import { IoMdClose } from "react-icons/io";
import { FiPause, FiEdit2 } from "react-icons/fi";
import { IoShareSocialOutline } from "react-icons/io5";
import cheatflag from "../images/cheatflag.png";
import useFetch from "../hooks/useFetch";
import ExportCSV from "./ui/ExportCSV";
import {
  buildCSV,
  buildCSVExpandingRows,
} from "../utils/interviewCredit/jobsUtils";
import { GlobalToggle } from "./drawer/aiAgent/AiAgent";
import OpenJob from "./modal/NewJob/OpenJob";
import RoleBasedAccessControl from "./RoleBasedAccessControl";
import Tooltip from "./ui/Tooltip";

import {
  getCurrencySymbol,
  getPhoneCode,
  formatSalary,
} from "../utils/currencyUtils";
import uuid from "react-uuid";

/** Narrow flexible filter columns: ellipsis selected values without widening the row */
const overviewFilterSelectStyles = {
  container: (base) => ({ ...base, width: "100%", minWidth: 0 }),
  control: (base) => ({ ...base, minHeight: 36 }),
  valueContainer: (base) => ({ ...base, overflow: "hidden", paddingRight: 4 }),
  singleValue: (base) => ({
    ...base,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 10001 }),
};

/** Menus inside `<table>` / overflow ancestors mis-position unless portaled (react-select). */
const selectPortalToBodyProps = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "fixed",
};

const selectPortalStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 10001 }),
};

const TempCandidates = () => {
  const location = useLocation();
  const id = location?.state?.id || "";
  const [job, setJob] = useState(null);
  const dispatch = useDispatch();
  const local_states = JSON.parse(localStorage.getItem("states"));
  // console.log(local_states)
  const [viewJobDetails, setViewJobDetails] = useState(false);
  const cid = useSelector(selectCid);
  const ait = useSelector(selectActiveInterviewedTab);
  const [openDate, setOpenDate] = useState(false);
  const ct = useSelector(selectCandidateTab);
  const sb = useSelector(selectSortedBy);
  const filters = useSelector(selectCandidateFilters);
  const [open, setOpen] = useState();
  const [notifications, setNotifications] = useState([]);
  const [states, setStates] = useState(
    local_states
      ? local_states
      : {
        tab: 0,
        activeInterviewedTab: 0,
      },
  );
  const userPrivilege = useSelector(getUserPrivilege);
  const [tab, setTab] = useState(ct ? ct : 0);
  const [csvData, setCsvData] = useState([]);
  // const [sortBy, setSortBy] = useState("")
  const [allApplicants, setAllApplicants] = useState([]);
  const [inviteModalIsOpen, setInviteModalIsOpen] = useState(false);
  const [maxSalary, setMaxSalary] = useState(0);
  const [roundsMap, setRoundsMap] = useState({});
  const [revokeOfferModal, setRevokeOfferModal] = useState(false);
  const [selectedAiApplicants, setSelectedAiApplicants] = useState([]);
  const [activeInterviewedTab, setActiveInterviewedTab] = useState(ait);
  const [openJoined, setOpenJoined] = useState(false);
  const [openChangeDoj, setOpenChangeDoj] = useState(false);
  const [sortedBy, setSortedBy] = useState("aggregate");
  const [hasManualSort, setHasManualSort] = useState(false);
  const [minSalary, setMinSalary] = useState(0);
  const [acceptanceDate, setAcceptanceDate] = useState("");
  const navigate = useNavigate();
  const [selectedRoundApplicants, setSelectedRoundApplicants] = useState([]);
  const [loader, setLoader] = useState(false);
  const [dateFocused, setDateFocused] = useState(false);
  const [openRoundShiftingModal, setOpenRoundShiftingModal] = useState(false);
  const [previousInterviewDate, setPreviousInterviewDate] = useState("");
  const [interviewer, setInterviewer] = useState();
  const [action, setAction] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [readcsvData, setReadCsvData] = useState([]);
  const [hiringManager, setHiringManager] = useState([]);
  const [statusCounts, setStatusCounts] = useState({
    total: 0,
    "AI Interview": 0,
    Hired: 0,
    Interviewed: 0,
    Offer: 0,
    "On-hold": 0,
    Rejected: 0,
    Selected: 0,
  });
  const [reviewCsvData, setReviewCsvData] = useState(false);
  const [users, setUsers] = useState([]);
  const [openInterviewModal, setOpenInterviewModal] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [activeApplicant, setActiveApplicant] = useState();
  const [roundNo, setRoundNo] = useState("");
  const [stars, setStars] = useState(0);
  const [interviewers, setInterviewers] = useState([]);
  const [maxRo, setMaxRo] = useState(0);
  const [withResumeModal, setWithResumeModal] = useState(false);
  const [onHoldReason, setOnholdReason] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [aiAllChecked, setAiAllChecked] = useState(false);
  const [roundAllChecked, setRoundAllChecked] = useState(false);
  const [openOfferModal, setOpenOfferModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [newDateOfJoining, setNewDateOfJoining] = useState("");
  const [interviewStartTime, setInterviewStartTime] = useState(null);
  const [interviewEndTime, setInterviewEndTime] = useState(null);
  const [additionalInterviewers, setAdditionalInterviewers] = useState([]);
  const [candidateEmail, setCandidateEmail] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [InterviewMedium, setInterviewMedium] = useState("");
  const [startDate, setStartDate] = useState(filters.startDate || "");
  const [endDate, setEndDate] = useState(filters.endDate || "");
  const [openSelectedNodalForInterviewed, setOpenSelectedModalForInterviewed] =
    useState(false);
  const [
    openSelectedNodalForBulkInterviewed,
    setOpenSelectedModalForBulkInterviewed,
  ] = useState(false);
  const [calenderLocation, setCalenderLocation] = useState("");
  const [meetingtitle, setMeetingTitle] = useState("");
  const [calenderDescription, setCalenderDescription] = useState("");
  const [generatingMeetLink, setGeneratingMeetLink] = useState(false);
  const [meetLinkCopied, setMeetLinkCopied] = useState(false);
  const NORTHSTARZ_CID = "232dcc46-0f0d-447a-ba2f-29a37defde19";
  const [interviewerEmails, setInterviewerEmail] = useState("");
  const [companyDetails, setCompanyDetails] = useState({});
  const [calenderCondition, setCalenderCondition] = useState(false);
  const [assignedinterviewDate, setAssignedInterviewDate] = useState("");
  const [calendarEditUUID, setCalendarEditUUID] = useState("");
  const [calendarCreatedAt, setCalendarCreatedAt] = useState("");
  const [isReschedulingInterview, setIsReschedulingInterview] = useState(false);
  const [withResume, setWithResume] = useState(false);
  const [isCsvFlow, setIsCsvFlow] = useState(false);
  const [switchToRound, setSwitchToRound] = useState(false);
  const [d1, setD1] = useState("");
  const [d2, setD2] = useState("");
  const [rem1, setRem1] = useState(0);
  const [twelveHour, setTwelveHour] = useState("");
  const [oneHour, setOneHour] = useState("");
  const [rem2, setRem2] = useState(0);
  const [userIPAddress, setUserIPAddress] = useState("");
  const [date, setDate] = useState("");
  const [companyCountryCode, setCompanyCountryCode] = useState("IN"); // Default
  const [sourceFilter, setSourceFilter] = useState(filters.sourceFilter);
  const [fitmentFilter, setFitmentFilter] = useState(filters.fitmentFilter);
  const [time, setTime] = useState("");
  const [csvUploadApplicantModalOpen, setCsvUploadApplicantModalOpen] =
    useState(false);
  const [csvParsedBulkUp, setCsvParsedBulkUp] = useState([]);
  const [addCandidatesLoader, setAddCandidatesLoader] = useState(false);
  const [selectedCsvData, setSelectedCsvData] = useState([]);
  const [selectCsvAll, setSelectCsvAll] = useState(false);
  const [zipLoader, setZipLoader] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [modalBulkUploadOpen, setModalBulkUploadOpen] = useState(false);
  const [multipleResumeFiles, setMultipleResumeFiles] = useState([]);
  const [parsedLoader, setParsedLoader] = useState(false);
  const [parsedData, setParsedData] = useState([]);
  const [notParsed, setNotParsed] = useState([]);
  const [showCandidates, setShowCandidates] = useState(false);
  const [selectedRows, setSelectdRows] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [csvBulkUpFile, setCsvBulkUpFile] = useState(null);
  const [file, setFile] = useState(null);
  const [switchToReject, setSwitchToReject] = useState(false);
  const [switchToRejectSimple, setSwitchToRejectSimple] = useState(false);
  const [switchToHold, setSwitchToHold] = useState(false);
  const [individualRejectReason, setIndividualRejectReason] = useState(null);
  const [individualRejectFeedback, setIndividualRejectFeedback] = useState("");
  const [openBulkRejectionModal, setOpenBulkRejectionModal] = useState(false);
  const [bulkRejectionData, setBulkRejectionData] = useState([]);
  const [openBulkOnholdModal, setOpenBulkOnholdModal] = useState(false);
  const [bulkOnholdData, setBulkOnholdData] = useState([]);
  const [activeRoundid, setActiveRoundid] = useState("");
  const [previousHiringManger, setPreviousManager] = useState([]);
  const [previousUpdate, setPreviousUpdate] = useState(false);
  const [timeToJoinFilter, setTimeToJoinFilter] = useState(
    filters.timeToJoinFilter,
  );
  const [preferredLocationFilter, setPreferredLocationFilter] = useState(
    filters.preferredLocationFilter || { value: "", label: "--" },
  );
  const [currentStatusFilter, setCurrentStatusFilter] = useState(
    filters.currentStatusFilter || { value: "", label: "--" },
  );
  const [statusOptions, setStatusOptions] = useState([{ value: "", label: "--" }]);
  const [bloodGroup, setBloodGroup] = useState("A+");
  const [acflFeedback, setAcflFeedback] = useState({
    communicationSkills: 0,
    communicationSkillsComment: "",
    personality: 0,
    personalityComment: "",
    teamwork: 0,
    teamworkComment: "",
    attitude: 0,
    attitudeComment: "",
    culturalFitment: 0,
    culturalFitmentComment: "",
    businessUnderstanding: 0,
    businessUnderstandingComment: "",
    alternateJob: "",
    interviewSummary: "",
  });
  const [isFromAFL, setIsFromAFL] = useState(false);
  useEffect(() => {
    if (isFromAFL) {
      const totalScore = Object.keys(acflFeedback)
        .filter(
          (k) =>
            !k.includes("Comment") &&
            k !== "alternateJob" &&
            k !== "interviewSummary",
        )
        .reduce((sum, key) => sum + acflFeedback[key], 0);
      const calculatedStars = (totalScore / 30) * 5;
      setStars(Math.ceil(calculatedStars));
    }
  }, [acflFeedback, isFromAFL]);
  const [totalPages, setTotalPages] = useState(1);
  const [employeeCode, setEmployeeCode] = useState("");
  const [emailNeeded, setEmailNeeded] = useState(null);
  const [visitingCardNeeded, setVisitingCardNeeded] = useState(null);
  const [zipModalIsOpen, setZipModalIsOpen] = useState(false);
  const [zipFile, setZipFile] = useState(null);
  const [inviteDropdownOpen, setInviteDropdownOpen] = useState(false);

  const handleZipSubmit = () => {
    setZipLoader(true);
    const formData = new FormData();
    formData.append("job_id", id);
    formData.append("company_id", cid);
    formData.append("country_code", getPhoneCode(companyCountryCode));
    formData.append("files", zipFile);
    axiosInstance
      .post(`${server_API}/api/v1/sendbulk-resume-upload`, formData)
      .then((response) => {
        toast.success("Zip file uploaded successfully");
        setZipModalIsOpen(false);
        setZipFile(null);
        setZipLoader(false);
      })
      .catch((error) => {
        toast.error("Zip file upload failed");
        setZipLoader(false);
      });
  };

  const handleZipUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.name.toLowerCase().endsWith(".zip")) {
        toast.error("Please upload a .zip file");
        return;
      }
      if (file.size > 25 * 1024 * 1024) {
        toast.error("File size exceeds 25 MB limit");
        return;
      }
      setZipFile(file);
    }
  };

  const [pageDets, setPageDets] = useState({
    page: filters.page,
    page_size: filters.page_size,
  });

  const getPageRange = () => {
    const maxVisiblePages = 3;
    const middlePage = pageDets.page;
    let startPage = middlePage - Math.floor(maxVisiblePages / 2);
    startPage = Math.max(startPage, 1);
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i,
    );
  };

  const [expandingRows, setExpandingRows] = useState(false);
  const [openAcceptedModal, setOpenAcceptedModal] = useState(false);
  const [acceptedFile, setAcceptedFile] = useState(null);
  const [furtherExplaination, setFurtherExplaination] = useState("");
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [AllChecked, setAllChecked] = useState(false);
  const [hackerRankChecked, setHackerRankChecked] = useState(false);
  const [coderbyteChecked, setCoderbyteChecked] = useState(false);
  const [bulkAction, setBulkAction] = useState({});
  const [lastAssessmentInviteProvider, setLastAssessmentInviteProvider] =
    useState("");
  const [skippedCandidates, setSkippedCandidates] = useState([]);
  const [hackerRankLoader, setHackerRankLoader] = useState(false);
  const [rejectionLoader, setRejectionLoader] = useState(false);
  const [selectedHackerRankRows, setSelectdHackerRankRows] = useState([]);
  const [selectedHackerRankAll, setSelectedHackerRankAll] = useState(false);
  const [selectedHired, setSelectedHired] = useState([]);
  const [hiredChecked, setHiredChecked] = useState(false);
  const [mergeCandidatesLoader, setMergeCandidatesLoader] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [link, setLink] = useState("");
  const [openLink, setOpenLink] = useState(false);
  const newRef = useRef(null);
  const shareRef = useRef(null);
  const headers = [
    { label: "Name", key: "name" },
    { label: "Technical Score", key: "technicalscore" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phone" },
    { label: "Interview Status", key: "status" },
    { label: "Resume Score", key: "resumescore" },
    { label: "Soft Skills Score", key: "aiscore" },
    { label: "Voice Analysis Score", key: "voiceanalysisscore" },
    { label: "Aggregate", key: "aggregate" },
    { label: "Applied on", key: "createdat" },
    { label: "First Reminder", key: "firstreminder" },
    { label: "Sent First Reminder", key: "sentfirstreminder" },
    { label: "Final Reminder", key: "finalreminder" },
    { label: "Sent Final Reminder", key: "sentfinalreminder" },
  ];

  const fileInputRef = useRef(null);
  const acceptanceFileInput = useRef(null);

  const statusChecks = [
    "Offer Initiation",
    "Offered",
    "Salary Proposal In-progress",
    "Salary Proposal Pending Approval",
    "Salary Proposal Approved",
    "Offer Letter In-progress",
    "Offer Letter Generated",
    "Offer Letter Pending Approval",
    "Offer Letter Approved",
    "Offer Letter Disapproved",
  ];

  const rejectionOptions = [
    { value: "Found a better job offer", label: "Found a better job offer" },
    {
      value: "⁠Retained by the current employer",
      label: "⁠Retained by the current employer",
    },
    { value: "Do not want to disclose", label: "Do not want to disclose" },
    {
      value: "Candidate did not show up on DOJ",
      label: "Candidate did not show up on DOJ",
    },
    { value: "Negative BGV", label: "Negative BGV" },
    { value: "Others", label: "Others" },
  ];

  const sourceOptions = [
    { value: "", label: "--" },
    { value: "Campus campaign", label: "Campus campaign" },
    { value: "Company website", label: "Company website" },
    { value: "Employees referral", label: "Employees referral" },
    { value: "Naukri", label: "Naukri" },
    { value: "Indeed", label: "Indeed" },
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "Recruitment agency", label: "Recruitment agency" },
    { value: "Northstarz", label: "Northstarz" },
    { value: "Others", label: "Others" },
  ];

  const mediumOption = [
    { label: "Virtual Interview", value: "virtual", icon: "virtual" },
    {
      label: "Google Meet",
      value: "gmeet",
      icon: "gmeet",
    },
    { label: "In-Person", value: "in-person", icon: "inperson" },
  ];

  const fitmentOptions = [
    { value: "", label: "--" },
    { label: "Above Range", value: "ar" },
    { label: "Below Range", value: "br" },
    { label: "Within Range", value: "wr" },
  ];

  const acceptanceAwaitedOptions = [
    { value: "Accepted", label: "Accepted" },
    { value: "Change DOJ", label: "Change DOJ" },
    { value: "Revoke Offer", label: "Revoke Offer" },
    { value: "Joined", label: "Joined" },
  ];

  const acceptedOptions = [
    { value: "Change DOJ", label: "Change DOJ" },
    { value: "Revoke Offer", label: "Revoke Offer" },
    { value: "Joined", label: "Joined" },
  ];

  const timeToJoinOptions = [
    { value: "", label: "--" },
    { label: "<7 Days", value: "7" },
    { label: "7 - 14 Days", value: "14" },
    { label: "15 - 30 Days", value: "30" },
    { label: ">30 Days", value: ">30" },
  ];

  const bulkActionOptions = [
    { value: "Rejected", label: "Reject" },
    { value: "Onhold", label: "On Hold" },
    ...(hackerRankChecked
      ? [{ value: "hackerRankInvite", label: "Trigger HackerRank" }]
      : []),
    ...(coderbyteChecked
      ? [{ value: "coderbyteInvite", label: "Trigger Coderbyte " }]
      : []),
    ...(job?.manual_trigger
      ? [{ value: "triggerAiInterview", label: "Trigger Ai Interview" }]
      : []),
    { value: "switch rounds", label: "Move to Round 1" },
  ];

  const userId = useSelector(selectUuid);

  const parseCSV = (file) => {
    Papa.parse(file, {
      header: true,
      complete: (result) => {
        setReadCsvData(result.data);
      },
      error: (error) => {
        console.error("Error parsing CSV:", error);
      },
    });
  };

  const changeTabUpdateFilters = (updateTab) => {
    updateTab();
    setFitmentFilter({ value: "", label: "--" });
    setTimeToJoinFilter({ value: "", label: "--" });
    setPreferredLocationFilter({ value: "", label: "--" });
    setSourceFilter({ value: "", label: "--" });
    setCurrentStatusFilter({ value: "", label: "--" });
    setStartDate("");
    setEndDate("");
    setSortedBy("");
    setHasManualSort(false);
    setPageDets({
      page: 1,
      page_size: 10,
    });
    updateCandidateFilters({
      ...filters,
      preferredLocationFilter: { value: "", label: "--" },
      currentStatusFilter: { value: "", label: "--" },
      page: 1,
      page_size: 10,
    });
  };

  // Persist filter state to Redux so filters survive navigation to candidate overview and back
  useEffect(() => {
    dispatch(
      updateCandidateFilters({
        ...filters,
        sourceFilter,
        fitmentFilter,
        timeToJoinFilter,
        preferredLocationFilter: preferredLocationFilter || {
          value: "",
          label: "--",
        },
        currentStatusFilter: currentStatusFilter || { value: "", label: "--" },
        startDate,
        endDate,
        page: pageDets.page,
        page_size: pageDets.page_size,
      }),
    );
  }, [
    sourceFilter,
    fitmentFilter,
    timeToJoinFilter,
    preferredLocationFilter,
    currentStatusFilter,
    startDate,
    endDate,
    pageDets.page,
    pageDets.page_size,
  ]);

  // useEffect(() => {
  //   setFitmentFilter({ value: "", label: "--" });
  //   setTimeToJoinFilter({ value: "", label: "--" });
  //   setSourceFilter({ value: "", label: "--" });
  //   setStartDate("");
  //   setEndDate("");
  //   setSortedBy("");
  //   setPageDets({
  //     page: 1,
  //     page_size: 10,
  //   })
  //   updateCandidateFilters({
  //     ...filters,
  //     page: 1,
  //     page_size: 10
  //   })

  //   console.log("checking abcdcd");
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [activeInterviewedTab]);

  // useEffect(() => {
  //   setFitmentFilter({ value: "", label: "--" });
  //   setTimeToJoinFilter({ value: "", label: "--" });
  //   setSourceFilter({ value: "", label: "--" });
  //   setEndDate("");
  //   setStartDate("");
  //   setSortedBy("");
  //   setPageDets({
  //     page: 1,
  //     page_size: 10,
  //   })
  //    updateCandidateFilters({
  //     ...filters,
  //     page: 1,
  //     page_size: 10
  //   })
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [tab]);

  const handleReject = () => {
    setRejectionLoader(true);
    axios
      .patch(`${server_API}/v2/offer/update`, {
        uuid: activeApplicant.offerid,
        status: "Revoked",
        rejectionreason: rejectReason,
        explaination: furtherExplaination,
        companyid: cid,
      })
      .then(() => {
        axios.post(`${server_API}/v2/offer/revoke`, {
          applicantid: activeApplicant.uuid,
          offerid: activeApplicant.offerid,
          companyid: cid,
        });
        setRejectionLoader(false);
      })
      .then(() => {
        axios
          .patch(`${server_API}/v2/applicant/update`, {
            uuid: activeApplicant.uuid,
            companyid: cid,
            status: "Offer Revoked",
          })
          .then((res) => {
            console.log(res);
            setRejectionLoader(false);
            createNotification(
              cid,
              job.assignrecruiter,
              "",
              "Offer letter rejected",
              `${activeApplicant.name} has rejected the offer letter for the job opening of ${activeApplicant.profilename}`,
              "",
            );
            window.location.reload();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
        setRejectionLoader(false);
      });
  };

  useEffect(() => {
    axiosInstance
      .get(`/v2/notification/getall/${cid}`)
      .then((res) => {
        console.log(res);
        setNotifications(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get("https://geolocation-db.com/json/")
      .then((res) => {
        console.log(res);
        setUserIPAddress(
          `${res.data.IPv4} lat:${res.data.latitude} long:${res.data.longitude}`,
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, [cid]);

  const convertToUTC = (date) => {
    if (!date) return "";
    const utcDate = new Date(date);
    return new Date(
      Date.UTC(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate()),
    )
      .toISOString()
      .split("T")[0];
  };

  const handleStartDateChange = (date) => {
    const newStartDate = convertToUTC(date);
    setStartDate(newStartDate);

    if (endDate && newStartDate > endDate) {
      setEndDate("");
    }
  };
  // console.log(startDate)
  // console.log(endDate)

  const handleMultipleUploads = (event) => {
    const file = event.target.files;
    setMultipleResumeFiles(file);
  };

  const handleEndDateChange = (date) => {
    const newEndDate = convertToUTC(date);

    if (!startDate || newEndDate >= startDate) {
      setEndDate(newEndDate);
    }
  };

  const handleJoined = () => {
    if (isFromAFL) {
      axios
        .patch(`${server_API}/v2/applicant/update`, {
          uuid: activeApplicant.uuid,
          companyid: cid,
          status: "Joined",
          actual_joining_date: newDateOfJoining,
          employee_code: employeeCode,
          email_needed: emailNeeded,
          visiting_card_needed: visitingCardNeeded,
          blood_group: bloodGroup,
        })
        .then((res) => {
          if (isFromAFL) {
            axios
              .post(
                `${server_API}/v2/applicant/onboarding/${activeApplicant.uuid}/${cid}`,
              )
              .then((res) => {
                console.log(res);
                window.location.reload();
              })
              .catch((err) => {
                console.log(err);
              });
          } else window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (openDate) {
      navigate("/jobs/candidates/about", {
        state: {
          uuid: activeApplicant.uuid,
          tabState: "offerletterdraft",
          joiningDate: newDateOfJoining,
        },
      });
    } else {
      axios
        .patch(`${server_API}/v2/applicant/update`, {
          uuid: activeApplicant.uuid,
          companyid: cid,
          status: "Joined",
        })
        .then((res) => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const resetPageOnSortChange = () => {
    setPageDets((p) => ({ ...p, page: 1 }));
    updateCandidateFilters({ ...filters, page: 1 });
  };

  const sortBy = (key, array, setArray, onSortChange) => {
    if (sortedBy != key) {
      if (array.length > 0) {
        const arr = [...array].sort((a, b) => {
          return b[key] - a[key];
        });
        setArray(arr);
      }
      setSortedBy(key);
      setHasManualSort(true);
      onSortChange?.();
    } else {
      const app = array.toSorted((a, b) => {
        const d1 = new Date(a.createdat);
        const d2 = new Date(b.createdat);
        return d2 - d1;
      });
      setArray(app);
      setSortedBy("");
      setHasManualSort(false);
      onSortChange?.();
    }
  };

  const sortByNumericString = (key, array, setArray, onSortChange) => {
    if (sortedBy !== key) {
      if (array.length > 0) {
        const arr = [...array].sort((a, b) => {
          const numA = parseFloat(a[key]) || 0;
          const numB = parseFloat(b[key]) || 0;
          return numB - numA; // descending order
        });
        setArray(arr);
      }
      setSortedBy(key);
      setHasManualSort(true);
      onSortChange?.();
    } else {
      // Reset to default sorting by createdat descending
      const app = [...array].sort((a, b) => {
        const d1 = new Date(a.createdat);
        const d2 = new Date(b.createdat);
        return d2 - d1;
      });
      setArray(app);
      setSortedBy("");
      setHasManualSort(false);
      onSortChange?.();
    }
  };

  // Round-aware average for sorting: AI jobs use avg from Round 4+, non-AI from Round 3+
  const getAvgRatingForSort = (a, activeTab, aiEnabled) => {
    const o = a?.interviewrattingsobject || {};
    const startRound = aiEnabled ? 2 : 1;
    const lastRound = activeTab >= 99 ? 99 : activeTab; // Selected = all rounds
    let sum = 0,
      count = 0;
    for (let r = startRound; r <= lastRound; r++) {
      const v = o[String(r)] ?? 0;
      if (v > 0) {
        sum += v;
        count++;
      }
    }
    return count > 0 ? sum / count : 0;
  };

  const sortByAvgRating = (
    array,
    setArray,
    activeTab,
    aiEnabled,
    onSortChange,
  ) => {
    const useRoundAware =
      (aiEnabled && activeTab >= 4) || (!aiEnabled && activeTab >= 3);
    if (sortedBy != "avgRating") {
      if (array.length > 0) {
        const arr = [...array].sort((a, b) => {
          const avgA = useRoundAware
            ? getAvgRatingForSort(a, activeTab, aiEnabled)
            : calculateAvgRating(a?.interviewrattingsobject || {});
          const avgB = useRoundAware
            ? getAvgRatingForSort(b, activeTab, aiEnabled)
            : calculateAvgRating(b?.interviewrattingsobject || {});
          return avgB - avgA;
        });
        setArray(arr);
      }
      setSortedBy("avgRating");
      setHasManualSort(true);
      onSortChange?.();
    } else {
      const app = array.toSorted((a, b) => {
        const d1 = new Date(a.createdat);
        const d2 = new Date(b.createdat);
        return d2 - d1;
      });
      setArray(app);
      setSortedBy("");
      setHasManualSort(false);
      onSortChange?.();
    }
  };

  const applyManualSortOnFetchedData = (arr, key, activeTab, aiEnabled) => {
    if (!arr || arr.length === 0) return arr;
    if (key === "avgRating") {
      const useRoundAware =
        (aiEnabled && activeTab >= 4) || (!aiEnabled && activeTab >= 3);
      return [...arr].sort((a, b) => {
        const avgA = useRoundAware
          ? getAvgRatingForSort(a, activeTab, aiEnabled)
          : calculateAvgRating(a?.interviewrattingsobject || {});
        const avgB = useRoundAware
          ? getAvgRatingForSort(b, activeTab, aiEnabled)
          : calculateAvgRating(b?.interviewrattingsobject || {});
        return avgB - avgA;
      });
    }
    if (["tenthscore", "twelvethscore", "coursefinalscore"].includes(key)) {
      return [...arr].sort((a, b) => {
        const numA = parseFloat(a?.[key]) || 0;
        const numB = parseFloat(b?.[key]) || 0;
        return numB - numA;
      });
    }
    return [...arr].sort((a, b) => (b?.[key] ?? 0) - (a?.[key] ?? 0));
  };

  const todayDate = new Date();

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  useEffect(() => {
    if (rem1 > 0 && rem2 > 0) {
      const reminderDate1 = new Date(
        parseInt(todayDate.getTime()) + parseInt(rem1),
      );
      setD1(
        `${reminderDate1.toLocaleDateString().split("/")[2]
        }-${padWithLeadingZeros(
          reminderDate1.toLocaleDateString().split("/")[0],
          2,
        )}-${padWithLeadingZeros(
          reminderDate1.toLocaleDateString().split("/")[1],
          2,
        )}`,
      );
      console.log(d1);
      const reminderDate2 = new Date(parseInt(rem2) + reminderDate1.getTime());
      //
      setD2(
        `${reminderDate2.toLocaleDateString().split("/")[2]
        }-${padWithLeadingZeros(
          reminderDate2.toLocaleDateString().split("/")[0],
          2,
        )}-${padWithLeadingZeros(
          reminderDate2.toLocaleDateString().split("/")[1],
          2,
        )}`,
      );
    }
  }, [rem1, rem2]);

  const handleCsvDelete = () => {
    setCsvBulkUpFile(null);
  };

  useEffect(() => {
    if (tab != undefined && activeInterviewedTab != undefined) {
      const obj = {
        tab: tab,
        activeInterviewedTab: activeInterviewedTab,
      };
      setStates(obj);
    }
  }, [tab, activeInterviewedTab]);

  const handleBulkCsvApplicant = (event) => {
    const file = event.target.files[0];
    setCsvBulkUpFile(file);
    parseBulkCsv(file);
  };

  const parseBulkCsv = (file) => {
    setIsCsvFlow(true);
    Papa.parse(file, {
      header: true,
      complete: (result) => {
        console.log(result);
        setCsvParsedBulkUp(result.data);
      },
      error: (error) => {
        console.error("Error parsing CSV:", error);
      },
    });
  };

  const bulkAiOptions = async (option) => {
    const promise = selectedAiApplicants.map((s) => {
      return actionOptions(option, s, 0, s.feedback);
    });
    const data = await Promise.all(promise)
      .then((result) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleBulkRejectionSubmit = async () => {
    if (!bulkRejectionData.every((d) => d.reason)) {
      toast.error("Please select a reason for all candidates");
      return;
    }
    setRejectionLoader(true);
    try {
      await Promise.all(
        bulkRejectionData.map((d) =>
          axiosInstance.patch(`/v2/applicant/update`, {
            uuid: d.uuid,
            companyid: cid,
            status: "Rejected",
            rejection_reason: d.reason.value,
            ...(d.feedback ? { feedback: d.feedback } : {}),
            interviewrattingsobject: {},
          }),
        ),
      );
      setOpenBulkRejectionModal(false);
      setBulkRejectionData([]);
      setBulkAction({});
      toast.success("Applicants successfully Rejected");
      window.location.reload();
    } catch (error) {
      console.log(error);
      toast.error("Error rejecting applicants");
      setRejectionLoader(false);
    }
  };

  const handleBulkOnholdSubmit = async () => {
    if (!bulkOnholdData.every((d) => d.reason)) {
      toast.error("Please select a reason for all candidates");
      return;
    }
    setRejectionLoader(true);
    try {
      await axiosInstance.post(`/v2/applicant/bulk/onhold`, {
        companyid: cid,
        applicants: bulkOnholdData.map((d) => ({
          uuid: d.uuid,
          onhold_reason: d.reason.value,
          feedback: d.feedback || "",
        })),
      });
      setOpenBulkOnholdModal(false);
      setBulkOnholdData([]);
      setBulkAction({});
      toast.success("Applicants successfully put On-hold");
      window.location.reload();
    } catch (error) {
      console.log(error);
      toast.error("Error putting applicants on hold");
      setRejectionLoader(false);
    }
  };

  const handleCandidateDelete = () => {
    if (selectedRows.length === 0) {
      toast.error("No candidate selected for deletion.");
      return;
    }

    const updatedParsedData = [...parsedData];
    const updatedResumeData = [...multipleResumeFiles];

    const selectedEmails = new Set(
      selectedRows.map((candidate) => candidate.email),
    );
    const selectedFileName = new Set(
      selectedRows.map((candidate) => candidate.file.name),
    );
    const filteredParsedData = updatedParsedData.filter(
      (candidate) => !selectedEmails.has(candidate.email),
    );
    const filteredResumeData = updatedResumeData.filter(
      (candidate) => !selectedFileName.has(candidate.name),
    );

    setParsedData(filteredParsedData);
    setMultipleResumeFiles(filteredResumeData);
    setSelectdRows([]);
    toast.success("Candidate(s) removed successfully.");
  };

  const resSaveForEmptyResumes = (fname, email, phone, source) => {
    const data = {
      name: fname,
      companyid: job.companyid,
      jobid: job.uuid,
      totalexperience: "",
      qualification: "",
      currentJobtitle: "",
      currentcomany: "",
      currentsalary: "",
      expectedsalary: "",
      skillset: "",
      additionalinfo: "",
      address: ``,
      email: email,
      applieddate: "",
      phone: phone,
      addedby: "",
      coverletter: "",
      resume: "",
      aiscore: 0,
      voiceanalysisscore: 0,
      firstreminder: d1,
      firstreminder: d1,
      finalreminder: d2,
      countrycode: getPhoneCode(companyCountryCode),
      twelvehrwhatsappreminder: "",
      onehrwhatsappreminder: "",
      timebefore15: "",
      interviewdate: "",
      interviewtime: ``,
      heardaboutus: source,
    };
    return axiosInstance
      .post(`/v2/applicant/create`, data)
      .then((res) => {
        return {
          response: res,
          status: "success",
        };
      })
      .catch((err) => {
        toast.error(`Email already registered for ${fname}`);
      });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFile(file);
    parseCSV(file);
  };

  function handleDefault() {
    setFile(null);
    setReadCsvData(null);
  }

  const handleSelectAllCsv = () => {
    if (selectCsvAll) {
      setSelectedCsvData([]);
    } else {
      setSelectedCsvData(readcsvData);
      setSelectCsvAll(true);
    }
    setSelectCsvAll(!selectCsvAll);
  };

  const handleSelectedCsvRow = (id) => {
    if (selectedCsvData.some((row) => row.Email === id.Email)) {
      setSelectedCsvData(
        selectedCsvData.filter((row) => row.Email !== id.Email),
      );
    } else {
      setSelectedCsvData([...selectedCsvData, id]);
    }
  };

  useEffect(() => {
    if (aiAllChecked) {
      setSelectedAiApplicants(allApplicants);
    } else {
      setSelectedAiApplicants([]);
    }
  }, [aiAllChecked, allApplicants]);

  useEffect(() => {
    if (roundAllChecked) {
      setSelectedRoundApplicants(allApplicants);
    } else {
      setSelectedRoundApplicants([]);
    }
  }, [roundAllChecked, allApplicants]);

  useEffect(() => {
    if (hiredChecked) {
      const allUUIDs = allApplicants.map((applicant) => applicant.uuid);
      setSelectedHired(allUUIDs);
    } else {
      setSelectedHired([]);
    }
  }, [hiredChecked, allApplicants]);

  useEffect(() => {
    setSelectedRoundApplicants([]);
    setRoundAllChecked(false);
  }, [activeInterviewedTab, tab]);

  useEffect(() => {
    if (AllChecked) {
      const allUUIDs = allApplicants.map((applicant) => applicant.uuid);
      setSelectedApplicants(allUUIDs);
    } else {
      setSelectedApplicants([]);
    }
  }, [AllChecked, allApplicants]);

  // helper: are all selected applicants in "Pending" status?
  const canPerformManualTrigger = (selectedUUIDs, allApplicants) => {
    return selectedUUIDs.every((uuid) => {
      const app = allApplicants.find((a) => a.uuid === uuid);
      return app?.status === "Applied" || app?.status?.includes("Shortlist");
    });
  };

  const addAiCandidate = (desired_arr_var, desired_arr_state, a) => {
    if (handleAiInterviewCheck(desired_arr_var, a.uuid)) {
      let arr = desired_arr_var.filter((s) => {
        return s.uuid != a.uuid;
      });
      desired_arr_state(arr);
    } else {
      desired_arr_state([...desired_arr_var, a]);
    }
  };

  const handleAiInterviewCheck = (arr = [], uuid) => {
    let obj = {};
    obj = arr.find((s) => {
      return s.uuid == uuid;
    });
    if (obj) {
      return true;
    }
    return false;
  };

  const addCandidate = (desired_arr_var, desired_arr_state, a) => {
    if (handleAllApplicantCheck(desired_arr_var, a)) {
      let arr = desired_arr_var.filter((s) => {
        return s != a;
      });
      desired_arr_state(arr);
    } else {
      desired_arr_state([...desired_arr_var, a]);
    }
  };

  const handleAllApplicantCheck = (arr, uuid) => {
    let obj = {};
    obj = arr.find((s) => {
      return s == uuid;
    });
    if (obj) {
      return true;
    }
    return false;
  };

  const formatDateInIst = (date) => {
    if (date.length == 0) return "--";
    var dateUTC = new Date(date);
    var dateUTC = dateUTC.getTime();
    var dateIST = new Date(dateUTC);
    //date shifting for IST timezone (+5 hours and 30 minutes)
    dateIST.setHours(dateIST.getHours() + 5);
    dateIST.setMinutes(dateIST.getMinutes() + 30);
    var dat = new Date(dateIST);
    const day = String(dat.getUTCDate()).padStart(2, "0");
    const month = String(dat.getUTCMonth() + 1).padStart(2, "0");
    const year = dat.getUTCFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const sendMail = (e) => {
    e.preventDefault();
    setLoader(true);
    axiosInstance
      .post(`/v2/applicant/sendbulk`, {
        JobID: job.uuid,
        CompanyID: cid,
        ApplicantDetails: selectedCsvData,
        UserID: userId,
        countrycode: getPhoneCode(companyCountryCode),
      })
      .then((response) => {
        if (response.status == 200) {
          toast.success("Successfully upload");
          setLoader(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        toast.error("Headers or data are not in correct format");
        setLoader(false);
        console.log(error);
      });
  };

  const handleDrop = (e) => {
    e.preventDefault();

    const droppedFile = e.dataTransfer.files[0];
    setFile(droppedFile);
    parseCSV(droppedFile);
  };

  const resSave = async (
    resume,
    fname,
    pnum,
    exp,
    email,
    skills,
    qual,
    source,
  ) => {
    const data = new FormData();
    data.append("name", fname);
    data.append("companyid", cid);
    data.append("totalexperience", exp);
    data.append("jobid", job.uuid);
    data.append("highestqualification", qual);
    data.append("currentJobtitle", "");
    data.append("currentcomany", "");
    data.append("currentsalary", "");
    data.append("expectedsalary", "");
    data.append("skillset", skills.toString());
    data.append("additionalinfo", "");
    data.append("address", ``);
    data.append("email", email);
    data.append("educationaldetails", "");
    data.append("applieddate", "");
    data.append("phone", pnum);
    data.append("jd", job.normaltext);
    data.append("file", resume);
    data.append("department", job.department);
    data.append("aiscore", 0);
    data.append("voiceanalysisscore", 0);
    data.append("firstreminder", d1);
    data.append("heardaboutus", source);
    data.append("finalreminder", d2);
    data.append("countrycode", getPhoneCode(companyCountryCode));
    data.append("twelvehrwhatsappreminder", twelveHour);
    data.append("onehrwhatsappreminder", oneHour);
    data.append("interviewdate", date);
    data.append("interviewtime", `${time}:00`);
    data.append("addApplicant", 1);
    return axiosInstance.post(`/v2/applicant/createnew`, data);
  };

  const hearoptions = [
    { value: "Campus campaign", label: "Campus campaign" },
    { value: "Company website", label: "Company website" },
    { value: "Employees referral", label: "Employees referral" },
    { value: "Naukri", label: "Naukri" },
    { value: "Indeed", label: "Indeed" },
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "Recruitment agency", label: "Recruitment agency" },
    { value: "Northstarz", label: "Northstarz" },
    { value: "Others", label: "Others" },
  ];

  const handleSelectedRow = (id) => {
    console.log(id);
    if (selectedRows.some((row) => row.email === id.email)) {
      setSelectdRows(selectedRows.filter((row) => row.email !== id.email));
    } else {
      // const select = selectedRows;
      setSelectdRows([...selectedRows, id]);
    }
    console.log(selectedRows);
  };

  const handleSelectedHackerRankRow = (id) => {
    console.log(id);
    if (selectedHackerRankRows.some((row) => row.email === id.email)) {
      setSelectdHackerRankRows(
        selectedHackerRankRows.filter((row) => row.email !== id.email),
      );
    } else {
      // const select = selectedRows;
      setSelectdHackerRankRows([...selectedHackerRankRows, id]);
    }
    console.log(selectedHackerRankRows);
  };

  const handleSelectedAll = () => {
    setSelectdRows(parsedData);
    setSelectedAll(true);
  };

  const handleSelectedHackerRankAll = () => {
    setSelectdHackerRankRows(skippedCandidates);
    setSelectedHackerRankAll(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAddCandidatesLoader(true);
    const promise = selectedRows.map((res) => {
      return resSave(
        res.file,
        res.name,
        res.pnum,
        res.experience,
        res.email,
        res.skills,
        res.qualification,
        res.source,
      );
    });
    const data = await Promise.all(promise)
      .then((result) => {
        console.log("Promise is completed", result);
        setConfirmationModal(true);
        setAddCandidatesLoader(false);
        toast.success("Bulk Save Complete");
        setShowCandidates(false);
        setModalBulkUploadOpen(false);
      })
      .catch((error) => {
        setAddCandidatesLoader(false);
        console.log(error);
      });
  };

  const handleCheckbox = () => {
    if (selectedAll) {
      setSelectdRows([]);
    } else {
      handleSelectedAll();
    }
    setSelectedAll(!selectedAll);
  };

  const handleHackerRankCheckbox = () => {
    if (selectedHackerRankAll) {
      setSelectdHackerRankRows([]);
    } else {
      handleSelectedHackerRankAll();
    }
    setSelectedHackerRankAll(!selectedHackerRankAll);
  };

  const mergeHackerRankResult = () => {
    setMergeCandidatesLoader(true);
    axiosInstance
      .patch(`${server_API}/v2/applicant/mergehackercandidate`, {
        skippedcandidates: selectedHackerRankRows,
        companyid: cid,
        testid: job?.coderbyte_enabled ? job.coderbyte_test_id : job.hackerrank_test_id,
        jobid: job.uuid,
      })
      .then((response) => {
        setSkippedCandidates([]);
        setHackerRankLoader(false);
        toast.success("Merging the candidate data successfully");
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleBulkSubmit = async (e) => {
    e.preventDefault();
    setAddCandidatesLoader(true);
    const promise = selectedRows.map((res) => {
      return resSaveForEmptyResumes(res.name, res.email, res.pnum, res.source);
    });
    const data = Promise.all(promise).then((result) => {
      console.log("res", result);
      if (result.length > 0) {
        setShowCandidates(false);
        setAddCandidatesLoader(false);
        toast.success("Bulk Save Complete");
        window.location.reload();
      }
    });
  };

  useEffect(() => {
    if (csvParsedBulkUp.length > 0) {
      csvParsedBulkUp.map((c) => {
        c["name"] = c["Name"];
        delete c["Name"];
        c["email"] = c["Email"];
        delete c["Email"];
        c["pnum"] = c["Phone"];
        delete c["Phone"];
        c["file"] = null;
        c["experience"] = "";
        c["skills"] = "";
        c["qualification"] = "";
        return c;
      });
      setParsedData(csvParsedBulkUp);
    }
  }, [csvParsedBulkUp]);

  console.log(selectedAiApplicants);

  useEffect(() => {
    if (
      multipleResumeFiles.length > 0 &&
      parsedData.length > 0 &&
      multipleResumeFiles.length == parsedData.length
    ) {
      setParsedLoader(false);
      setShowCandidates(true);
      setModalBulkUploadOpen(false);
    }
  }, [multipleResumeFiles, parsedData]);
  function formatUTCDate(dateStr) {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
  }

  const summary = async (resume) => {
    var single = {};
    var formdata = new FormData();
    formdata.append("file", resume);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    await fetch(`${server_API}/v2/applicant/resume/summary`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        single["file"] = resume;
        if (result.success.Name) {
          single["name"] = result.success.Name;
        } else {
          single["name"] = "";
        }
        if (result.success.Email) {
          single["email"] = result.success.Email;
        } else {
          single["email"] = "";
        }
        if (result.success["Phone Number"]) {
          var phone = result.success["Phone Number"];
          phone = phone.replaceAll("-", "");
          phone = phone.replaceAll(getPhoneCode(companyCountryCode), "");
          if (phone.startsWith("0")) {
            phone = phone.substring(1);
          }
          single["pnum"] = phone;
        } else {
          single["pnum"] = "";
        }
        if (result.success["Total Experience"]) {
          single["experience"] = result.success["Total Experience"];
        } else {
          single["experience"] = "";
        }
        if (result.success.Skills) {
          single["skills"] = result.success.Skills;
        } else {
          single["skills"] = "";
        }
        if (result.success["Highest Qualification"]) {
          single["qualification"] = result.success["Highest Qualification"];
        } else {
          single["qualification"] = "";
        }
        setParsedData((oldArray) => [...oldArray, single]);
      })
      .catch((error) => {
        console.log("error", error);
        setParsedData((oldArray) => [
          ...oldArray,
          {
            file: resume,
            source: "",
            name: "",
            email: "",
            pnum: "",
            experience: "",
            skills: [],
            qualification: "",
          },
        ]);
        setNotParsed((oldArray) => [...oldArray, resume.name]);
      });
  };

  const bulkParse = (e) => {
    e.preventDefault();
    setParsedLoader(true);
    Array.from(multipleResumeFiles).map((f) => {
      summary(f);
    });
  };

  // Prevent default behavior for drag events
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Prevent default behavior for drag enter events
  const handleDragEnter = (e) => {
    e.preventDefault();
  };

  const handleMultipleResumeUpload = (event) => {
    const file = event.target.files[0];
    setAcceptedFile(file);
  };

  const handleAdditionalMultipleResumeUpload = (event) => {
    const files = event.target.files;

    setMultipleResumeFiles((multiple) => {
      if (multiple.length + files.length > 10) {
        toast.error("Add up to 10 resumes.");
        return multiple;
      } else {
        return [...multiple, ...files];
      }
    });
  };

  const Tempheaders = [
    { label: "Name", key: "Name" },
    { label: "Phone", key: "Phone" },
    { label: "Email", key: "Email" },
  ];

  const TempData = [
    { Name: "John Doe", Phone: "+1234567890", Email: "johndoe@gmail.com" },
    { Name: "Jane Smith", Phone: "+1987654321", Email: "janesmith@gmail.com" },
    {
      Name: "Alice Johnson",
      Phone: "+1122334455",
      Email: "alicejohnson@gmail.com",
    },
    // Add more data as needed
  ];

  const aiCallingHeaders = [
    { label: "fullname", key: "fullname" },
    { label: "email", key: "email" },
    { label: "phone", key: "phone" },
  ];

  const aiCallingData = [
    { fullname: "Ayan Pandey", email: "EMAIL_ADDRESS", phone: "9999999999" },
    { fullname: "Vandit Kala", email: "EMAIL_ADDRESS", phone: "9999999999" },
  ];

  // const handleCsvDelete = ()=>{
  //   setCsvBulkUpFile(null)
  // }

  // function handleDefault (){
  //   setFile(null);
  //   setReadCsvData(null);
  // }
  // const handleDrop = (e) => {
  //   e.preventDefault();

  //   const droppedFile = e.dataTransfer.files[0];
  //   setFile(droppedFile);
  //  parseCSV(droppedFile);
  // };

  const previousRoundUpdate = () => {
    axiosInstance
      .patch(`v2/applicant/update/round`, {
        uuid: activeApplicant.uuid,
        companyid: cid,
        roundid: activeRoundid,
        assigneedate: previousInterviewDate,
        functionalmanagername: hiringManager.label,
        fmid: hiringManager.value,
      })
      .then((response) => {
        console.log(response);
        setPreviousUpdate(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const actionOptions = (
    option,
    applicant,
    stars,
    feedback,
    hiringManager,
    rejectionReason,
    noReload = false
  ) => {
    // setAction(option.value);
    let applicantstatus = applicant.status;
    let updateRound = false;
    let value = option;
    let roundfrom = "";
    let roundto = "";
    let stat = "";
    let prevStars = structuredClone(applicant.interviewrattingsobject);
    if (
      applicantstatus.includes("Pending") ||
      applicantstatus === "AI Interview" ||
      applicantstatus.includes("Shortlist")
    ) {
      updateRound = true;
      if (value == "switch rounds") {
        roundfrom = 1;
        roundto = 2;
        stat = "Interviewed R2";
      } else if (value == "select") {
        roundfrom = 1;
        roundto = "selected";
        stat = "Selected";
      } else if (value == "reject") {
        roundfrom = 1;
        roundto = "reject";
        stat = "Rejected";
      } else if (value == "hold") {
        roundfrom = 1;
        roundto = "onhold";
        stat = "Onhold";
      }
    }
    if (applicantstatus.includes("Interviewed")) {
      updateRound = true;

      console.log(updateRound);
      // This was done because the The error came
      //  from parsing the applicant status when it was
      // exactly "Interviewed" (no round number).
      const getRoundFromStatus = () => {
        if (applicantstatus === "Interviewed") return 1;
        const parts = applicantstatus?.split(" ");
        const roundPart = parts?.[1];
        if (!roundPart) return 1;
        const num = parseInt(roundPart.replace(/^R/i, ""), 10);
        return isNaN(num) ? 1 : num;
      };
      if (value == "switch rounds") {
        if (applicantstatus == "Interviewed") {
          roundfrom = 1;
          roundto = 2;
          stat = "Interviewed R2";
        } else {
          let round = getRoundFromStatus();
          roundfrom = round;
          round = round + 1;
          roundto = round;
          stat = "Interviewed R" + round;
        }
      } else if (value == "select") {
        let round = getRoundFromStatus();
        roundfrom = round;
        round = round + 1;
        roundto = "select";
        stat = "Selected";
      } else if (value == "reject") {
        let round = "";
        if (applicantstatus == "Interviewed") {
          round = "AI Interview";
        } else {
          round = getRoundFromStatus();
        }
        roundfrom = round;
        roundto = "reject";
        stat = "Rejected";
      } else if (value == "hold") {
        let round = "";
        if (applicantstatus == "Interviewed") {
          round = "AI Interview";
        } else {
          round = getRoundFromStatus();
        }
        roundfrom = round;
        roundto = "onhold";
        stat = "Onhold";
      }
      prevStars[roundfrom.toString()] = stars;
    } else if (applicantstatus.includes("Onhold")) {
      if (value == "switch rounds") {
        updateRound = true;
        let round = applicant.roundsinfo.length + 2;
        roundfrom = "Onhold";
        roundto = round;
        stat = "Interviewed R" + round;
      } else if (value == "reject") {
        stat = "Rejected";
      } else if (value == "select") {
        stat = "Selected";
      }
    } else if (applicantstatus.includes("Selected")) {
      if (value == "offer") {
        stat = "Offer Initiation";
      } else if (value == "reject") {
        stat = "Rejected";
      } else if (value == "hold") {
        stat = "Onhold";
      }
    } else if (applicantstatus.includes("Rejected")) {
      console.log("entered");
      if (value == "switch rounds") {
        updateRound = true;
        let round = applicant.roundsinfo.length + 2;
        roundfrom = "Rejected";
        roundto = round;
        stat = "Interviewed R" + round;
      } else if (value == "select") {
        stat = "Selected";
      } else if (value == "hold") {
        stat = "Onhold";
      }
    } else if (statusChecks.includes(applicantstatus)) {
      if (value == "reject") {
        stat = "Rejected";
      } else if (value == "hold") {
        stat = "Onhold";
      }
    } else if (
      applicant.status == "Pending" ||
      applicant.status == "Applied" ||
      applicant.status.includes("Shortlist")
    ) {
      if (value == "reject") {
        stat = "Rejected";
      } else if (value == "hold") {
        stat = "Onhold";
      }
    }

    if (applicant.status.includes("Interviewed")) {
      removeNotification(applicant ? applicant : activeApplicant, roundto - 1);
    }

    return axios
      .patch(`${server_API}/v2/applicant/update`, {
        uuid: applicant.uuid,
        companyid: cid,
        status: stat,
        interviewrattingsobject: prevStars,
        ...(stat === "Onhold"
          ? rejectionReason
            ? { onhold_reason: rejectionReason }
            : {}
          : rejectionReason
            ? { rejection_reason: rejectionReason }
            : {}),
      })
      .then((response) => {
        if (value == "reject") {
          createNotification(
            cid,
            userId,
            "",
            `${applicant?.name || activeApplicant?.name} has been rejected successfully`,
            `Candidate has been successfully rejected for ${job.profilename} of department - ${job.department}. Rejection mail also sent.`,
            JSON.stringify({ id: applicant.uuid }),
          );
        } else if (value == "hold") {
          createNotification(
            cid,
            userId,
            "",
            `${activeApplicant.name} put on-hold successfully`,
            `Candidate has been successfully put on-hold for ${job.profilename} role. Review the application for details.`,
            JSON.stringify({ id: applicant.uuid }),
          );
        } else if (value == "switch rounds") {
          createNotification(
            cid,
            userId,
            "",
            `${applicant ? applicant.name : activeApplicant.name
            } has been successfully moved to Round ${roundto} of the interview`,
            `${applicant ? applicant.name : activeApplicant.name
            } has been successfully moved to Round ${roundto} for ${job.profilename
            } role.`,
            JSON.stringify({ id: applicant.uuid }),
          );
          if (interviewer) {
            createNotification(
              cid,
              interviewer.value,
              "Interview",
              `${applicant ? applicant.name : activeApplicant.name
              } has been successfully moved to Round ${roundto} of the interview`,
              `You are asssigned as an interviewer for the next round of interview of ${applicant ? applicant.name : activeApplicant.name
              } .`,
              JSON.stringify({ id: applicant.uuid }),
            );
          }
        } else if (value == "select") {
          createNotification(
            cid,
            userId,
            "",
            `${activeApplicant.name} has been successfully selected`,
            `${activeApplicant.name} has been successfully selected for ${job.profilename} of department - ${job.department}.`,
            JSON.stringify({ id: applicant.uuid }),
          );
        }
        if (updateRound) {
          let curr = false;
          if (previousUpdate) {
            //previousRoundUpdate();
            curr = true;
          }
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Cookie", "Cookie_1=value");
          let finalAssignedDate = "";

          if (assignedinterviewDate) {
            finalAssignedDate = getLocalDateString(assignedinterviewDate);
          }

          const roundInfo =
            activeApplicant.roundsinfo?.filter((round) => round.star !== "") ||
            [];

          const lastRound =
            Array.isArray(roundInfo) && roundInfo.length > 0
              ? roundInfo[roundInfo.length - 1]
              : {};

          const fnm =
            lastRound?.assignedInterviewerName ||
            interviewer?.label ||
            lastRound?.functionalmanagername ||
            "";
          const fmid =
            lastRound?.assignedInterviewerUuid ||
            interviewer?.value ||
            lastRound?.fmid ||
            "";

          let roundinfo = {
            functionalmanagername: fnm,
            fmid: fmid,
            star: stars,
            assigneetime: "",
            assigneedate: finalAssignedDate,
            roundfrom: roundfrom?.toString() || "",
            roundto: roundto?.toString() || "",
            assignedInterviewerName:
              (curr ? hiringManager?.label : interviewer?.label) || "",
            assignedInterviewerUuid:
              (curr ? hiringManager?.value : interviewer?.value) || "",
          };

          if (isFromAFL) {
            roundinfo = { ...roundinfo, ...feedback };
          } else {
            roundinfo = { ...roundinfo, feedback: feedback };
          }

          const raw = JSON.stringify({
            applicantid: applicant.uuid,
            roundsinfo: roundinfo,
            companyid: cid,
          });

          const requestOptions = {
            method: "PATCH",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(`${server_API}/v2/applicant/update/roundinfo`, requestOptions)
            .then((response) => console.log(response.json()))
            .then((result) => {
              if (!noReload) window.location.reload();
            })
            .catch((error) => console.error(error));
        } else {
          if (!noReload) window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
        if (!noReload) window.location.reload();
      });
  };

  const handleWithoutAiRound1Switch = async (applicant, noReload = false) => {
    axios
      .patch(`${server_API}/v2/applicant/update/roundinfo`, {
        applicantid: applicant.uuid,
        roundsinfo: {},
        companyid: cid,
      })
      .then(
        async () =>
          await axios.patch(`${server_API}/v2/applicant/update`, {
            uuid: applicant.uuid,
            companyid: cid,
            status: "Interviewed R1",
          }),
      )
      .then(() => {
        createNotification(
          cid,
          userId,
          "",
          `${applicant ? applicant.name : activeApplicant.name
          } has been successfully moved to Round 1 of the interview`,
          `${applicant ? applicant.name : activeApplicant.name
          } has been successfully moved to Round 1 for ${job.profilename
          } role.`,
          JSON.stringify({ id: applicant.uuid }),
        );
      })
      .then(() => {
        if (!noReload) window.location.reload();
        else return;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (roundsMap[activeInterviewedTab]?.length > 0) {
      roundsMap[activeInterviewedTab].map((a) => {
        if (a.roundsinfo.length > 0) {
          const option = {
            value: a.roundsinfo[a.roundsinfo.length - 1].fmid,
            label: a.roundsinfo[a.roundsinfo.length - 1].functionalmanagername,
          };
          setInterviewers({ ...interviewers, [a.uuid]: option });
        }
      });
    }
    setSelectedRoundApplicants([]);
  }, [activeInterviewedTab, roundsMap]);

  const shouldModalOpen = (option, applicant) => {
    if (option.value == "switch rounds" && applicant.status == "Interviewed") {
      setSwitchToRound(true);
      setAction(option.value);
      setActiveApplicant(applicant);
      // actionOptions(option.value, applicant, 0, "")
    } else if (
      option.value == "switch rounds" &&
      (applicant.status === "Applied" || applicant.status.includes("Shortlist"))
    ) {
      handleWithoutAiRound1Switch(applicant);
    } else if (
      option.value == "reject" &&
      (applicant.status == "Pending" ||
        applicant.status == "Applied" ||
        applicant.status.includes("Shortlist"))
    ) {
      if (companyDetails?.from_acfl) {
        setSwitchToReject(true);
        setAction(option.value);
        setActiveApplicant(applicant);
        setIndividualRejectReason(null);
        setIndividualRejectFeedback("");
      } else {
        setSwitchToRejectSimple(true);
        setAction(option.value);
        setActiveApplicant(applicant);
      }
    } else if (option.value == "select" && applicant.status == "Interviewed") {
      setOpenSelectedModalForInterviewed(true);
      setAction(option.value);
      setActiveApplicant(applicant);
    } else if (
      option.value == "hold" &&
      (applicant.status == "Pending" ||
        applicant.status == "Applied" ||
        applicant.status.includes("Shortlist"))
    ) {
      setSwitchToHold(true);
      setAction(option.value);
      setActiveApplicant(applicant);
    } else if (option.value == "offer") {
      setAction(option.value);
      setActiveApplicant(applicant);
      setOpenOfferModal(true);
      // actionOptions(option.value, applicant, 0, "")
    } else if (option.value == "Accepted") {
      setAction(option.value);
      setActiveApplicant(applicant);
      setOpenAcceptedModal(true);
    } else if (option.value == "Change DOJ") {
      setAction(option.value);
      setActiveApplicant(applicant);
      setOpenChangeDoj(true);
    } else if (option.value == "Joined") {
      setAction(option.value);
      setActiveApplicant(applicant);
      setOpenJoined(true);
    } else if (option.value == "Revoke Offer") {
      setRevokeOfferModal(true);
      setActiveApplicant(applicant);
    } else if (option.value == "reject" && applicant.status == "Interviewed") {
      actionOptions(option.value, applicant, 0, "");
    } else if (option.value == "hold" && applicant.status == "Interviewed") {
      actionOptions(option.value, applicant, 0, "");
    } else if (option.value == "hackerRankInvite" || option.value == "coderbyteInvite") {
      setBulkAction(option);
      setSelectedApplicants([applicant.uuid]);
    } else if (option.value == "triggerAiInterview") {
      setBulkAction(option);
      setSelectedApplicants([applicant.uuid]);
    } else {
      setAction(option.value);
      setActiveApplicant(applicant);
      setOpenInterviewModal(true);
    }
  };

  const activeRound = () => {
    const status = activeApplicant.status;
    let round = "";

    if (status.includes("Interviewed")) {
      if (status == "Interviewed") {
        round = 2;
      } else {
        const roundPart = status?.split(" ")?.[1];
        const num = roundPart ? parseInt(roundPart.replace(/^R/i, ""), 10) : 1;
        round = (isNaN(num) ? 1 : num) + 1;
      }
      return round;
    }
    if (status.includes("Pending")) {
      return 2;
    }
    if (status.includes("Onhold")) {
      return activeApplicant.roundsinfo.length + 2;
    }
    if (status.includes("Rejected")) {
      return activeApplicant.roundsinfo.length + 2;
    }
  };

  // useEffect(()=>{
  //   console.log(sortedAllApplicants)
  // },[sortedAllApplicants])

  const hasAssessmentValue = (value) => {
    if (typeof value === "string") return value.trim() !== "";
    return Boolean(value);
  };

  const isAssessmentEnabled = (value) => value === true;

  const shouldShowCoderbyteTrigger = (candidate) => {
    if (!coderbyteChecked) return false;
    if (!candidate) return true;
    return (
      !isAssessmentEnabled(candidate.coderbyte_enabled) &&
      !hasAssessmentValue(candidate.coderbyte_candidate_id) &&
      !hasAssessmentValue(candidate.coderbyte_test_status)
    );
  };

  const shouldShowHackerRankTrigger = (candidate) => {
    if (!hackerRankChecked) return false;
    if (!candidate) return true;
    return (
      !isAssessmentEnabled(candidate.hackerrank_enabled) &&
      !hasAssessmentValue(candidate.hackerrank_candidate_id) &&
      !hasAssessmentValue(candidate.hackerrankid) &&
      !hasAssessmentValue(candidate.hackerrank_test_status)
    );
  };

  const assessmentTriggerOptions = (candidate) => [
    ...(shouldShowHackerRankTrigger(candidate)
      ? [{ value: "hackerRankInvite", label: "Trigger HackerRank" }]
      : []),
    ...(shouldShowCoderbyteTrigger(candidate)
      ? [{ value: "coderbyteInvite", label: "Trigger Coderbyte" }]
      : []),
  ];

  const interviewedOptions = (status, isAi = false, candidate = null) => {
    let round = "";
    if (status == "Interviewed") {
      isAi ? (round = 1) : (round = 2);
    } else {
      round = parseInt(status.split(" ")?.at(1)?.at(1) ?? "");
      round = round + 1;
    }
    const options = [
      { value: "switch rounds", label: `Move to round ${round}` },
      { value: "select", label: `Select` },
      { value: "reject", label: `Reject` },
      { value: "hold", label: `On hold` },
    ];

    options.unshift(...assessmentTriggerOptions(candidate));

    return options;
  };
  const onHoldOptions = (roundsInfo, candidate = null) => {
    let round = roundsInfo?.length + 1;

    const options = [
      { value: "switch rounds", label: `Move to round ${round}` },
      { value: "select", label: `Select` },
      { value: "reject", label: `Reject` },
    ];

    options.unshift(...assessmentTriggerOptions(candidate));

    return options;
  };

  const selectedOptions = (candidate = null) => {
    let options = [
      { value: "offer", label: `Move to offer` },
      { value: "reject", label: `Reject` },
      { value: "hold", label: `On hold` },
    ];

    options.unshift(...assessmentTriggerOptions(candidate));

    if (userPrivilege === "Hiring Manager") {
      options = options.filter((opt) => opt.value !== "offer");
    }

    return options;
  };

  const RejectedReasonOptions = [
    {
      value: "Lacks required skills & experience",
      label: `Lacks required skills & experience`,
    },
    {
      value: "Lacks cultural and/or team fitment",
      label: `Lacks cultural and/or team fitment`,
    },
    {
      value: "Position filled internally",
      label: `Position filled internally`,
    },
    { value: "Application withdrawn", label: `Application withdrawn` },
    {
      value: "Mismatch in salary expectation",
      label: `Mismatch in salary expectation`,
    },
    { value: "Others", label: "Others" },
  ];
  const OnholdReasonOptions = [
    {
      value: "Position filled internally",
      label: `Position filled internally`,
    },
    { value: "Better candidate found", label: `Better candidate found` },
    { value: "Position / Job on hold", label: `Position / Job on hold` },
    { value: "Not a perfect fit (yet)", label: `Not a perfect fit (yet)` },
    { value: "Others", label: "Others" },
  ];

  const rejectedOptions = (roundsInfo) => {
    let round = roundsInfo?.length + 1;
    return [
      { value: "switch rounds", label: `Move to round ${round}` },
      { value: "select", label: `Select` },
      { value: "hold", label: `On-hold` },
    ];
  };

  const offeredOptions = () => {
    const options = [
      { value: "reject", label: `Reject` },
      { value: "hold", label: `On-hold` },
    ];
    return options;
  };

  const aiInterviewOfferedOptions = (candidate = null) => {
    const options = [
      { value: "reject", label: `Reject` },
      { value: "hold", label: `On-hold` },
    ];

    options.unshift(...assessmentTriggerOptions(candidate));
    return options;
  };

  const appliedOptions = (candidate = null) => {
    const options = [
      { value: "reject", label: `Reject` },
      { value: "hold", label: `On-hold` },
      { value: "switch rounds", label: `Move to R1` },
    ];

    options.push(...assessmentTriggerOptions(candidate));

    if (job?.aiinterviewenabled) {
      options.push({
        value: "triggerAiInterview",
        label: "Trigger Ai Interview",
      });
    }
    return options;
  };

  const allAplicantTabOptions = (status, roundInfo, candidate = null) => {
    if (status.includes("Interviewed")) return interviewedOptions(status, false, candidate);
    if (status.includes("Onhold")) return onHoldOptions(roundInfo, candidate);
    if (status.includes("Selected")) return selectedOptions(candidate);
    if (status == "Rejected")
      return !companyDetails?.from_acfl ? rejectedOptions(roundInfo) : [];
    if (status.includes("Acceptance Awaited")) return acceptanceAwaitedOptions;
    if (statusChecks.includes(status)) return offeredOptions();
    if (status.includes("Accepted")) return acceptedOptions;
    if (status.includes("Pending")) {
      if (job.aiinterviewenabled) return aiInterviewOfferedOptions(candidate);
      else return interviewedOptions(status, false, candidate);
    }
    if (status.includes("Applied") || status.includes("Shortlist"))
      return appliedOptions(candidate);
    if (status.includes("Incomplete")) return rejectedOptions(roundInfo);
    else return [];
  };

  const removeNotification = (applicant, roundto) => {
    const ids = notifications.filter((n) => {
      if (
        (n.notificationtype == "Interview" &&
          n.notificationtitle ==
          `${applicant.name} has been successfully moved to Round ${roundto} of the interview`,
          `You are asssigned as an interviewer for the next round of interview of ${applicant ? applicant.name : activeApplicant.name
          } .`)
      ) {
      }
      return n;
    });

    const uuids = ids.map((i) => {
      return i.uuid;
    });

    deleteBulkNotifications(uuids, cid);
  };

  useEffect(() => {
    if (
      (bulkAction.value == "hackerRankInvite" ||
        bulkAction.value == "coderbyteInvite") &&
      selectedApplicants.length > 0
    ) {
      const isCoderbyteInvite = bulkAction.value == "coderbyteInvite";
      const inviteProvider = isCoderbyteInvite ? "coderbyte" : "hackerrank";
      setLastAssessmentInviteProvider(inviteProvider);
      setHackerRankLoader(true);
      const inviteEndpoint = isCoderbyteInvite
        ? "sendCoderbyteInvite"
        : "sendHackerrankInvite";
      axiosInstance
        .post(`${server_API}/v2/applicant/${inviteEndpoint}`, {
          uuids: selectedApplicants,
          companyid: cid,
          jobid: job.uuid,
        })
        .then((response) => {
          setSkippedCandidates(
            (response.data.skippedCandidates || []).map((candidate) => ({
              ...candidate,
              provider: candidate.provider || inviteProvider,
            })),
          );
          setHackerRankLoader(false);
          toast.success(
            isCoderbyteInvite
              ? "Invite for Coderbyte successfully sent"
              : "Invite for HackerRank successfully sent",
          );
          setBulkAction({});
        })
        .catch((error) => {
          setHackerRankLoader(false);
          const inviteErrorMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            (isCoderbyteInvite
              ? "Invite for Coderbyte failed"
              : "Invite for HackerRank failed");
          toast.error(
            isCoderbyteInvite
              ? `Invite for Coderbyte failed: ${inviteErrorMessage}`
              : inviteErrorMessage,
          );
          console.log(error);
        });
    } else if (
      bulkAction.value == "Rejected" &&
      selectedApplicants.length > 0
    ) {
      const data = selectedApplicants.map((uuid) => {
        const applicant = allApplicants.find((a) => a.uuid === uuid);
        return {
          uuid,
          name: applicant?.name || uuid,
          reason: null,
          feedback: "",
        };
      });
      setBulkRejectionData(data);
      setOpenBulkRejectionModal(true);
    } else if (bulkAction.value == "Onhold" && selectedApplicants.length > 0) {
      const data = allApplicants
        .filter((a) => selectedApplicants.includes(a.uuid))
        .map((a) => ({
          uuid: a.uuid,
          name: a.name,
          reason: null,
          feedback: "",
        }));
      setBulkOnholdData(data);
      setOpenBulkOnholdModal(true);
    } else if (
      bulkAction.value == "triggerAiInterview" &&
      selectedApplicants.length > 0
    ) {
      if (!canPerformManualTrigger(selectedApplicants, allApplicants)) {
        toast.error(
          "Ai trigger can only be trigger to applicants are in Applied status.",
        );
        return;
      }
      axiosInstance
        .post(`${server_API}/v2/applicant/manual/trigger`, {
          applicant_ids: selectedApplicants,
          companyid: cid,
          jobid: job.uuid,
        })
        .then((response) => {
          setHackerRankLoader(false);
          toast.success("Ai Interview Triggered Successfully");
          setBulkAction({});
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (
      bulkAction.value == "switch rounds" &&
      selectedApplicants.length > 0
    ) {
      if (!canPerformManualTrigger(selectedApplicants, allApplicants)) {
        toast.error(
          "Only Candidates in Applied status can be moved to next round.",
        );
        return;
      }
      selectedApplicants.map((applicant) => {
        handleWithoutAiRound1Switch({ uuid: applicant });
      });
      window.location.reload();
    }
  }, [bulkAction]);

  const showReport = (uuid, provider) => {
    const reportProvider = provider || lastAssessmentInviteProvider;
    const isCoderbyte = reportProvider === "coderbyte";
    const testId = isCoderbyte ? job?.coderbyte_test_id : job?.hackerrank_test_id;
    const reportPath = isCoderbyte ? "coderbyte/report" : "hackerrank/report";

    if (!uuid || !testId) {
      toast.error("Report details are missing for this candidate.");
      return;
    }

    window.open(
      `${server_API}/v2/applicant/${reportPath}/${testId}/${uuid}/${cid}`,
      "_blank",
    );
  };

  useEffect(() => {
    if (!id || !cid) return;

    axios
      .get(`${server_API}/v2/job/get/${id}/${cid}`)
      .then((res) => {
        setJob(res.data);
        setHackerRankChecked(res.data.hackerrank_enabled);
        setCoderbyteChecked(res.data.coderbyte_enabled);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${server_API}/v2/user/company/${cid}`)
      .then((res) => {
        console.log(res);
        setUsers(res.data.message.Users);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${server_API}/v2/applicant/statuses/${cid}?jobid=${id}`)
      .then((res) => {
        const opts = [{ value: "", label: "--" }];
        (res.data.statuses || []).forEach((s) => opts.push({ value: s, label: s }));
        setStatusOptions(opts);
      })
      .catch(() => { });
  }, [id, cid]);

  useEffect(() => {
    if (!id || !cid) return;

    const mapStatusToTab = {
      0: "",
      1: "interviewed",
      2: "offer",
      3: "hired",
      5: "rejected",
      4: "Onhold",
    };

    const params = { jobid: id };

    const backendSortFieldsList = [
      "resumescore",
      "aggregate",
      "aiscore",
      "technicalscore",
      "voiceanalysisscore",
      "tenthscore",
      "twelvethscore",
      "coursefinalscore",
    ];
    const hasUserSort =
      hasManualSort && sortedBy && backendSortFieldsList.includes(sortedBy);
    if (!hasUserSort) {
      setPageDets({ page: filters.page, page_size: filters.page_size });
    }

    if (mapStatusToTab[tab]?.length) {
      params.status = mapStatusToTab[tab];
    }
    if (fitmentFilter.label !== "--") {
      params.salaryFitment = fitmentFilter.label;
    }
    if (timeToJoinFilter.label !== "--") {
      params.time_to_join = timeToJoinFilter.label;
    }
    if (sourceFilter.label !== "--") {
      params.source = sourceFilter.label;
    }
    if (preferredLocationFilter.label !== "--") {
      params.preferred_location = preferredLocationFilter.label;
    }
    if (currentStatusFilter.label !== "--") {
      params.currentstatus = currentStatusFilter.label;
    }
    if (startDate.length || endDate.length) {
      if (endDate.length) params.application_date = startDate + "#" + endDate;
      else params.application_date = startDate;
    }
    // for now
    // if(sortedBy.length) {
    //   params.sorted_by = sortedBy;
    // }

    // Build filter in backend format (key:value,key:value) with raw # for date range to avoid double-encoding in URL
    const filterParts = [];
    if (params.jobid) filterParts.push("jobid:" + params.jobid);
    if (params.status) filterParts.push("status:" + params.status);
    if (params.salaryFitment)
      filterParts.push("salaryFitment:" + params.salaryFitment);
    if (params.time_to_join)
      filterParts.push("time_to_join:" + params.time_to_join);
    if (params.source) filterParts.push("source:" + params.source);
    if (params.preferred_location)
      filterParts.push("preferred_location:" + params.preferred_location);
    if (params.currentstatus)
      filterParts.push("currentstatus:" + params.currentstatus);
    if (params.application_date)
      filterParts.push("application_date:" + params.application_date);
    let filterStr = filterParts.join(",");
    if (mapStatusToTab[tab] === "interviewed") {
      const roundKey = { 0: "ai interview", 99: "selected" };
      const roundVal =
        roundKey[activeInterviewedTab] ||
        "Interviewed R" + activeInterviewedTab;
      filterStr = filterStr.replace("status:interviewed", "status:" + roundVal);
    }

    const finalFilters = {
      page: pageDets.page,
      page_size: pageDets.page_size,
      filter: filterStr,
    };
    // Backend-supported sort: applies to all candidates before pagination
    const backendSortFields = [
      "resumescore",
      "aggregate",
      "aiscore",
      "technicalscore",
      "voiceanalysisscore",
      "tenthscore",
      "twelvethscore",
      "coursefinalscore",
    ];
    const useBackendSort =
      hasManualSort && sortedBy && backendSortFields.includes(sortedBy);

    const urlFilters = new URLSearchParams(finalFilters).toString();
    // Apply filter-format replacements only to filter part; append sort params after to avoid corruption
    let urlStr = urlFilters.replaceAll("%3D", "%3A").replaceAll("%26", "%2C");
    if (useBackendSort) {
      urlStr +=
        (urlStr ? "&" : "") +
        `sort_by=${encodeURIComponent(sortedBy)}&sort_order=desc`;
    }

    if (mapStatusToTab[tab] === "interviewed") {
      const roundKey = {
        0: "ai interview",
        99: "selected",
      };
      axios
        .get(
          `${server_API}/v2/applicant/getallv2/${cid}?${urlStr.replace(
            "interviewed",
            `${roundKey[activeInterviewedTab] || "Interviewed R" + activeInterviewedTab}`,
          )}`,
        )
        .then((res) => {
          const currRoundsAvailable = new Set([
            "Hired",
            "Interviewed",
            "Offer",
            "On-hold",
            "Rejected",
          ]);
          const availableRounds = Object.keys(res.data.status_count)
            .filter((key) => !currRoundsAvailable.has(key))
            .sort((a, b) => {
              if (a === "AI Interview") return -1;
              if (b === "AI Interview") return 1;
              if (a === "Selected") return 1;
              if (b === "Selected") return -1;
              const roundA = a.startsWith("Round")
                ? parseInt(a.split(" ")[1], 10)
                : Infinity;
              const roundB = b.startsWith("Round")
                ? parseInt(b.split(" ")[1], 10)
                : Infinity;
              return roundA - roundB;
            });

          if (
            activeInterviewedTab === 0 &&
            !("AI Interview" in res.data.status_count)
          ) {
            if (availableRounds.length > 0) {
              const firstRound = availableRounds[0];
              const roundNum = firstRound.startsWith("Round")
                ? parseInt(firstRound.split(" ")[1], 10)
                : null;

              if (roundNum) {
                setActiveInterviewedTab(roundNum);
              }
            } else {
              setActiveInterviewedTab(99);
            }
          }
          const data = res.data.data || [];
          const backendSortFields = [
            "resumescore",
            "aggregate",
            "aiscore",
            "technicalscore",
            "voiceanalysisscore",
            "tenthscore",
            "twelvethscore",
            "coursefinalscore",
          ];
          const useBackendSort =
            hasManualSort && sortedBy && backendSortFields.includes(sortedBy);
          let finalSortedData;
          if (useBackendSort) {
            finalSortedData = data; // Backend already sorted full dataset
          } else {
            const baseSortedData = applyInterviewRoundSort(
              data,
              activeInterviewedTab,
              job?.aiinterviewenabled,
            );
            finalSortedData =
              hasManualSort && sortedBy
                ? applyManualSortOnFetchedData(
                  baseSortedData,
                  sortedBy,
                  activeInterviewedTab,
                  job?.aiinterviewenabled,
                )
                : baseSortedData;
          }
          setAllApplicants(finalSortedData);
          setRoundsMap(
            availableRounds.reduce(
              (acc, val) => ({ ...acc, [val]: res.data.status_count[val] }),
              {},
            ),
          );
          setStatusCounts({ ...res.data.status_count, total: res.data.total });
          setTotalPages(res.data.total_page);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      axios
        .get(`${server_API}/v2/applicant/getallv2/${cid}?${urlStr}`)
        .then((res) => {
          const data = res.data.data || [];
          const backendSortFields = [
            "resumescore",
            "aggregate",
            "aiscore",
            "technicalscore",
            "voiceanalysisscore",
            "tenthscore",
            "twelvethscore",
            "coursefinalscore",
          ];
          const useBackendSort =
            hasManualSort && sortedBy && backendSortFields.includes(sortedBy);
          let finalSortedData;
          if (useBackendSort) {
            finalSortedData = data; // Backend already sorted full dataset
          } else {
            const baseSortedData = applyDefaultTieredSort(data);
            finalSortedData =
              hasManualSort && sortedBy
                ? applyManualSortOnFetchedData(
                  baseSortedData,
                  sortedBy,
                  activeInterviewedTab,
                  job?.aiinterviewenabled,
                )
                : baseSortedData;
          }
          setAllApplicants(finalSortedData);
          setStatusCounts({ ...res.data.status_count, total: res.data.total });
          setTotalPages(res.data.total_page);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [
    pageDets.page,
    pageDets.page_size,
    cid,
    id,
    tab,
    filters.page,
    filters.page_size,
    startDate,
    endDate,
    fitmentFilter.label,
    timeToJoinFilter.label,
    preferredLocationFilter.label,
    sourceFilter.label,
    activeInterviewedTab,
    job?.aiinterviewenabled,
    sortedBy,
    hasManualSort,
    currentStatusFilter.label,
  ]);

  const handleAcceptOfferLetter = () => {
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        uuid: activeApplicant.uuid,
        status: "Accepted",
        companyid: cid,
      })
      .then((res) => {
        const data = new FormData();
        data.append("offerid", activeApplicant.offerid);
        data.append("companyid", cid);
        data.append("file", acceptedFile);
        axios
          .post(`${server_API}/v2/offer/upload/offerletter`, data)
          .then((res) => {
            axios
              .patch(`${server_API}/v2/offer/update`, {
                uuid: activeApplicant.offerid,
                status: "Accepted",
                companyid: cid,
                acceptancelocation: userIPAddress,
                acceptancedate: new Date(),
              })
              .then((res) => {
                window.location.reload();
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (users.length > 0) {
      let user = [];
      user = users.map((u) => {
        return { value: u.uuid, label: u.name, mail: u.email };
      });
      setUserOptions(user);
    }
  }, [users]);

  const calculateAvgRating = (interviewobj) => {
    let total = 0;

    let arr = Object.values(interviewobj);
    arr.shift();
    if (arr.length > 0) {
      arr.map((a) => {
        total += a;
      });
      return parseInt(total / arr.length);
    }
    return 0;
  };

  // Interview tab round-specific sort.
  // AI jobs: Round 4+ use avg of all rounds (R2..current). Non-AI: Round 3+ use avg of R1..current.
  const applyInterviewRoundSort = (arr, activeTab, aiEnabled) => {
    if (!arr || arr.length === 0) return arr;
    const obj = (a) => a?.interviewrattingsobject || {};
    const getRoundRating = (a, roundNum) => obj(a)[String(roundNum)] ?? 0;
    const avgRoundsUpTo = (a, lastRound, startRound = 1) => {
      const o = obj(a);
      let sum = 0,
        count = 0;
      const end = lastRound >= 99 ? 99 : lastRound; // Selected = all rounds
      for (let r = startRound; r <= end; r++) {
        const v = o[String(r)] ?? 0;
        if (v > 0) {
          sum += v;
          count++;
        }
      }
      return count > 0 ? sum / count : 0;
    };
    return [...arr].sort((a, b) => {
      if (aiEnabled) {
        // AI Interview (0), Round 2 (2): by Aggregate AI Score
        if (activeTab === 0 || activeTab === 2)
          return (b?.aggregate ?? 0) - (a?.aggregate ?? 0);
        // Round 3: by Round 2's rating
        if (activeTab === 3) return getRoundRating(b, 2) - getRoundRating(a, 2);
        // Round 4+ and Selected: avg of all rounds 2..current (or all if Selected)
        if (activeTab >= 4 || activeTab === 99) {
          const avgA = avgRoundsUpTo(a, activeTab, 2);
          const avgB = avgRoundsUpTo(b, activeTab, 2);
          return avgB - avgA;
        }
      } else {
        // Round 1: by Resume Score
        if (activeTab === 1)
          return (b?.resumescore ?? 0) - (a?.resumescore ?? 0);
        // Round 2: by Round 1's rating
        if (activeTab === 2) return getRoundRating(b, 1) - getRoundRating(a, 1);
        // Round 3+ and Selected: avg of all rounds 1..current (or all if Selected)
        if (activeTab >= 3 || activeTab === 99) {
          const avgA = avgRoundsUpTo(a, activeTab, 1);
          const avgB = avgRoundsUpTo(b, activeTab, 1);
          return avgB - avgA;
        }
      }
      return 0;
    });
  };

  const applyDefaultTieredSort = (arr) => {
    if (!arr || arr.length === 0) return arr;
    const effectiveAvgRating = (a) => {
      const obj = a?.interviewrattingsobject || {};
      if (Object.keys(obj).length <= 1) return 0; // UI shows "-" when <=1 key, so treat as no rating
      return calculateAvgRating(obj);
    };
    const sorted = [...arr].sort((a, b) => {
      const avgA = effectiveAvgRating(a);
      const avgB = effectiveAvgRating(b);
      let tierA = 3;
      if (avgA > 0) tierA = 1;
      else if ((a?.aggregate ?? 0) > 0) tierA = 2;
      let tierB = 3;
      if (avgB > 0) tierB = 1;
      else if ((b?.aggregate ?? 0) > 0) tierB = 2;
      if (tierA !== tierB) return tierA - tierB;
      if (tierA === 1) return avgB - avgA;
      if (tierA === 2) return (b?.aggregate ?? 0) - (a?.aggregate ?? 0);
      return (b?.resumescore ?? 0) - (a?.resumescore ?? 0);
    });
    return sorted;
  };
  useEffect(() => {
    if (cid.length > 0) {
      axiosInstance
        .get(`/v2/company/get/${cid}`)
        .then((res) => {
          setCompanyDetails(res.data);
          setIsFromAFL(res.data.from_acfl || false);
          if (
            res.data.company_countries &&
            res.data.company_countries.length > 0
          ) {
            setCompanyCountryCode(res.data.company_countries[0]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [cid]);

  const { refetch } = useFetch(
    `/v2/applicant/report/${cid}/${id}`,
    {
      method: "GET",
    },
    false,
  );

  const getISODateTime = (date, timeVal) => {
    const isoDate = new Date(date);
    if (timeVal instanceof Date) {
      isoDate.setHours(timeVal.getHours());
      isoDate.setMinutes(timeVal.getMinutes());
    } else if (typeof timeVal === "string" && timeVal.includes(":")) {
      const [hours, minutes] = timeVal.split(":").map(Number);
      isoDate.setHours(hours);
      isoDate.setMinutes(minutes);
    }
    isoDate.setSeconds(0);
    isoDate.setMilliseconds(0);
    return isoDate.toISOString();
  };

  const getLocalDateString = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getMediumFromMeetingType = (meetingType = "") => {
    const normalized = String(meetingType).toLowerCase();
    if (normalized === "google_meet" || normalized === "gmeet") {
      return mediumOption.find((option) => option.value === "gmeet");
    }
    if (normalized === "in-person" || normalized === "in_person") {
      return mediumOption.find((option) => option.value === "in-person");
    }
    return mediumOption.find((option) => option.value === "virtual");
  };

  const resetScheduleInterviewForm = () => {
    setMeetingTitle("");
    setInterviewStartTime(null);
    setInterviewEndTime(null);
    setAdditionalInterviewers([]);
    setInterviewMedium("");
    setCalenderLocation("");
    setCalenderDescription("");
    setGeneratingMeetLink(false);
    setMeetLinkCopied(false);
    setCalendarEditUUID("");
    setCalendarCreatedAt("");
    setIsReschedulingInterview(false);
  };

  const openScheduleDrawer = async (applicant, prefillExisting = false) => {
    const latestRound = Array.isArray(applicant?.roundsinfo)
      ? applicant.roundsinfo[applicant.roundsinfo.length - 1]
      : null;

    setActiveRoundid(latestRound?.roundid || "");
    setActiveApplicant(applicant);
    setCandidateEmail(applicant?.email || "");
    setCandidateName(applicant?.name || "");
    setCalenderCondition(false);
    resetScheduleInterviewForm();

    if (!prefillExisting) {
      setIsOpen(true);
      return;
    }

    try {
      const { data } = await axiosInstance.get(
        `/v2/notification/calender/latest/${cid}/${applicant.uuid}/${applicant.jobid}`,
      );

      const interviewerFromOptions = userOptions.find(
        (option) => option.value === data?.interviewerid,
      );
      const fallbackInterviewer = {
        value:
          data?.interviewerid || latestRound?.assignedInterviewerUuid || "",
        label: latestRound?.assignedInterviewerName || "Select interviewer",
        mail: "",
      };
      const selectedInterviewer = interviewerFromOptions || fallbackInterviewer;
      const candidateMail = applicant?.email || "";
      const fallbackInterviewerEmail = (data?.emails || []).find(
        (email) => email && email !== candidateMail,
      );
      setHiringManager(selectedInterviewer);
      setInterviewerEmail(
        selectedInterviewer?.mail || fallbackInterviewerEmail || "",
      );

      const existingDate = data?.startdate ? new Date(data.startdate) : null;
      const existingEnd = data?.enddate ? new Date(data.enddate) : null;
      setAssignedInterviewDate(existingDate);
      setInterviewStartTime(existingDate);
      setInterviewEndTime(existingEnd);
      setMeetingTitle(data?.subject || data?.summary || "");
      setCalenderLocation(data?.location || "");
      setCalenderDescription(data?.description || "");
      setInterviewMedium(getMediumFromMeetingType(data?.meeting_type));
      setCalendarEditUUID(data?.uuid || "");
      setCalendarCreatedAt(data?.createdat || "");
      setIsReschedulingInterview(true);

      const otherEmails = (data?.emails || []).filter(
        (email) =>
          email &&
          email !== candidateMail &&
          email !== (selectedInterviewer?.mail || ""),
      );
      const mappedAdditional = otherEmails.map((email) => {
        const match = userOptions.find((option) => option.mail === email);
        return match || { value: email, label: email, mail: email };
      });
      setAdditionalInterviewers(mappedAdditional);
      setIsOpen(true);
    } catch (error) {
      console.error("Error fetching existing calendar details:", error);
      toast.error("Unable to fetch previous interview details.");
    }
  };

  const generateGoogleMeetLink = async () => {
    if (!assignedinterviewDate || !interviewStartTime || !interviewEndTime) {
      toast.error("Please fill in the date, start time, and end time first.");
      return;
    }

    setGeneratingMeetLink(true);
    setCalenderLocation("");
    setMeetLinkCopied(false);

    try {
      const emails = interviewerEmails
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email !== "");
      if (candidateEmail) emails.push(candidateEmail);
      additionalInterviewers.forEach((ai) => {
        if (ai.mail && !emails.includes(ai.mail)) emails.push(ai.mail);
      });

      const startDateISO = getISODateTime(
        assignedinterviewDate,
        interviewStartTime,
      );
      const endDateISO = getISODateTime(
        assignedinterviewDate,
        interviewEndTime,
      );

      const meetRes = await axiosInstance.post(
        "v2/notification/generate-meet-link",
        {
          companyid: cid,
          meeting_type: "google_meet",
          summary: meetingtitle || `Interview with ${companyDetails.name}`,
          description: calenderDescription || "Google Meet Interview",
          startdate: startDateISO,
          enddate: endDateISO,
          emails: emails,
          timezone: companyCountryCode === "GB" ? "UTC" : Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      );

      const link = meetRes.data.meet_link;
      setCalenderLocation(link);
      setCalenderDescription(
        (prev) => prev || `Google Meet Interview\n\nJoin: ${link}`,
      );
      toast.success("Google Meet link generated successfully!");
    } catch (meetErr) {
      console.error("Failed to generate Google Meet link:", meetErr);
      console.error(
        "Server response:",
        meetErr?.response?.status,
        meetErr?.response?.data,
      );
      const errMsg =
        meetErr?.response?.data?.error ||
        "Failed to generate Google Meet link. Please try again.";
      toast.error(errMsg, { autoClose: 5000 });
    } finally {
      setGeneratingMeetLink(false);
    }
  };

  const CreateCalender = async () => {
    try {
      const effectiveInterviewer =
        calenderCondition && previousHiringManger
          ? previousHiringManger
          : hiringManager;
      const effectiveEmailString = effectiveInterviewer?.mail || interviewerEmails;

      const emails = effectiveEmailString
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email !== "");

      if (candidateEmail) emails.push(candidateEmail);

      additionalInterviewers.forEach((ai) => {
        if (ai.mail && !emails.includes(ai.mail)) emails.push(ai.mail);
      });

      const startDateISO = getISODateTime(
        assignedinterviewDate,
        interviewStartTime,
      );
      const endDateISO = getISODateTime(
        assignedinterviewDate,
        interviewEndTime,
      );

      const calendarPayload = {
        ...(isReschedulingInterview && calendarEditUUID
          ? { uuid: calendarEditUUID, createdat: calendarCreatedAt }
          : {}),
        applicantid: activeApplicant.uuid,
        companyid: cid,
        jobid: activeApplicant.jobid,
        summary: meetingtitle || `Interview with ${companyDetails.name}`,
        location: calenderLocation,
        startdate: startDateISO,
        enddate: endDateISO,
        description: calenderDescription,
        emails: emails,
        subject: meetingtitle,
        interviewerid: effectiveInterviewer?.value,
        meeting_type:
          InterviewMedium?.value === "gmeet"
            ? "google_meet"
            : InterviewMedium?.value === "virtual"
              ? "virtual"
              : InterviewMedium?.value === "in-person"
                ? "in-person"
                : "",
        timezone: companyCountryCode === "GB" ? "UTC" : Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      const finalAssignedDate = getLocalDateString(assignedinterviewDate);

      // 1. Create calendar
      await axiosInstance.post(`v2/notification/calender`, calendarPayload);

      // 2. Depending on condition, either do actionOptions or patch the round
      if (calenderCondition) {
        if (isFromAFL) {
          await actionOptions(
            action,
            activeApplicant,
            stars,
            acflFeedback,
            true,
            null,
            true,
          );
        } else {
          await actionOptions(
            action,
            activeApplicant,
            stars,
            feedback,
            true,
            null,
            true,
          );
        }
      } else {
        const latestRound =
          Array.isArray(activeApplicant.roundsinfo) &&
            activeApplicant.roundsinfo.length > 0
            ? activeApplicant.roundsinfo[activeApplicant.roundsinfo.length - 1]
            : null;
        const isPreviousRoundComplete =
          !isReschedulingInterview &&
          latestRound &&
          latestRound.star !== "" &&
          latestRound.star !== undefined &&
          latestRound.star !== null &&
          latestRound.star !== 0;

        const roundPatchPayload = {
          uuid: activeApplicant.uuid,
          companyid: cid,
          roundid: activeRoundid,
          assigneedate: finalAssignedDate,
          ...(isPreviousRoundComplete
            ? {}
            : {
              functionalmanagername: hiringManager.label,
              assignedInterviewerUuid: hiringManager.value,
              assignedInterviewerName: hiringManager.label,
              fmid: hiringManager.value,
            }),
        };
        await axiosInstance.patch(`v2/applicant/update/round`, roundPatchPayload);
      }

      // 3. Create notification (assuming it returns a promise)

      await createNotification(
        cid,
        userId,
        "Interview",
        isReschedulingInterview
          ? `Interview schedule has been updated for ${activeApplicant.name}`
          : `Interview of ${activeApplicant.name} has been scheduled at ${finalAssignedDate}`,
        isReschedulingInterview
          ? `Interview schedule has been updated for ${activeApplicant.name}`
          : `Interview of ${activeApplicant.name} has been scheduled at ${finalAssignedDate}`,
        JSON.stringify({ id: activeApplicant.uuid }),
      );

      toast.success(
        isReschedulingInterview ? "Interview updated" : "Meeting scheduled",
      );

      window.location.reload();
    } catch (err) {
      console.error("Error scheduling interview:", err);
      toast.error("Failed to schedule meeting. Please try again.");
      return false;
    }
  };

  useEffect(() => {
    if (job) {
      let maxSalary = job.salaryto.replaceAll(",", "");
      let minSalary = job.salaryfrom.replaceAll(",", "");
      setMaxSalary(parseInt(maxSalary));
      setMinSalary(parseInt(minSalary));
    }
  }, [job]);

  const handleClick = (action) => {
    if (action === "pause") {
      changeStatus(id, "Paused");
    } else if (action === "close") {
      setOpenPopup(true);
      setActiveId(id);
    } else if (action === "share") {
      setLink(id);
      setOpenLink(true);
    } else if (action == "restart") {
      changeStatus(id, "Open");
    }
  };

  const changeStatus = (id, status) => {
    axios
      .patch(`${server_API}/v1/job/update`, {
        uuid: id,
        companyid: cid,
        jobstatus: status,
      })
      .then((response) => {
        console.log(response);
        if (status == "closed") {
          window.location.reload();
        } else {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (hiringManager && hiringManager.mail) {
      setInterviewerEmail(hiringManager.mail);
      setInterviewer(hiringManager);
    }
  }, [hiringManager]);

  useEffect(() => {
    if (activeApplicant?.status != "Pending") {
      setActiveRoundid(
        activeApplicant?.roundsinfo[activeApplicant?.roundsinfo.length - 1]
          ?.roundid,
      );
    }
  }, [activeApplicant]);

  if (job)
    return (
      <div>
        {openChangeDoj && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/3 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <p className="text-center font-semibold">
                Change in date of joining requires regenerating the offer
                letter?
              </p>
              <div className="flex justify-between items-center mt-5">
                <button
                  onClick={() => {
                    navigate("/jobs/candidates/about", {
                      state: {
                        uuid: activeApplicant.uuid,
                        tabState: "offerletterdraft",
                      },
                    });
                  }}
                  className="px-6 py-2 rounded-lg border border-[#148EFF] text-[#148EFF] bg-white"
                >
                  Yes, regenerate offer letter
                </button>
                <button
                  onClick={() => {
                    setOpenChangeDoj(false);
                  }}
                  className="px-6 py-2 rounded-lg border bg-[#148EFF]  text-white"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        {openJoined && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <div className="flex mb-5 py-1 items-center justify-between">
                <p className="text-2xl font-semibold">
                  DoJ: {activeApplicant.name}
                </p>
                <img
                  src={cross}
                  onClick={() => {
                    setOpenJoined(false);
                  }}
                  className="h-5"
                ></img>
              </div>
              <div className="h-[0.05rem] bg-gray-200 w-full"></div>
              {isFromAFL ? (
                <div className="mt-4 space-y-4">
                  <div>
                    <p className="font-semibold">
                      What is the Actual Joining date?
                      <span className="text-red-500">*</span>
                    </p>
                    <div
                      className={`mt-2 w-full flex items-center rounded border border-[#D2D4DA]`}
                    >
                      <span className="bg-[#D2D4DA] flex items-center rounded-l-sm w-fit h-9 px-2">
                        <MdOutlineDateRange className="text-[#8f94a1] w-5 h-5" />
                      </span>
                      <div className="single-date w-full">
                        <DatePicker
                          selected={newDateOfJoining}
                          onChange={(date) => setNewDateOfJoining(date)}
                          maxDate={new Date()}
                          dateFormat="dd-MM-yy"
                          className="w-full text-[#8f94a1] outline-none text-[14px] rounded-r-md flex-1 h-9 px-2"
                          placeholderText="Select Date"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <p className="font-semibold">
                      Enter the employee code
                      <span className="text-red-500">*</span>
                    </p>
                    <input
                      type="text"
                      value={employeeCode}
                      onChange={(e) => setEmployeeCode(e.target.value)}
                      className="w-full border-[#D2D4DA] border rounded-md h-9 px-3 mt-2 outline-none"
                      placeholder="Enter Employee Code"
                    />
                  </div>
                  <div>
                    <p className="font-semibold">
                      Email ID needed?<span className="text-red-500">*</span>
                    </p>
                    <div className="w-full mt-2">
                      <Select
                        onChange={(option) => setEmailNeeded(option.value)}
                        options={[
                          { value: true, label: "Yes" },
                          { value: false, label: "No" },
                        ]}
                        placeholder="Select"
                      />
                    </div>
                  </div>
                  <div>
                    <p className="font-semibold">
                      Visiting card needed?
                      <span className="text-red-500">*</span>
                    </p>
                    <div className="w-full mt-2">
                      <Select
                        onChange={(option) =>
                          setVisitingCardNeeded(option.value)
                        }
                        options={[
                          { value: true, label: "Yes" },
                          { value: false, label: "No" },
                        ]}
                        placeholder="Select"
                      />
                    </div>
                  </div>
                  <div>
                    <p className="font-semibold">Blood Group</p>
                    <div className="w-full mt-2">
                      <Select
                        onChange={(option) => setBloodGroup(option.value)}
                        options={[
                          { value: "A+", label: "A+" },
                          { value: "A-", label: "A-" },
                          { value: "B+", label: "B+" },
                          { value: "B-", label: "B-" },
                          { value: "AB+", label: "AB+" },
                          { value: "AB-", label: "AB-" },
                          { value: "O+", label: "O+" },
                          { value: "O-", label: "O-" },
                        ]}
                        placeholder="Select"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="mt-4">
                    <p className="font-semibold">
                      Did the candidate joined on the date mentioned in the
                      offer letter?<span className="text-red-500">*</span>
                    </p>
                    <div className=" w-full mt-2">
                      <Select
                        onChange={(option) => {
                          if (option.value == "n") {
                            setOpenDate(true);
                          } else {
                            setOpenDate(false);
                          }
                        }}
                        options={[
                          { value: "", label: "--" },
                          { value: "y", label: "Yes" },
                          { value: "n", label: "No" },
                        ]}
                      ></Select>
                    </div>
                  </div>
                  {openDate && (
                    <div className=" w-full mt-4">
                      <p className="font-semibold">
                        Which date did the candidate join?
                        <span className="text-red-500">*</span>
                      </p>

                      <div
                        className={` custom-placeholder  mt-2 w-full flex items-center   rounded ${dateFocused
                          ? " border-[#8f94a1] border-2"
                          : "border-[#D2D4DA] border"
                          }
                            `}
                      >
                        {" "}
                        <span
                          className={` ${dateFocused ? "bg-[#8f94a1]" : "bg-[#D2D4DA]"
                            }  flex items-center rounded-l-sm  w-fit h-9 px-2 `}
                        >
                          <MdOutlineDateRange
                            className={`${dateFocused ? "text-[#FFFFFF]" : " text-[#8f94a1]"
                              } w-5  h-5`}
                          />
                        </span>{" "}
                        <div className="single-date w-full">
                          <DatePicker
                            selected={newDateOfJoining}
                            onChange={(date) => {
                              setNewDateOfJoining(date);
                              // setInterviewDate(date)
                            }}
                            maxDate={new Date()}
                            // selected={feedback.hasOwnProperty(a.uuid)?feedback[a.uuid]:""}
                            // onChange={(date)=>{setFeedback({...feedback, [a.uuid]:date})}}
                            dateFormat="dd-MM-yy"
                            className={` ${dateFocused
                              ? "border-[#8f94a1] "
                              : "border-[#D2D4DA] "
                              }  ${dateFocused || newDateOfJoining
                                ? "font-normal"
                                : ""
                              }  w-full  text-[#8f94a1]  outline-none text-[14px] rounded-r-md flex-1  z-50  h-9 px-2   `}
                            placeholderText="Select Date"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              <div className="h-[0.05rem] my-4 bg-gray-200 w-full"></div>
              <div className="text-center">
                <button
                  onClick={() => {
                    handleJoined();
                  }}
                  className={`  font-normal rounded-[4px] border border-[] bg-[#148EFF] text-[#FFFFFF]  py-[12px] leading-[12px] text-[15px] px-[20px] disabled:opacity-50 disabled:cursor-not-allowed`}
                  disabled={
                    isFromAFL
                      ? !employeeCode ||
                      !newDateOfJoining ||
                      emailNeeded === null ||
                      visitingCardNeeded === null
                      : openDate && !newDateOfJoining
                  }
                >
                  {!openDate ? "Submit" : "Regenerate offer letter"}
                </button>
              </div>
            </div>
          </div>
        )}
        {switchToReject && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <div className="flex mb-5 py-1 items-center justify-between">
                <p className="text-2xl font-semibold">Rejection Feedback</p>
                <img
                  src={cross}
                  onClick={() => setSwitchToReject(false)}
                  className="h-5 cursor-pointer"
                />
              </div>
              <div className="bg-[#FFD9B2] rounded-lg px-3 mb-5 py-3 flex items-center gap-2">
                <IoAlertCircleOutline className="text-orange-500 shrink-0" />
                <p>You are rejecting the candidate without any interview</p>
              </div>
              <p className="font-medium mb-2">
                Select Reason <span className="text-red-500">*</span>
              </p>
              <Select
                options={RejectedReasonOptions}
                value={individualRejectReason}
                onChange={(option) => setIndividualRejectReason(option)}
                placeholder="Select a reason"
              />
              <p className="font-medium mt-4 mb-2">Detailed Feedback</p>
              <textarea
                className="w-full outline-none border-2 rounded-lg px-2 py-2 mt-1"
                rows="4"
                placeholder="Describe your feedback here..."
                value={individualRejectFeedback}
                onChange={(e) => setIndividualRejectFeedback(e.target.value)}
              />
              <div className="text-right mt-5">
                <button
                  disabled={!individualRejectReason}
                  onClick={() => {
                    setSwitchToReject(false);
                    setRejectionLoader(true);
                    actionOptions(
                      action,
                      activeApplicant,
                      0,
                      individualRejectFeedback,
                      null,
                      individualRejectReason?.value,
                    );
                  }}
                  className="px-6 py-2 rounded-lg bg-[#148EFF] text-white disabled:bg-[#D2D4DA]"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
        {openBulkRejectionModal && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-2/3 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2 max-h-[80vh] overflow-y-auto">
              <div className="flex mb-5 py-1 items-center justify-between">
                <p className="text-2xl font-semibold">Rejection Feedback</p>
                <img
                  src={cross}
                  onClick={() => {
                    setOpenBulkRejectionModal(false);
                    setBulkRejectionData([]);
                    setBulkAction({});
                  }}
                  className="h-5 cursor-pointer"
                />
              </div>
              <div className="bg-[#FFD9B2] rounded-lg px-3 mb-5 py-3 flex items-center gap-2">
                <IoAlertCircleOutline className="text-orange-500 shrink-0" />
                <p>You are rejecting the candidates without any interview</p>
              </div>
              <div className="text-sm">
                <Table>
                  <Thead>
                    <Tr>
                      <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left">
                        Candidate
                      </Th>
                      <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left">
                        Select Reason <span className="text-red-500">*</span>
                      </Th>
                      <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left">
                        Detailed Feedback
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {bulkRejectionData.map((d, i) => (
                      <Tr key={d.uuid}>
                        <Td className="border-y p-2 text-left">{d.name}</Td>
                        <Td className="border-y p-2 text-left min-w-[200px]">
                          <Select
                            options={RejectedReasonOptions}
                            value={d.reason}
                            onChange={(option) => {
                              const newData = [...bulkRejectionData];
                              newData[i] = { ...newData[i], reason: option };
                              setBulkRejectionData(newData);
                            }}
                            placeholder="Select a reason"
                          />
                        </Td>
                        <Td className="border-y p-2 text-left">
                          <textarea
                            rows="2"
                            value={d.feedback}
                            placeholder="Describe your feedback here..."
                            onChange={(e) => {
                              const newData = [...bulkRejectionData];
                              newData[i] = {
                                ...newData[i],
                                feedback: e.target.value,
                              };
                              setBulkRejectionData(newData);
                            }}
                            className="w-full rounded-lg outline-none border-2 p-2"
                          />
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
              <div className="text-right mt-5">
                <button
                  onClick={handleBulkRejectionSubmit}
                  className="font-normal rounded-[4px] border bg-[#148EFF] text-white py-[12px] leading-[12px] text-[15px] px-[20px]"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
        {openBulkOnholdModal && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-2/3 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2 max-h-[80vh] overflow-y-auto">
              <div className="flex mb-5 py-1 items-center justify-between">
                <p className="text-2xl font-semibold">On-Hold Feedback</p>
                <img
                  src={cross}
                  onClick={() => {
                    setOpenBulkOnholdModal(false);
                    setBulkOnholdData([]);
                    setBulkAction({});
                  }}
                  className="h-5 cursor-pointer"
                />
              </div>
              <div className="text-sm">
                <Table>
                  <Thead>
                    <Tr>
                      <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left">
                        Candidate
                      </Th>
                      <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left">
                        Select Reason <span className="text-red-500">*</span>
                      </Th>
                      <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left">
                        Detailed Feedback
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {bulkOnholdData.map((d, i) => (
                      <Tr key={d.uuid}>
                        <Td className="border-y p-2 text-left">{d.name}</Td>
                        <Td className="border-y p-2 text-left min-w-[200px]">
                          <Select
                            options={OnholdReasonOptions}
                            value={d.reason}
                            onChange={(option) => {
                              const newData = [...bulkOnholdData];
                              newData[i] = { ...newData[i], reason: option };
                              setBulkOnholdData(newData);
                            }}
                            placeholder="Select a reason"
                          />
                        </Td>
                        <Td className="border-y p-2 text-left">
                          <textarea
                            rows="2"
                            value={d.feedback}
                            placeholder="Describe your feedback here..."
                            onChange={(e) => {
                              const newData = [...bulkOnholdData];
                              newData[i] = {
                                ...newData[i],
                                feedback: e.target.value,
                              };
                              setBulkOnholdData(newData);
                            }}
                            className="w-full rounded-lg outline-none border-2 p-2"
                          />
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
              <div className="text-right mt-5">
                <button
                  onClick={handleBulkOnholdSubmit}
                  className="font-normal rounded-[4px] border bg-[#148EFF] text-white py-[12px] leading-[12px] text-[15px] px-[20px]"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
        {openAcceptedModal && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <div className="flex mb-5 py-1 items-center justify-between">
                <p className="text-2xl font-semibold">
                  Accepted Offer: {activeApplicant.name}
                </p>
                <img
                  src={cross}
                  onClick={() => {
                    setOpenAcceptedModal(false);
                  }}
                  className="h-5"
                ></img>
              </div>
              <div className="h-[0.05rem] bg-gray-200 w-full"></div>
              <div className="mt-4">
                <p className="font-semibold">
                  Date of acceptance <span className="text-red-500">*</span>
                </p>
                <div className=" w-full ">
                  <div
                    className={` custom-placeholder  mt-2 w-full flex items-center   rounded ${dateFocused
                      ? " border-[#8f94a1] border-2"
                      : "border-[#D2D4DA] border"
                      }
                            `}
                  >
                    {" "}
                    <span
                      className={` ${dateFocused ? "bg-[#8f94a1]" : "bg-[#D2D4DA]"
                        }  flex items-center rounded-l-sm  w-fit h-9 px-2 `}
                    >
                      <MdOutlineDateRange
                        className={`${dateFocused ? "text-[#FFFFFF]" : " text-[#8f94a1]"
                          } w-5  h-5`}
                      />
                    </span>{" "}
                    <div className="single-date w-full">
                      <DatePicker
                        selected={acceptanceDate}
                        onChange={(date) => {
                          setAcceptanceDate(date);
                          // setInterviewDate(date)
                        }}
                        maxDate={new Date()}
                        // selected={feedback.hasOwnProperty(a.uuid)?feedback[a.uuid]:""}
                        // onChange={(date)=>{setFeedback({...feedback, [a.uuid]:date})}}
                        dateFormat="dd-MM-yy"
                        className={` ${dateFocused
                          ? "border-[#8f94a1] "
                          : "border-[#D2D4DA] "
                          }  ${dateFocused || acceptanceDate ? "font-normal" : ""
                          }  w-full  text-[#8f94a1]  outline-none text-[14px] rounded-r-md flex-1  z-50  h-9 px-2   `}
                        placeholderText="Select Date"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <p className="font-semibold mb-2">
                  Copy of acceptance <span className="text-red-500">*</span>
                </p>
                {acceptedFile == null ? (
                  <>
                    <div
                      className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-14"
                      onClick={() => {
                        acceptanceFileInput.current.click();
                      }}
                    >
                      <div className="p-6">
                        {/* <img src={Tick_Square} className="" alt="Tick" /> */}
                      </div>
                      <span
                        className="text-xl font-medium"
                        style={{ color: "#0DCD94" }}
                      >
                        Select a .pdf or .docx file to upload
                      </span>
                      <span className="text-sm text-gray-500 pb-2">
                        drag & drop it here
                      </span>
                      <input
                        ref={acceptanceFileInput}
                        type="file"
                        className="hidden"
                        multiple
                        onChange={handleMultipleResumeUpload}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-14 gap-5">
                      <div className="border-2 rounded-md border-gray-300 flex flex-col">
                        <span className="flex justify-end p-1">
                          <button
                            className=""
                            onClick={() => {
                              setAcceptedFile(null);
                            }}
                          >
                            <img src={cross} alt="Remove" />
                          </button>
                        </span>
                        <div className="flex gap-2 items-center px-6 pb-4">
                          <div>
                            <img src={file_upload} alt="Uploaded file" />
                          </div>
                          <span>{acceptedFile?.name}</span>
                        </div>
                      </div>
                      <span
                        className="text-xl font-medium"
                        style={{ color: "#0DCD94" }}
                      >
                        File Uploaded Successfully
                      </span>
                    </div>
                  </>
                )}
              </div>
              <div className="h-[0.05rem] my-4 bg-gray-200 w-full"></div>
              <div className="text-center">
                <button
                  onClick={() => {
                    handleAcceptOfferLetter();
                  }}
                  className={`  font-normal rounded-[4px] border border-[] bg-[#148EFF] text-[#FFFFFF]  py-[12px] leading-[12px] text-[15px] px-[20px] `}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
        {revokeOfferModal && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <div className="flex mb-5 py-1 items-center justify-between">
                <p className="text-2xl font-semibold">
                  Revoke Offer: {activeApplicant.name}
                </p>
                <img
                  src={cross}
                  onClick={() => {
                    setRevokeOfferModal(false);
                  }}
                  className="h-5"
                ></img>
              </div>
              <p className="mt-5 mb-3">Rejection Reason</p>
              <Select
                options={rejectionOptions}
                onChange={(option) => {
                  setRejectReason(option.value);
                }}
              ></Select>
              <p className="mt-3">Reason</p>
              <textarea
                className="w-full border-2 outline-none p-2 mt-1 rounded-lg"
                rows="3"
                placeholder="Describe the reason here"
                value={furtherExplaination}
                onChange={(e) => {
                  setFurtherExplaination(e.target.value);
                }}
              ></textarea>
              <div className="mt-4 text-center">
                <button
                  onClick={handleReject}
                  className="bg-[#148EFF] text-white rounded-lg px-3 py-2"
                >
                  {rejectionLoader ? (
                    <TailSpin
                      height="20"
                      width="20"
                      color="#fff"
                      ariaLabel="tail-spin-loading"
                      radius="1"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                    />
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
        {openRoundShiftingModal && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2"></div>
          </div>
        )}
        {switchToRejectSimple && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/3 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <p className="text-center font-semibold">
                Would you like to reject the candidate?
              </p>
              <div className="flex justify-between items-center mt-5">
                <button
                  onClick={() => setSwitchToRejectSimple(false)}
                  className="px-6 py-2 rounded-lg border border-[#148EFF] text-[#148EFF] bg-white"
                >
                  No
                </button>
                <button
                  onClick={() => {
                    setSwitchToRejectSimple(false);
                    setRejectionLoader(true);
                    actionOptions(action, activeApplicant, 0, "", null, null);
                  }}
                  className="px-6 py-2 rounded-lg border bg-[#148EFF] text-white"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}
        {switchToHold && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/3 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <p className="text-center font-semibold">
                Would you like to put the candidate On-hold?
              </p>
              <div className="flex justify-between items-center mt-5">
                <button
                  onClick={() => {
                    setSwitchToHold(false);
                  }}
                  className="px-6 py-2 rounded-lg border border-[#148EFF] text-[#148EFF] bg-white"
                >
                  No
                </button>
                <button
                  onClick={() => {
                    actionOptions(action, activeApplicant, 0, "");
                  }}
                  className="px-6 py-2 rounded-lg border bg-[#148EFF]  text-white"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}
        {switchToRound && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/3 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <p className="text-center font-semibold">
                Would you like to move the candidate to next round?
              </p>
              <div className="flex justify-between items-center mt-5">
                <button
                  onClick={() => {
                    setSwitchToRound(false);
                  }}
                  className="px-6 py-2 rounded-lg border border-[#148EFF] text-[#148EFF] bg-white"
                >
                  No
                </button>
                <button
                  onClick={() => {
                    actionOptions(action, activeApplicant, 0, "");
                  }}
                  className="px-6 py-2 rounded-lg border bg-[#148EFF]  text-white"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}
        {openOfferModal && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/3 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <p className="text-center font-semibold">
                Would you like to start creating the offer?
              </p>
              <div className="flex justify-between items-center mt-5">
                <button
                  onClick={() => {
                    actionOptions("offer", activeApplicant, 0, "");
                  }}
                  className="px-3 py-2 rounded-lg border border-[#148EFF] text-[#148EFF] bg-white"
                >
                  Not now
                </button>
                <button
                  onClick={() => {
                    axios
                      .patch(`${server_API}/v2/applicant/update`, {
                        uuid: activeApplicant.uuid,
                        status: "Salary Proposal In-progress",
                        companyid: cid,
                      })
                      .then((res) => {
                        dispatch(
                          updateCandidateFilters({
                            sourceFilter: sourceFilter,
                            fitmentFilter: fitmentFilter,
                            timeToJoinFilter: timeToJoinFilter,
                            preferredLocationFilter: preferredLocationFilter,
                            startDate: startDate,
                            endDate: endDate,
                            updated: true,
                            page: pageDets.page,
                            page_size: pageDets.page_size,
                          }),
                        );
                        navigate("/jobs/candidates/about", {
                          state: {
                            uuid: activeApplicant.uuid,
                            tabState: "reqdoc",
                          },
                        });
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }}
                  className="px-3 py-2 rounded-lg border bg-[#148EFF]  text-white"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        )}

        {openSelectedNodalForInterviewed && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <div className="flex mb-5 py-1 items-center justify-between">
                <p className="text-2xl font-semibold">Interview Feedback</p>
                <img
                  src={cross}
                  onClick={() => {
                    setOpenSelectedModalForInterviewed(false);
                  }}
                  className="h-5"
                ></img>
              </div>
              <div className="bg-[#FFD9B2] rounded-lg px-3 mb-5  py-3">
                <p>You have chosen the candidate without any interview</p>
              </div>
              <p>
                Specify the reason for selection
                <span className="text-red-500">*</span>
              </p>
              <textarea
                className="w-full outline-none border-2 rounded-lg px-2 py-2  mt-2"
                rows="4"
                value={feedback}
                onChange={(e) => {
                  setFeedback(e.target.value);
                }}
              ></textarea>
              <div className="text-right mt-5">
                <button
                  onClick={() => {
                    actionOptions(action, activeApplicant, 0, feedback);
                  }}
                  className={`  font-normal rounded-[4px] border border-[] bg-[#148EFF] text-[#FFFFFF]  py-[12px] leading-[12px] text-[15px] px-[20px] `}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}

        {openSelectedNodalForBulkInterviewed && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <div className="flex mb-5 py-1 items-center justify-between">
                <p className="text-2xl font-semibold">Select</p>
                <img
                  src={cross}
                  onClick={() => {
                    setOpenSelectedModalForBulkInterviewed(false);
                  }}
                  className="h-5"
                ></img>
              </div>
              <div className="bg-[#FFD9B2] rounded-lg px-3 mb-5  py-3">
                <p>You have chosen the candidate without any interview</p>
              </div>
              <div classname="bg-white pt-10 h-[30rem] overflow-y-scroll text-sm">
                <Table>
                  <Thead>
                    <Tr>
                      <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left ">
                        Name
                      </Th>
                      <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left ">
                        Detailed Feedback
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {selectedAiApplicants.map((s, i) => {
                      return (
                        <Tr className="text-sm">
                          <Td className="border-y p-2 text-left">{s.name}</Td>
                          <Td className="border-y p-2 text-left">
                            <textarea
                              rows="2"
                              value={s.feedback}
                              name="feedback"
                              onChange={(e) => {
                                let newItems = [...selectedAiApplicants];
                                newItems[i] = {
                                  ...newItems[i],
                                  feedback: e.target.value,
                                };
                                setSelectedAiApplicants(newItems);
                              }}
                              className="w-full rounded-lg outline-none border-2 p-2"
                            ></textarea>
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </div>
              <div className="text-right mt-5">
                <button
                  onClick={() => {
                    bulkAiOptions("select");
                  }}
                  className={`  font-normal rounded-[4px] border border-[] bg-[#148EFF] text-[#FFFFFF]  py-[12px] leading-[12px] text-[15px] px-[20px] `}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="">
          {/* Overlay */}
          {isOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-40 z-40"
              onClick={() => {
                setIsOpen(false);
                if (calenderCondition) {
                  setCalenderCondition(false);
                  setOpenInterviewModal(false);
                  if (isFromAFL) {
                    actionOptions(action, activeApplicant, stars, acflFeedback, true);
                  } else {
                    actionOptions(
                      action,
                      activeApplicant,
                      stars,
                      feedback,
                      true,
                      action === "hold" ? onHoldReason?.value : null,
                    );
                  }
                }
              }}
            />
          )}

          {/* Slide-in screen */}
          <div
            className={`fixed py-20 top-0 right-0 h-full w-1/3 overflow-y-scroll bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "translate-x-full"
              }`}
          >
            <div className="px-6 py-4 flex justify-between items-center border-b">
              <h2 className="text-xl font-medium">
                {isReschedulingInterview
                  ? "Update Interview Schedule"
                  : "Schedule Interview"}
              </h2>
              <button
                onClick={() => {
                  setIsOpen(false);
                  if (calenderCondition) {
                    setCalenderCondition(false);
                    setOpenInterviewModal(false);
                    if (isFromAFL) {
                      actionOptions(action, activeApplicant, stars, acflFeedback, true);
                    } else {
                      actionOptions(
                        action,
                        activeApplicant,
                        stars,
                        feedback,
                        true,
                        action === "hold" ? onHoldReason?.value : null,
                      );
                    }
                  }
                }}
                className="text-gray-500 hover:text-black text-xl"
              >
                &times;
              </button>
            </div>

            <div className="p-5">
              <div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Meeting Title <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. Technical Interview - Round 2"
                    value={meetingtitle}
                    className="w-full h-10 px-3 text-sm text-gray-700 placeholder:text-gray-400 border border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none transition-colors"
                    onChange={(e) => setMeetingTitle(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">
                      Interviewer <span className="text-red-500">*</span>
                    </label>
                    {calenderCondition && previousHiringManger ? (
                      <div className="w-full h-10 px-3 flex items-center text-sm text-gray-700 border border-gray-200 bg-gray-50 rounded-lg">
                        {previousHiringManger.label}
                      </div>
                    ) : (
                      <Select
                        className="w-full"
                        menuPlacement="auto"
                        placeholder="Select interviewer"
                        value={hiringManager}
                        options={userOptions}
                        onChange={(option) => {
                          setInterviewerEmail(option.mail);
                          setInterviewer(option);
                          setHiringManager(option);
                        }}
                      />
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">
                      Candidate <span className="text-red-500">*</span>
                    </label>
                    <div className="w-full min-h-[38px] px-3 py-2 rounded-lg border border-gray-200 bg-gray-50 text-gray-700 text-sm truncate flex items-center">
                      {candidateName || candidateEmail || (
                        <span className="text-gray-400">
                          Selected candidate
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Additional Interviewers
                  </label>
                  <Select
                    isMulti
                    className="w-full"
                    menuPlacement="auto"
                    placeholder="Select additional interviewers (optional)"
                    value={additionalInterviewers}
                    options={userOptions}
                    onChange={(options) =>
                      setAdditionalInterviewers(options || [])
                    }
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: 40,
                        borderRadius: 8,
                        borderColor: "#e5e7eb",
                      }),
                    }}
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Interview Date <span className="text-red-500">*</span>
                  </label>
                  <div
                    className={`w-full flex items-center rounded-lg border transition-colors ${dateFocused
                      ? "border-blue-500 ring-1 ring-blue-500"
                      : "border-gray-200 hover:border-gray-300"
                      }`}
                  >
                    <span className="flex items-center justify-center w-10 h-10 rounded-l-lg bg-gray-100 text-gray-500 shrink-0">
                      <MdOutlineDateRange className="w-5 h-5" />
                    </span>
                    <div className="single-date flex-1 min-w-0">
                      <DatePicker
                        selected={assignedinterviewDate}
                        onChange={(date) => setAssignedInterviewDate(date)}
                        minDate={new Date()}
                        dateFormat="dd MMM yyyy"
                        onFocus={() => setDateFocused(true)}
                        onBlur={() => setDateFocused(false)}
                        className="w-full h-10 px-3 text-sm text-gray-700 placeholder:text-gray-400 border-0 bg-transparent focus:ring-0 rounded-r-lg"
                        placeholderText="Select date"
                      />
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">
                      Start Time <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center rounded-lg border border-gray-200 hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 bg-white transition-colors">
                      <span className="flex items-center justify-center w-10 h-10 bg-gray-100 text-gray-500 shrink-0 rounded-l-lg border-r border-gray-200">
                        <MdAccessTime className="w-[18px] h-[18px]" />
                      </span>
                      <div className="single-date flex-1 min-w-0">
                        <DatePicker
                          selected={interviewStartTime}
                          onChange={(time) => setInterviewStartTime(time)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="Start"
                          dateFormat="h:mm aa"
                          className="w-full h-10 px-3 text-sm text-gray-700 placeholder:text-gray-400 border-0 bg-transparent focus:ring-0 rounded-r-lg"
                          placeholderText="Select start time"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">
                      End Time <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center rounded-lg border border-gray-200 hover:border-gray-300 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 bg-white transition-colors">
                      <span className="flex items-center justify-center w-10 h-10 bg-gray-100 text-gray-500 shrink-0 rounded-l-lg border-r border-gray-200">
                        <MdAccessTime className="w-[18px] h-[18px]" />
                      </span>
                      <div className="single-date flex-1 min-w-0">
                        <DatePicker
                          selected={interviewEndTime}
                          onChange={(time) => {
                            if (
                              interviewStartTime &&
                              time <= interviewStartTime
                            ) {
                              toast.error("End time must be after start time");
                              return;
                            }
                            setInterviewEndTime(time);
                          }}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="End"
                          dateFormat="h:mm aa"
                          className="w-full h-10 px-3 text-sm text-gray-700 placeholder:text-gray-400 border-0 bg-transparent focus:ring-0 rounded-r-lg"
                          placeholderText="Select end time"
                          minTime={
                            interviewStartTime
                              ? new Date(
                                interviewStartTime.getTime() + 15 * 60000,
                              )
                              : new Date(new Date().setHours(0, 0, 0, 0))
                          }
                          maxTime={new Date(new Date().setHours(23, 45, 0, 0))}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Interview <span className="text-red-500">*</span>
                  </label>
                  <div className="filter-container text-sm">
                    <Select
                      placeholder="Select medium"
                      value={InterviewMedium}
                      options={mediumOption}
                      className="react-select-container"
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: 40,
                          borderRadius: 8,
                          borderColor: "#e5e7eb",
                        }),
                      }}
                      formatOptionLabel={(option) => (
                        <div className="flex items-center gap-3 py-0.5">
                          {option.icon === "virtual" && (
                            <img
                              src={virtualInterviewIcon}
                              alt=""
                              className="w-6 h-6 shrink-0"
                            />
                          )}
                          {option.icon === "gmeet" && (
                            <img
                              src={googleMeetIcon}
                              alt=""
                              className="w-6 h-6 shrink-0"
                            />
                          )}
                          {option.icon === "inperson" && (
                            <IoLocationOutline className="text-[22px] text-[#2563EB] shrink-0" />
                          )}
                          <span>{option.label}</span>
                        </div>
                      )}
                      onChange={(option) => {
                        setInterviewMedium(option);
                        if (option?.value === "gmeet") {
                          setCalenderLocation("");
                          setMeetLinkCopied(false);
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    {InterviewMedium?.value === "virtual" ||
                      InterviewMedium?.value === "gmeet"
                      ? "Meeting link"
                      : "Location"}{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  {InterviewMedium?.value === "gmeet" ? (
                    <div className="space-y-2">
                      {generatingMeetLink ? (
                        <div className="w-full h-10 px-3 flex items-center gap-2 text-sm bg-blue-50 border border-blue-200 rounded-lg text-blue-600">
                          <svg
                            className="animate-spin h-4 w-4 shrink-0"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                              fill="none"
                            />
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            />
                          </svg>
                          Generating Google Meet link...
                        </div>
                      ) : calenderLocation ? (
                        <div className="flex items-center gap-2">
                          <div className="flex-1 h-10 px-3 flex items-center text-sm bg-green-50 border border-green-200 rounded-lg text-green-700 overflow-hidden">
                            <svg
                              className="w-4 h-4 mr-2 shrink-0 text-green-500"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                              <polyline points="22 4 12 14.01 9 11.01" />
                            </svg>
                            <a
                              href={calenderLocation}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="truncate hover:underline"
                            >
                              {calenderLocation}
                            </a>
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              navigator.clipboard.writeText(calenderLocation);
                              setMeetLinkCopied(true);
                              setTimeout(() => setMeetLinkCopied(false), 2000);
                            }}
                            className={`h-10 px-3 flex items-center gap-1.5 text-sm rounded-lg border transition-colors shrink-0 ${meetLinkCopied
                              ? "bg-green-50 border-green-300 text-green-700"
                              : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300"
                              }`}
                          >
                            {meetLinkCopied ? (
                              <>
                                <svg
                                  className="w-4 h-4"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                                Copied
                              </>
                            ) : (
                              <>
                                <svg
                                  className="w-4 h-4"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <rect
                                    x="9"
                                    y="9"
                                    width="13"
                                    height="13"
                                    rx="2"
                                    ry="2"
                                  />
                                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                </svg>
                                Copy
                              </>
                            )}
                          </button>
                        </div>
                      ) : (
                        <button
                          type="button"
                          onClick={generateGoogleMeetLink}
                          disabled={
                            !assignedinterviewDate ||
                            !interviewStartTime ||
                            !interviewEndTime
                          }
                          className={`w-full h-10 px-3 flex items-center justify-center gap-2 text-sm rounded-lg border transition-colors ${!assignedinterviewDate ||
                            !interviewStartTime ||
                            !interviewEndTime
                            ? "bg-gray-50 border-gray-200 text-gray-400 cursor-not-allowed"
                            : "bg-blue-50 border-blue-200 text-blue-600 hover:bg-blue-100 hover:border-blue-300 cursor-pointer"
                            }`}
                        >
                          <svg
                            className="w-4 h-4"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                          </svg>
                          {!assignedinterviewDate ||
                            !interviewStartTime ||
                            !interviewEndTime
                            ? "Fill date & time to generate link"
                            : "Generate Google Meet Link"}
                        </button>
                      )}
                    </div>
                  ) : (
                    <input
                      type="text"
                      placeholder={
                        InterviewMedium?.value === "virtual"
                          ? "https://meet.google.com/xxx-xxxx-xxx"
                          : "Enter venue or address"
                      }
                      value={calenderLocation}
                      className="w-full h-10 px-3 text-sm text-gray-700 placeholder:text-gray-400 border border-gray-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none transition-colors"
                      onChange={(e) => setCalenderLocation(e.target.value)}
                    />
                  )}
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Add Description <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    placeholder="Add agenda, topics to discuss, or notes for the candidate..."
                    rows={4}
                    value={calenderDescription}
                    className="w-full px-3 py-2.5 text-sm text-gray-700 placeholder:text-gray-400 border border-gray-200 rounded-lg resize-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none transition-colors"
                    onChange={(e) => setCalenderDescription(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="px-6 py-5 flex justify-center items-center border-t">
              <button
                onClick={async () => {
                  const success = await CreateCalender();
                  if (success !== false) setIsOpen(false);
                }}
                disabled={
                  generatingMeetLink ||
                  !meetingtitle ||
                  !interviewerEmails ||
                  !assignedinterviewDate ||
                  !interviewStartTime ||
                  !interviewEndTime ||
                  !InterviewMedium ||
                  !calenderLocation ||
                  !calenderDescription
                }
                className={`px-5 py-3 rounded-sm text-white text-base transition-colors duration-200 ${generatingMeetLink ||
                  !meetingtitle ||
                  !interviewerEmails ||
                  !assignedinterviewDate ||
                  !interviewStartTime ||
                  !interviewEndTime ||
                  !InterviewMedium ||
                  !calenderLocation ||
                  !calenderDescription
                  ? "bg-blue-200 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
                  }`}
              >
                {isReschedulingInterview ? "Update" : "Submit"}
              </button>
            </div>
          </div>
        </div>
        {openInterviewModal && (
          <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2 max-h-[700px] overflow-y-auto">
            <div className="flex items-center justify-between">
              <p className="text-2xl">Interview Feedback</p>
              <img
                src={cross}
                onClick={() => {
                  setOpenInterviewModal(false);
                }}
                className="h-5"
              ></img>
            </div>
            {activeApplicant.status != "Onhold" &&
              activeApplicant.status != "Selected" &&
              activeApplicant.status != "Rejected" && (
                <div className="w-full flex gap-4 text-[14px] mb-[20px]">
                  <div className="w-1/2">
                    {/* Label */}
                    <div className="mb-1 font-semibold">
                      Interviewer <span className="text-red-400">*</span>
                    </div>

                    {/* Select Dropdown */}
                    <div className="filter-container text-[14px]">
                      {Array.isArray(activeApplicant.roundsinfo) &&
                        activeApplicant.roundsinfo.length > 0 &&
                        activeApplicant.roundsinfo[
                          activeApplicant.roundsinfo.length - 1
                        ].assignedInterviewerUuid &&
                        activeApplicant.roundsinfo[
                          activeApplicant.roundsinfo.length - 1
                        ].assignedInterviewerName ? (
                        // If fmid and functionalmanagername exist, show the name
                        <div className="flex items-center border border-[#D2D4DA] rounded p-2 h-9 text-[#8f94a1] text-[14px]">
                          {
                            activeApplicant.roundsinfo[
                              activeApplicant.roundsinfo.length - 1
                            ].assignedInterviewerName
                          }
                        </div>
                      ) : (
                        // Otherwise show the Select dropdown
                        <Select
                          placeholder="Select Recruiter"
                          defaultValue={
                            Array.isArray(activeApplicant.roundsinfo) &&
                              activeApplicant.roundsinfo.length > 0 &&
                              activeApplicant.roundsinfo[
                                activeApplicant.roundsinfo.length - 1
                              ].assignedInterviewerUuid
                              ? {
                                value:
                                  activeApplicant.roundsinfo[
                                    activeApplicant.roundsinfo.length - 1
                                  ].assignedInterviewerUuid,
                                label:
                                  activeApplicant.roundsinfo[
                                    activeApplicant.roundsinfo.length - 1
                                  ].assignedInterviewerName,
                              }
                              : null
                          }
                          value={hiringManager}
                          options={userOptions}
                          onChange={(option) => {
                            setHiringManager(option);
                            setPreviousUpdate(true);
                            if (activeApplicant.status != "Pending") {
                              setActiveRoundid(
                                activeApplicant.roundsinfo[
                                  activeApplicant.roundsinfo.length - 1
                                ].roundid,
                              );
                            }
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <div className="w-1/2">
                    <div className="mb-1 font-semibold">
                      Interview Date{" "}
                      <span className="text-red-400 justify start">*</span>
                    </div>
                    <div className="w-full">
                      {Array.isArray(activeApplicant?.roundsinfo) &&
                        activeApplicant.roundsinfo.length > 0 &&
                        activeApplicant.roundsinfo[
                          activeApplicant.roundsinfo.length - 1
                        ].assigneedate ? (
                        // If assigneedate is available, show it as plain text
                        <div className="flex items-center border border-[#D2D4DA] rounded p-2 h-9 text-[#8f94a1] text-[14px]">
                          <MdOutlineDateRange className="text-[#8f94a1] w-5 h-5 mr-2" />
                          {
                            new Date(
                              activeApplicant.roundsinfo[
                                activeApplicant.roundsinfo.length - 1
                              ].assigneedate.slice(0, 10),
                            ).toLocaleDateString("en-GB") // Format: DD/MM/YYYY
                          }
                        </div>
                      ) : (
                        // Else, show the DatePicker
                        <div
                          className={`custom-placeholder w-full flex items-center rounded ${dateFocused
                            ? "border-[#8f94a1] border-2"
                            : "border-[#D2D4DA] border"
                            }`}
                        >
                          <span
                            className={`${dateFocused ? "bg-[#8f94a1]" : "bg-[#D2D4DA]"
                              } flex items-center rounded-l-sm w-fit h-9 px-2`}
                          >
                            <MdOutlineDateRange
                              className={`${dateFocused
                                ? "text-[#FFFFFF]"
                                : "text-[#8f94a1]"
                                } w-5 h-5`}
                            />
                          </span>

                          <div className="single-date w-full">
                            <DatePicker
                              selected={previousInterviewDate}
                              onChange={(date) => {
                                setPreviousInterviewDate(date);
                                setPreviousUpdate(true);
                              }}
                              maxDate={new Date()}
                              dateFormat="dd-MM-yy"
                              className={`${dateFocused
                                ? "border-[#8f94a1]"
                                : "border-[#D2D4DA]"
                                } ${dateFocused || previousInterviewDate
                                  ? "font-normal"
                                  : ""
                                } w-full text-[#8f94a1] text-[14px] rounded-r-md flex-1 z-50 h-9 px-2`}
                              placeholderText="Select Date"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            <div className=" text-[14px]  font-semibold mb-1">
              Outcome <span className="text-red-400 justify start">*</span>
            </div>
            <div className="flex gap-[12px]  text-[14px] ">
              {activeApplicant.status != "Selected" && (
                <button
                  className={`${action == "switch rounds"
                    ? "bg-blue-100 text-[#148EFF]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#148EFF]"
                    : "bg-gray-100 text-[#8F94A1]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#8F94A1]"
                    } `}
                  onClick={() => {
                    setAction("switch rounds");
                  }}
                >
                  Move to round {activeRound()}
                </button>
              )}
              {activeApplicant.status == "Selected" &&
                userPrivilege !== "Hiring Manager" && (
                  <button
                    className={`${action == "offer"
                      ? "bg-blue-100 text-[#148EFF]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#148EFF]"
                      : "bg-gray-100 text-[#8F94A1]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#8F94A1]"
                      } `}
                    onClick={() => {
                      setAction("offer");
                    }}
                  >
                    Move to Offer
                  </button>
                )}
              {activeApplicant.status != "Rejected" && (
                <button
                  className={`${action == "reject"
                    ? "bg-red-100 text-[#E95060]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#E95060]"
                    : "bg-gray-100 text-[#8F94A1]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#8F94A1]"
                    } `}
                  onClick={() => {
                    setAction("reject");
                  }}
                >
                  Reject
                </button>
              )}
              {activeApplicant.status != "Onhold" && (
                <button
                  className={`${action == "hold"
                    ? "bg-gray-300 text-[#444D63]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#444D63]"
                    : "bg-gray-100 text-[#8F94A1]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#8F94A1]"
                    } `}
                  onClick={() => {
                    setAction("hold");
                  }}
                >
                  On-hold
                </button>
              )}
              {activeApplicant.status != "Selected" && (
                <button
                  className={`${action == "select"
                    ? "bg-[#D9F0F1] text-[#40B2B7]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#40B2B7]"
                    : "bg-gray-100 text-[#8F94A1]  font-medium p-[6px] leading-[12px] rounded   border-[1.2px] border-[#8F94A1]"
                    } `}
                  onClick={() => {
                    setAction("select");
                  }}
                >
                  Select
                </button>
              )}
            </div>

            {!isFromAFL
              ? activeApplicant.status != "Onhold" &&
              activeApplicant.status != "Selected" &&
              activeApplicant.status != "Rejected" && (
                <div className="flex flex-col mt-5 text-[14px]  mb-4">
                  <div className=" font-semibold mb-2">
                    Rating{" "}
                    <span className="text-red-400 justify start">*</span>
                  </div>
                  <div>
                    <ReactStars
                      count={5}
                      className=" flex gap-[8px] items-center h-[2.8rem] mt-[-8px] "
                      isHalf={false}
                      half={false}
                      value={stars}
                      onChange={(e) => {
                        setStars(e);
                      }}
                      edit={true}
                      size={46}
                      color2={"#FFA500"}
                      color1={"gray"}
                    />
                  </div>
                </div>
              )
              : null}

            {action == "hold" && (
              <div>
                <div className=" font-semibold text-sm my-5 mb-[4px]">
                  Specify the reason for being put on hold
                </div>
                <div className="w-full">
                  <div className="filter-container">
                    <Select
                      className=""
                      menuPlacement="bottom"
                      placeholder=""
                      options={OnholdReasonOptions}
                      onChange={(option) => {
                        setOnholdReason(option);
                      }}
                    ></Select>
                  </div>
                </div>
              </div>
            )}
            {action == "reject" && (
              <div>
                <div className=" font-semibold text-sm my-5 mb-[4px]">
                  Why are you rejecting the candidate?
                </div>
                <div className="w-full">
                  <div className="filter-container">
                    <Select
                      className=""
                      menuPlacement="bottom"
                      placeholder=""
                      options={RejectedReasonOptions}
                      onChange={(option) => {
                        setRejectReason(option);
                      }}
                    ></Select>
                  </div>
                </div>
              </div>
            )}

            {isFromAFL ? (
              <div className="flex flex-col text-[14px] mt-5 mb-[14px] gap-4">
                {/* Display Previous Rounds Feedback */}
                {activeApplicant?.roundsinfo?.length > 0 && (
                  <div className="mb-4 bg-gray-50 p-3 rounded-lg border">
                    <p className="font-semibold text-base mb-2">
                      Previous Rounds Feedback
                    </p>
                    {[...activeApplicant.roundsinfo]
                      .reverse()
                      .map((round, rIdx) => {
                        if (!round.star) return null;
                        else {
                          return (
                            <div
                              key={rIdx}
                              className="mb-3 last:mb-0 border-b last:border-0 pb-2"
                            >
                              <div className="flex justify-between items-center text-xs">
                                <p className="font-medium text-blue-600">
                                  Round {round.roundfrom} (
                                  {round.functionalmanagername ||
                                    "Unknown Interviewer"}
                                  )
                                </p>
                                <span className="font-bold bg-blue-100 text-blue-600 px-2 py-0.5 rounded">
                                  Total:{" "}
                                  {[
                                    "communicationSkills",
                                    "personality",
                                    "teamwork",
                                    "attitude",
                                    "culturalFitment",
                                    "businessUnderstanding",
                                  ].reduce(
                                    (sum, key) => sum + (round[key] || 0),
                                    0,
                                  )}
                                </span>
                              </div>
                              <div className="grid grid-cols-2 gap-x-4 gap-y-1 mt-1">
                                {[
                                  "communicationSkills",
                                  "personality",
                                  "teamwork",
                                  "attitude",
                                  "culturalFitment",
                                  "businessUnderstanding",
                                ].map((key) => {
                                  return (
                                    <div
                                      key={key}
                                      className="flex justify-between text-xs"
                                    >
                                      <span className="text-gray-600 capitalize">
                                        {key.replace(/([A-Z])/g, " $1").trim()}{" "}
                                        {round[key + "Comment"] && (
                                          <Tooltip
                                            tooltip={round[key + "Comment"]}
                                          >
                                            <IoInformationCircle className="text-blue-600 cursor-pointer" />
                                          </Tooltip>
                                        )}{" "}
                                      </span>
                                      <span className="font-bold">
                                        {round[key]}/5
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                              <p className="text-xs mt-1">
                                <span className="font-semibold">Summary:</span>{" "}
                                {round.interviewSummary}
                              </p>
                            </div>
                          );
                        }
                      })}
                  </div>
                )}

                <p className="font-semibold text-lg">Round Feedback</p>
                <div className="">
                  <table className="min-w-full text-left text-sm border-collapse border border-gray-300">
                    <thead className="bg-gray-100 uppercase font-medium text-gray-700">
                      <tr>
                        <th className="border border-gray-300 px-4 py-2">
                          Attributes
                        </th>
                        <th className="border border-gray-300 px-4 py-2 w-[160px]">
                          Score
                        </th>
                        {/* <th className="border border-gray-300 px-4 py-2">Checklist</th> */}
                        <th className="border border-gray-300 px-4 py-2">
                          Interviewer Comments
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        {
                          label: "Communication Skill",
                          key: "communicationSkills",
                          desc: "Ability to explain her/his points clearly; Can speak in Eng/Hindi or both with ease",
                        },
                        {
                          label: "Personality",
                          key: "personality",
                          desc: "Has the right attitude towards work and knows how to deal with difficult situations.",
                        },
                        {
                          label: "Teamwork",
                          key: "teamwork",
                          desc: "Portraying examples of experiences that showcase teamwork",
                        },
                        {
                          label: "Attitude",
                          key: "attitude",
                          desc: "Ability to work under stress, handle situations at work, has self-awareness, honest, organized",
                        },
                        {
                          label: "Cultural Fitment",
                          key: "culturalFitment",
                          desc: "Having a stable career throughout; Looking for long-term association",
                        },
                        {
                          label: "Understanding of business/function",
                          key: "businessUnderstanding",
                          desc: "Knowledge about the industry and her/his current role.",
                        },
                      ].map((item, idx) => (
                        <tr key={idx} className="border-b border-gray-300">
                          <td className="border border-gray-300 px-4 py-2 font-medium">
                            {item.label}
                            <p className="text-[10px] text-gray-500">
                              {item.desc}
                            </p>
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <div className="flex items-center gap-2">
                              <ReactStars
                                count={5}
                                value={acflFeedback[item.key]}
                                onChange={(val) =>
                                  setAcflFeedback({
                                    ...acflFeedback,
                                    [item.key]: val,
                                  })
                                }
                                size={24}
                                color2={"#FFA500"}
                                half={false}
                              />
                            </div>
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <textarea
                              className="w-full p-1 border border-gray-200 rounded text-sm focus:outline-none focus:border-blue-500"
                              placeholder="Comments..."
                              rows={2}
                              value={acflFeedback[item.key + "Comment"]}
                              onChange={(e) =>
                                setAcflFeedback({
                                  ...acflFeedback,
                                  [item.key + "Comment"]: e.target.value,
                                })
                              }
                            />
                          </td>
                        </tr>
                      ))}
                      {/* Total Score Row */}
                      <tr className="bg-gray-200 font-bold">
                        <td className="border border-gray-300 px-4 py-3">
                          Total Score (out of 30)
                        </td>
                        <td className="border border-gray-300 px-4 py-3 text-lg">
                          {Object.keys(acflFeedback)
                            .filter(
                              (k) =>
                                !k.includes("Comment") &&
                                k !== "alternateJob" &&
                                k !== "interviewSummary",
                            )
                            .reduce((sum, key) => sum + acflFeedback[key], 0)}
                        </td>
                        <td className="border border-gray-300 px-4 py-3 text-lg">
                          {(
                            (Object.keys(acflFeedback)
                              .filter(
                                (k) =>
                                  !k.includes("Comment") &&
                                  k !== "alternateJob" &&
                                  k !== "interviewSummary",
                              )
                              .reduce(
                                (sum, key) => sum + acflFeedback[key],
                                0,
                              ) /
                              30) *
                            100
                          ).toFixed(1)}
                          %
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Footer Section: Recommendation & Summary */}
                <div className="border border-gray-300 p-4 rounded bg-gray-50 mt-2">
                  <div className="mb-4">
                    <label className="block font-semibold mb-1">
                      RECOMMENDATION (If any)
                    </label>
                    <div className="flex items-center gap-2">
                      <span>Maybe suitable for the position of:</span>
                      <input
                        type="text"
                        className="flex-1 p-1 border-b border-gray-400 bg-transparent focus:outline-none"
                        placeholder="Job Name"
                        value={acflFeedback.alternateJob}
                        onChange={(e) =>
                          setAcflFeedback({
                            ...acflFeedback,
                            alternateJob: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="space-y-4">
                    {(() => {
                      const isFirstRound = !(
                        activeApplicant?.roundsinfo?.filter(
                          (round) => round.star,
                        ).length > 0
                      );
                      return (
                        <div>
                          <label className="block font-semibold mb-1">
                            Interviewer Summary{" "}
                            {isFirstRound && (
                              <span className="text-red-500">*</span>
                            )}
                          </label>
                          <textarea
                            className="w-full p-2 border border-gray-300 rounded"
                            placeholder={
                              isFirstRound
                                ? "Detailed summary (min 30 words)..."
                                : "Summary (optional)..."
                            }
                            rows={3}
                            value={acflFeedback.interviewSummary}
                            onChange={(e) => {
                              setAcflFeedback({
                                ...acflFeedback,
                                interviewSummary: e.target.value,
                              });
                            }}
                          ></textarea>
                          {isFirstRound && (
                            <p
                              className={`text-xs text-right mt-1 ${acflFeedback.interviewSummary
                                .trim()
                                .split(/\s+/)
                                .filter((w) => w.length > 0).length < 30
                                ? "text-red-500"
                                : "text-green-500"
                                }`}
                            >
                              {
                                acflFeedback.interviewSummary
                                  .trim()
                                  .split(/\s+/)
                                  .filter((w) => w.length > 0).length
                              }{" "}
                              / 30 words
                            </p>
                          )}
                        </div>
                      );
                    })()}
                  </div>

                  {activeApplicant.status != "Onhold" &&
                    activeApplicant.status != "Selected" &&
                    activeApplicant.status != "Rejected" && (
                      <div className="flex flex-col mt-5 text-[14px]  mb-4">
                        <div className=" font-semibold mb-2">
                          Rating{" "}
                          <span className="text-red-400 justify start">*</span>
                        </div>
                        <div>
                          <ReactStars
                            count={5}
                            className=" flex gap-[8px] items-center h-[2.8rem] mt-[-8px] "
                            isHalf={true}
                            half={true}
                            value={stars}
                            edit={false} // Read-only for ACFL
                            size={46}
                            color2={"#FFA500"}
                            color1={"gray"}
                          />
                        </div>
                      </div>
                    )}
                </div>
              </div>
            ) : (
              <>
                <div className="flex flex-col text-[14px] mt-5  mb-[14px]">
                  <div className=" font-semibold  mb-[6px]">
                    Detailed Feedback
                  </div>
                  <div>
                    <textarea
                      className="w-full p-[8px] border border-gray-300 rounded-[4px]"
                      placeholder="Describe your feedback here.."
                      rows={4}
                      value={feedback}
                      onChange={(e) => {
                        setFeedback(e.target.value);
                      }}
                    ></textarea>
                  </div>
                </div>
              </>
            )}

            {action == "switch rounds" && (
              <div className="flex mt-10 text-[14px] mb-[20px] flex-col ">
                <div className=" font-semibold mb-2">
                  Create Interview For Next Round
                </div>
                <div className="flex gap-4 w-full">
                  <div className="flex flex-col gap-2 w-1/2">
                    <div className=" font-semibold mb-[4px]">
                      Assign Interviewer
                    </div>
                    <div className="w-full">
                      <div className="filter-container">
                        <Select
                          className=""
                          menuPlacement="auto"
                          placeholder=""
                          value={previousHiringManger}
                          options={userOptions}
                          onChange={(option) => {
                            setPreviousManager(option);
                          }}
                        ></Select>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 w-1/2">
                    <div className=" font-semibold mb-[4px]">
                      Interview Date
                    </div>
                    <div className=" w-full ">
                      <div
                        className={` custom-placeholder  w-full flex items-center   rounded ${dateFocused
                          ? " border-[#8f94a1] border-2"
                          : "border-[#D2D4DA] border"
                          }
                            `}
                      >
                        {" "}
                        <span
                          className={` ${dateFocused ? "bg-[#8f94a1]" : "bg-[#D2D4DA]"
                            }  flex items-center rounded-l-sm w-fit h-9 px-2 `}
                        >
                          <MdOutlineDateRange
                            className={`${dateFocused ? "text-[#FFFFFF]" : " text-[#8f94a1]"
                              } w-5  h-5`}
                          />
                        </span>{" "}
                        <button
                          className="single-date w-full text-left px-2 h-9 flex items-center text-[#8f94a1] text-[14px]"
                          onClick={() => {
                            resetScheduleInterviewForm();
                            setIsOpen(true);
                            setOpenInterviewModal(false);
                            setCandidateEmail(activeApplicant.email);
                            setCandidateName(activeApplicant.name || "");
                            setCalenderCondition(true);
                          }}
                          disabled={(() => {
                            if (!previousHiringManger || stars === 0) return true;

                            if (isFromAFL) {
                              const acflAttributes = [
                                "communicationSkills",
                                "personality",
                                "teamwork",
                                "attitude",
                                "culturalFitment",
                                "businessUnderstanding",
                              ];
                              const anyAttributeUnrated = acflAttributes.some(
                                (key) => !acflFeedback[key] || acflFeedback[key] === 0,
                              );
                              const isFirstRound = !(
                                activeApplicant?.roundsinfo?.filter((round) => round.star)
                                  .length > 0
                              );
                              const summaryTooShort =
                                isFirstRound &&
                                acflFeedback.interviewSummary
                                  .trim()
                                  .split(/\s+/)
                                  .filter((w) => w.length > 0).length < 30;

                              if (anyAttributeUnrated || summaryTooShort) return true;
                            }
                            return false;
                          })()}
                        >
                          {assignedinterviewDate
                            ? new Date(
                              assignedinterviewDate,
                            ).toLocaleDateString("en-GB") // format: dd/mm/yyyy
                            : "Select Date"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <button
              onClick={() => {
                if (!calenderCondition) {
                  if (isFromAFL) {
                    actionOptions(
                      action,
                      activeApplicant,
                      stars, // Use total score as stars? or just pass object. The original function takes 'result' which is stars. Let's see.
                      // Wait, 'actionOptions' signature is (option, applicant, stars, feedback, hiringManager).
                      // I should pass the acflFeedback object as the 'feedback' argument.
                      acflFeedback, // Passing object here
                      true,
                    );
                  } else {
                    actionOptions(
                      action,
                      activeApplicant,
                      stars,
                      feedback,
                      true,
                      action === "hold" ? onHoldReason?.value : null,
                    );
                  }
                }
              }}
              disabled={(() => {
                const isFinalStatus = [
                  "Selected",
                  "Rejected",
                  "Onhold",
                ].includes(activeApplicant?.status);
                if (companyDetails.from_acfl ? false : isFinalStatus)
                  return false;

                const standardValidationFailed =
                  (!(
                    Array.isArray(activeApplicant.roundsinfo) &&
                    activeApplicant.roundsinfo.length > 0 &&
                    activeApplicant.roundsinfo[
                      activeApplicant.roundsinfo.length - 1
                    ].assignedInterviewerUuid &&
                    activeApplicant.roundsinfo[
                      activeApplicant.roundsinfo.length - 1
                    ].assignedInterviewerName
                  ) &&
                    !hiringManager.value) ||
                  stars === 0 ||
                  (!(
                    Array.isArray(activeApplicant?.roundsinfo) &&
                    activeApplicant.roundsinfo.length > 0 &&
                    activeApplicant.roundsinfo[
                      activeApplicant.roundsinfo.length - 1
                    ].assigneedate
                  ) &&
                    previousInterviewDate === "");

                if (isFromAFL) {
                  const acflAttributes = [
                    "communicationSkills",
                    "personality",
                    "teamwork",
                    "attitude",
                    "culturalFitment",
                    "businessUnderstanding",
                  ];
                  const anyAttributeUnrated = acflAttributes.some(
                    (key) => !acflFeedback[key] || acflFeedback[key] === 0,
                  );
                  const isFirstRound = !(
                    activeApplicant?.roundsinfo?.filter((round) => round.star)
                      .length > 0
                  );
                  const summaryTooShort =
                    isFirstRound &&
                    acflFeedback.interviewSummary
                      .trim()
                      .split(/\s+/)
                      .filter((w) => w.length > 0).length < 30;

                  if (isFinalStatus)
                    return anyAttributeUnrated || summaryTooShort;
                  return (
                    anyAttributeUnrated ||
                    summaryTooShort ||
                    standardValidationFailed
                  );
                }

                return standardValidationFailed;
              })()}
              className={`flex justify-center items-center font-normal rounded-[4px] border border-[] bg-[#148EFF] text-[#FFFFFF]  py-[12px] leading-[12px] text-[15px] px-[20px] disabled:bg-[#D2D4DA]`}
            >
              Submit
            </button>
          </div>
        )}
        {openPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm z-30 flex items-center justify-center">
            <div ref={newRef} className="">
              <div className="fixed bg-white  shadow-xl   p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="p-3 rounded-xl text-center  ">
                  <p className="font-semibold text-xl">
                    Are you sure you want to close this job?
                  </p>
                  <div className="flex w-full justify-around mt-5">
                    <button
                      className="text-red-500 border-red-500 border rounded-xl py-2 px-5 "
                      onClick={() => {
                        setOpenPopup(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="bg-red-500 text-white border-red-500 border rounded-xl py-2 px-6 "
                      onClick={() => {
                        changeStatus(activeId, "Closed");
                        toast.success("The Job has been successfully closed");
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {openLink && (
          <OpenJob
            navigate={navigate}
            jid={job.uuid}
            cid={cid}
            setOpenPopup={setOpenLink}
            navigateToJob
            heading="Share Job!"
          />
        )}
        <div className="p-10">
          <div
            className={
              viewJobDetails
                ? "bg-white py-5 rounded-t-xl shadow-xl justify-between flex items-center"
                : "bg-white py-5 rounded-xl shadow-xl justify-between flex items-center"
            }
          >
            <div className="font-semibold  relative  text-[16px] pl-4 leading-[18.75px] before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
              <p className="text-xl flex">
                {job.profilename} | {job.department}
                <div className="ml-6">
                  {userPrivilege !== "Hiring Manager" && (
                    <div className=" flex gap-3 ">
                      <>
                        {job.jobstatus !== "Closed" && (
                          <>
                            {job.jobstatus !== "Paused" && (
                              <div
                                onClick={() => {
                                  handleClick("pause");
                                  toast.success(
                                    "The Job has been successfully paused",
                                  );
                                }}
                                className="bg-[#F1F4FB] p-1.5 rounded-md tooltip"
                              >
                                <FiPause className="text-slate-700 cursor-pointer w-4 h-4" />
                                <p className="tooltiptext">Pause</p>
                              </div>
                            )}

                            {job.jobstatus === "Paused" && (
                              <div
                                onClick={() => {
                                  handleClick("restart");
                                  toast.success(
                                    "The Job has been successfully restarted",
                                  );
                                }}
                                className="bg-[#F1F4FB] p-1.5 rounded-md tooltip flex justify-center items-center"
                              >
                                <VscDebugRestart className="text-slate-700 cursor-pointer w-4 h-4" />
                                <p className="tooltiptext">Restart</p>
                              </div>
                            )}

                            <div
                              onClick={() => {
                                handleClick("close");
                              }}
                              className="bg-[#F1F4FB] p-1.5 rounded-md tooltip"
                            >
                              <IoMdClose className="text-slate-700 cursor-pointer w-4 h-4" />
                              <p className="tooltiptext">Close</p>
                            </div>
                          </>
                        )}
                      </>

                      <div
                        onClick={() => {
                          handleClick("share");
                        }}
                        className="bg-[#F1F4FB] p-1.5 rounded-md tooltip"
                      >
                        <IoShareSocialOutline className="text-slate-700 cursor-pointer w-4 h-4" />{" "}
                        <p className="tooltiptext">Share</p>
                      </div>
                    </div>
                  )}
                </div>
              </p>
              <p className="font-normal mt-2">
                {job.companyjobcount} | {job.experience} | {job.jobtype} |{" "}
                {job["location:"]}
              </p>
            </div>
            <button
              onClick={() => {
                setViewJobDetails(!viewJobDetails);
              }}
            >
              <img src={arrow} className="h-3 invert mr-4"></img>
            </button>
          </div>
          {viewJobDetails && (
            <JobDetails job={job} applicants={allApplicants}></JobDetails>
          )}

          <div className="bg-white py-5 rounded-xl shadow-xl mt-10">
            <div className="font-semibold  relative  text-[16px] pl-4 leading-[18.75px] before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
              <p className="text-xl">Overview</p>
            </div>
            <div className="">
              <div className="card-body p-6 bg-white h-full flex flex-col  rounded-xl">
                <div className="flex justify-between mb-6">
                  <div className=" flex gap-[12px] items-center">
                    <div
                      onClick={() => {
                        navigate("/jobs");
                      }}
                      className="tooltip"
                    >
                      <IoMdArrowBack className="text-lg text-[#444D63] w-6 h-6  tooltip"></IoMdArrowBack>
                      <p className="tooltiptext">Back</p>
                    </div>

                    <div>
                      <button
                        onClick={() => {
                          window.location.reload();
                        }}
                        className="flex tooltip justify-center  items-center text-[#444D63]  rounded-xl"
                      >
                        <LuRefreshCcw className="text-lg text-[#444D63] w-5 h-5  tooltip"></LuRefreshCcw>
                        <p className="tooltiptext">Refresh</p>
                      </button>
                    </div>
                  </div>
                  <div className="flex gap-[12px]">
                    {userPrivilege !== "Hiring Manager" && (
                      <ExportCSV
                        filename={`candidates-${job.profilename}.csv`}
                        headerAndDataFunctionCombined={
                          (companyDetails?.newProffesionalKeys || companyDetails?.is_socketAI)
                            ? buildCSVExpandingRows
                            : buildCSV
                        }
                        fetchData={refetch}
                        buttonLabel={
                          <img
                            src={download_black}
                            className="text-slate-700 cursor-pointer w-7 h-7"
                          />
                        }
                      />
                    )}

                    {hackerRankChecked && (
                      <button
                        onClick={() => {
                          navigate("/jobs/hackerrankdata", {
                            state: { jid: id },
                          });
                        }}
                        className="py-2 px-3 text-[14px] rounded-[4px] flex items-center bg-[#148EFF] text-white"
                      >
                        HackerRank
                      </button>
                    )}

                    {coderbyteChecked && (
                      <button
                        onClick={() => {
                          navigate("/jobs/coderbytedata", {
                            state: { jid: id },
                          });
                        }}
                        className="py-2 px-3 text-[14px] rounded-[4px] flex items-center bg-[#148EFF] text-white"
                      >
                        Coderbyte
                      </button>
                    )}

                    {userPrivilege !== "Hiring Manager" && (
                      <>
                        {job?.aicalling ? (
                          <div className="relative text-[14px]">
                            <button
                              className="py-2 px-3 text-[14px] rounded-[4px] h-11 flex items-center bg-white text-[#148EFF] border-[#148EFF] border-[1.4px]"
                              onClick={() => {
                                setInviteDropdownOpen(!inviteDropdownOpen);
                              }}
                            >
                              <div className="flex text-[14px] items-center justify-between">
                                Invite Application
                                <span className="ml-2">
                                  {!inviteDropdownOpen ? (
                                    <IoIosArrowDown />
                                  ) : (
                                    <IoIosArrowUp />
                                  )}
                                </span>
                              </div>
                            </button>
                            {inviteDropdownOpen && (
                              <div className="flex flex-col bg-white border border-[#148EFF] absolute w-full text-[#148EFF] rounded-b-lg z-50">
                                <button
                                  className="hover:bg-[#f0f4fc] text-left"
                                  onClick={() => {
                                    setInviteModalIsOpen(true);
                                    setInviteDropdownOpen(false);
                                  }}
                                >
                                  <div className="flex items-center space-x-4 py-3 px-3">
                                    <p>CSV</p>
                                  </div>
                                </button>
                                <button
                                  className="hover:bg-[#f0f4fc] text-left"
                                  onClick={() => {
                                    setZipModalIsOpen(true);
                                    setInviteDropdownOpen(false);
                                  }}
                                >
                                  <div className="flex items-center space-x-4 py-3 px-3">
                                    <p>Zip</p>
                                  </div>
                                </button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <button
                            onClick={() => {
                              setInviteModalIsOpen(true);
                            }}
                            className="py-2 px-3 text-[14px] rounded-[4px] flex items-center bg-white text-[#148EFF] border-[#148EFF] border-[1.4px]"
                          >
                            Invite Application
                          </button>
                        )}

                        <div className="relative text-[14px]">
                          <button
                            className={
                              !open
                                ? "h-full bg-[#148EFF] text-white px-4 py-1 rounded-[4px]"
                                : "h-full bg-[#148EFF] text-white px-4 py-1 rounded-t-[4px]"
                            }
                            onClick={() => {
                              setOpen(!open);
                            }}
                          >
                            <div className="flex text-[14px] items-center justify-between">
                              Add New Applicant
                              <span className="ml-2">
                                {!open ? <IoIosArrowDown /> : <IoIosArrowUp />}
                              </span>
                            </div>
                          </button>

                          {open && (
                            <div className="flex flex-col bg-[#5AA7EF] absolute w-full text-white rounded-b-lg">
                              <Link
                                to="/jobs/candidates/new"
                                state={{ id: id, tabState: "" }}
                              >
                                <button
                                  onClick={() => {
                                    dispatch(updateSortedBy(sortedBy));
                                  }}
                                >
                                  <div className="flex items-center space-x-4 py-3 px-3">
                                    <p>Manually</p>
                                  </div>
                                </button>
                              </Link>

                              <button
                                onClick={() => {
                                  setWithResumeModal(true);
                                }}
                              >
                                <div className="flex items-center space-x-4 py-3 px-3">
                                  <p className="text-left">File Upload</p>
                                </div>
                              </button>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* staging begins from here */}
              <div className="p-2 bg-[#f0f4fc] rounded-lg mx-4 gap-4">
                <div className="grid grid-cols-6 justify-items-center gap-4">
                  <div
                    className={
                      tab == 0
                        ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                        : " w-full px-2 py-3  flex justify-center rounded-lg"
                    }
                    onClick={() => {
                      changeTabUpdateFilters(() => setTab(0));
                      dispatch(updateCandidateTab(0));
                    }}
                  >
                    <button>All Application - {statusCounts.total}</button>
                  </div>

                  <div
                    className={
                      tab == 1
                        ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                        : " w-full px-2 py-3  flex justify-center rounded-lg"
                    }
                    onClick={() => {
                      changeTabUpdateFilters(() => setTab(1));
                      dispatch(updateCandidateTab(1));
                    }}
                  >
                    <button>
                      Interview -{" "}
                      {(statusCounts.Interviewed || 0) +
                        (statusCounts.Selected || 0)}
                    </button>
                  </div>
                  <div
                    className={
                      tab == 2
                        ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                        : " w-full px-2 py-3  flex justify-center rounded-lg"
                    }
                    onClick={() => {
                      changeTabUpdateFilters(() => setTab(2));
                      dispatch(updateCandidateTab(2));
                    }}
                  >
                    <button>Offer - {statusCounts.Offer}</button>
                  </div>
                  <div
                    className={
                      tab == 3
                        ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                        : " w-full px-2 py-3  flex justify-center rounded-lg"
                    }
                    onClick={() => {
                      changeTabUpdateFilters(() => setTab(3));
                      dispatch(updateCandidateTab(3));
                    }}
                  >
                    <button>Hire - {statusCounts.Hired}</button>
                  </div>
                  <div
                    className={
                      tab == 4
                        ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                        : " w-full px-2 py-3  flex justify-center rounded-lg"
                    }
                    onClick={() => {
                      changeTabUpdateFilters(() => setTab(4));
                      dispatch(updateCandidateTab(4));
                    }}
                  >
                    <button>On-hold - {statusCounts["On-hold"]}</button>
                  </div>

                  <button
                    className={
                      tab == 5
                        ? " w-full px-2 py-3 bg-[#148EFF] text-white flex justify-center rounded-lg"
                        : " w-full px-2 py-3  flex justify-center rounded-lg"
                    }
                    onClick={() => {
                      changeTabUpdateFilters(() => setTab(5));
                      dispatch(updateCandidateTab(5));
                    }}
                  >
                    Reject - {statusCounts.Rejected}
                  </button>
                </div>
              </div>
              <div className="md:flex md:flex-nowrap p-6 filter-container w-full items-end justify-start gap-2 min-w-0">
                <div className="min-w-0 flex-1 basis-0">
                  <p className="font-semibold text-sm mb-1 truncate">Source</p>

                  <Select
                    {...selectPortalToBodyProps}
                    placeholder="Select Source"
                    className="text-[14px]"
                    options={sourceOptions}
                    value={sourceFilter}
                    styles={overviewFilterSelectStyles}
                    onChange={(option) => {
                      setSourceFilter(option);
                    }}
                  ></Select>
                </div>
                <div className="min-w-0 flex-1 basis-0">
                  <p className="font-semibold text-sm mb-1 truncate">
                    Salary Fitment
                  </p>

                  <Select
                    {...selectPortalToBodyProps}
                    placeholder="Salary Fitment"
                    className="text-[14px]"
                    options={fitmentOptions}
                    value={fitmentFilter}
                    styles={overviewFilterSelectStyles}
                    onChange={(option) => {
                      setFitmentFilter(option);
                    }}
                  ></Select>
                </div>
                <div className="min-w-0 flex-1 basis-0">
                  <p className="font-semibold text-sm mb-1 truncate">
                    Time to join
                  </p>

                  <Select
                    {...selectPortalToBodyProps}
                    placeholder="Salary Range"
                    className="text-[14px]"
                    options={timeToJoinOptions}
                    value={timeToJoinFilter}
                    styles={overviewFilterSelectStyles}
                    onChange={(option) => {
                      setTimeToJoinFilter(option);
                    }}
                  ></Select>
                </div>
                <div className="min-w-0 flex-1 basis-0">
                  <p className="font-semibold text-sm mb-1 truncate">
                    Preferred Location
                  </p>

                  <Select
                    {...selectPortalToBodyProps}
                    placeholder="Select Location"
                    className="text-[14px]"
                    options={[
                      { value: "", label: "--" },
                      { value: "open", label: "Open for All" },
                      ...(job?.["location:"]
                        ? job["location:"].split(",").map((loc) => ({
                          value: loc.trim(),
                          label: loc.trim(),
                        }))
                        : []),
                    ]}
                    value={preferredLocationFilter}
                    styles={overviewFilterSelectStyles}
                    onChange={(option) => {
                      setPreferredLocationFilter(option);
                    }}
                  ></Select>
                </div>
                <div className="min-w-0 flex-1 basis-0">
                  <p className="font-semibold text-sm mb-1 truncate">
                    Current Status
                  </p>
                  <Select
                    {...selectPortalToBodyProps}
                    placeholder="Select Status"
                    className="text-[14px]"
                    options={statusOptions}
                    value={currentStatusFilter}
                    styles={overviewFilterSelectStyles}
                    onChange={(option) => {
                      setCurrentStatusFilter(option);
                    }}
                  ></Select>
                </div>
                <div className="w-[230px]">
                  <div className="text-sm  mb-1 font-semibold">Applied On</div>
                  {/* <div className="flex gap-2 items-center border-[1px] rounded-md w-full">
      <label className="font-semibold text-[#8f94a1] px-1">To</label>
      <input
        type="date"
        min={startDate || ""}
        max={new Date().toISOString().split("T")[0]}
        value={endDate || ""} 
        onChange={handleEndDateChange}
        className="px-1 py-1 border-l-[1px] w-full outline-none"
      />
      {endDate && (
        <button
          onClick={() => setEndDate("")}
          className="px-1 text-[#8f94a1] hover:text-red-500 transition-colors"
        >
          <MdClose />
        </button>
      )}
    </div>
  </div>  */}
                  <div className="w-full min-w-0">
                    <div
                      className={`custom-placeholder flex min-w-0 items-center justify-center rounded overflow-hidden ${dateFocused
                        ? " border-[#8f94a1] border-2"
                        : "border-[#D2D4DA] border"
                        }`}
                    >
                      {" "}
                      <span
                        className={` ${dateFocused ? "bg-[#8f94a1]" : "bg-[#D2D4DA]"
                          } flex shrink-0 items-center rounded-l-sm h-9 px-1`}
                      >
                        <MdOutlineDateRange
                          className={`${dateFocused ? "text-[#FFFFFF]" : " text-[#8f94a1]"
                            } w-4 h-4`}
                        />
                      </span>{" "}
                      <DatePicker
                        selected={startDate}
                        onFocus={() => setDateFocused(true)}
                        onBlur={() => setDateFocused(false)}
                        onChange={(date) => handleStartDateChange(date)}
                        // value={startDate}
                        selectsStart
                        // isClearable
                        startDate={startDate}
                        endDate={endDate}
                        dateFormat="dd-MM-yy"
                        className={` min-w-0 ${dateFocused
                          ? "border-[#8f94a1]  border-r-2"
                          : "border-[#D2D4DA] border-r"
                          }  ${dateFocused || startDate || endDate
                            ? "font-semibold"
                            : ""
                          } flex-1 text-[#8f94a1] text-[12px] sm:text-[13px] z-50 h-9 px-1`}
                        placeholderText="From"
                      />
                      <DatePicker
                        selected={endDate}
                        onFocus={() => setDateFocused(true)}
                        onBlur={() => setDateFocused(false)}
                        onChange={(date) => handleEndDateChange(date)}
                        // value={endDate}
                        startDate={new Date(startDate)}
                        // isClearable
                        endDate={endDate}
                        dateFormat="dd-MM-yy"
                        selectsEnd
                        className={` min-w-0 ${dateFocused
                          ? "border-[#8f94a1]  "
                          : "border-[#D2D4DA] "
                          }  ${dateFocused || startDate || endDate
                            ? "font-semibold"
                            : ""
                          } flex-1 rounded-r text-[#8f94a1] text-[12px] sm:text-[13px] z-50 h-9 px-1`}
                        placeholderText="To"
                      />
                    </div>
                  </div>
                </div>
                {selectedApplicants.length > 0 && (
                  <div className="min-w-0 flex-1 basis-0">
                    <p className="font-semibold text-sm mb-1 truncate">
                      Select Action
                    </p>

                    <Select
                      {...selectPortalToBodyProps}
                      placeholder="Select Action"
                      className="text-[14px]"
                      options={bulkActionOptions}
                      value={bulkAction}
                      styles={overviewFilterSelectStyles}
                      onChange={(option) => {
                        setBulkAction(option);
                      }}
                    ></Select>
                  </div>
                )}
                {/* <div className='w-1/4'>
              <p className="font-semibold">Work style</p>
              <select onChange={(e)=>{setWs(e.target.value)}} value={ws} className="border w-full  px-1 py-1 rounded-lg mt-1">
                <option value="">--</option>
                <option value="On-Site">On-site</option>
                <option value="Remote">Remote</option>
                <option value="Hybrid">Hybrid</option>
              </select>
            </div> */}

                {/* <button onClick={()=>{search()}} className="py-2 h-full  bg-[#148EFF] text-white px-12 rounded-lg">Search</button> */}
              </div>
              <div className="mx-4 mt-6">
                {tab == 0 && (
                  <table className="w-full">
                    <thead className="text-center text-sm sticky  top-0 z-30  bg-white">
                      {/* ----------- Main header row ----------- */}
                      <tr>
                        <th
                          rowSpan={2}
                          className="border-y border-[#D2D4DA] py-5 px-2 text-center "
                        >
                          <input
                            type="checkbox"
                            checked={AllChecked}
                            onClick={() => setAllChecked(!AllChecked)}
                          />
                        </th>
                        <th
                          rowSpan={2}
                          className="border-y border-[#D2D4DA] py-5 px-2 text-left "
                        >
                          <div className="flex justify-start items-center gap-2">
                            <span className="text-left">Applicant Name</span>
                            {(companyDetails?.professionalDetail ||
                              companyDetails?.newProffesionalKeys ||
                              companyDetails?.from_acfl ||
                              companyDetails?.is_everestIMS ||
                              companyDetails?.is_socketAI) && (
                                <button
                                  type="button"
                                  onClick={() => setExpandingRows(!expandingRows)}
                                  className="focus:outline-none"
                                  aria-label={
                                    expandingRows
                                      ? "Collapse details"
                                      : "Expand details"
                                  }
                                >
                                  {expandingRows ? (
                                    <img
                                      src={collapserow}
                                      alt="Collapse"
                                      className="text-slate-700 cursor-pointer w-12 h-12"
                                    />
                                  ) : (
                                    <img
                                      src={expandedrow}
                                      alt="Expand"
                                      className="text-slate-700 cursor-pointer w-12 h-12"
                                    />
                                  )}
                                </button>
                              )}
                          </div>
                        </th>

                        <th
                          rowSpan={2}
                          className="border-y cursor-pointer border-[#D2D4DA] p-2 text-center"
                          onClick={() =>
                            sortBy(
                              "resumescore",
                              allApplicants,
                              (arr) => setAllApplicants(arr),
                              resetPageOnSortChange,
                            )
                          }
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                              justifyContent: "center",
                            }}
                          >
                            Resume Score
                            {sortedBy === "resumescore" && union && (
                              <img
                                src={union}
                                style={{ width: 12, marginLeft: 4 }}
                              />
                            )}
                          </span>
                        </th>

                        {expandingRows ? (
                          companyDetails?.newProffesionalKeys ? (
                            <>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                Current Salary
                              </th>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                6 Days Willingness
                              </th>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                Ed Tech Experience
                              </th>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                Laptop & Wifi
                              </th>
                            </>
                          ) : companyDetails?.is_zeroharm ? (
                            <>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                6 Days Willingness
                              </th>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                Willing to Relocate (Hyd)
                              </th>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                7 Days Roster Willingness
                              </th>
                            </>
                          ) : companyDetails?.from_acfl ? (
                            <>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                Age
                              </th>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                Highest Qualification
                              </th>
                            </>
                          ) : companyDetails?.is_everestIMS ? (
                            <>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                5 Days Willingness
                              </th>
                              {(Array.isArray(job?.required_skills)
                                ? job.required_skills
                                : []
                              ).map((requiredSkill) => (
                                <th
                                  key={`everest-skill-header-${requiredSkill?.skill}`}
                                  className="border-y border-[#D2D4DA] p-2 text-center min-w-[110px]"
                                >
                                  {`Exp in ${requiredSkill?.skill || "Skill"}`}
                                </th>
                              ))}
                            </>
                          ) : companyDetails?.is_socketAI ? (
                            <>
                              <th className="border-y border-[#D2D4DA] p-2 text-center">
                                Office Willingness
                              </th>
                              <th className="border-y border-[#D2D4DA] p-2 text-center min-w-[110px]">
                                Notice Period
                              </th>
                              {(Array.isArray(job?.required_skills)
                                ? job.required_skills
                                : []
                              ).map((requiredSkill) => (
                                <th
                                  key={`socket-skill-header-${requiredSkill?.skill}`}
                                  className="border-y border-[#D2D4DA] p-2 text-center min-w-[110px]"
                                >
                                  {`Exp in ${requiredSkill?.skill || "Skill"}`}
                                </th>
                              ))}
                            </>
                          ) : (
                            <>
                              <th
                                colSpan={2}
                                className="border-y cursor-pointer border-[#D2D4DA] p-2 text-center"
                              >
                                10th
                              </th>
                              <th
                                colSpan={2}
                                className="border-y cursor-pointer border-[#D2D4DA] p-2 text-center"
                              >
                                12th
                              </th>
                              <th
                                colSpan={3}
                                className="border-y cursor-pointer border-[#D2D4DA] p-2 text-center"
                              >
                                Bachelors
                              </th>
                            </>
                          )
                        ) : (
                          <>
                            <th className="border-y border-[#D2D4DA] p-2 text-center">
                              Applied On
                            </th>
                            {job.aiinterviewenabled && (
                              <th
                                className="border-y cursor-pointer border-[#D2D4DA] p-2 text-center"
                                onClick={() =>
                                  sortBy(
                                    "aggregate",
                                    allApplicants,
                                    (arr) => setAllApplicants(arr),
                                    resetPageOnSortChange,
                                  )
                                }
                              >
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 4,
                                    justifyContent: "center",
                                  }}
                                >
                                  Aggregate AI Score
                                  {sortedBy === "aggregate" && union && (
                                    <img
                                      src={union}
                                      style={{ width: 12, marginLeft: 4 }}
                                    />
                                  )}
                                </span>
                              </th>
                            )}
                            <th
                              className="border-y cursor-pointer border-[#D2D4DA]  p-2 text-center"
                              onClick={() =>
                                sortByAvgRating(
                                  allApplicants,
                                  setAllApplicants,
                                  activeInterviewedTab,
                                  job?.aiinterviewenabled,
                                  resetPageOnSortChange,
                                )
                              }
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 4,
                                  justifyContent: "center",
                                }}
                              >
                                Average Rating
                                {sortedBy === "avgRating" && union && (
                                  <img
                                    src={union}
                                    style={{ width: 12, marginLeft: 4 }}
                                  />
                                )}
                              </span>
                            </th>
                            <th className="border-y border-[#D2D4DA] p-2 text-center max-w-[9rem] w-[9rem]">
                              <span className="line-clamp-2 leading-tight inline-block">
                                Current Status
                              </span>
                            </th>
                          </>
                        )}
                        {expandingRows &&
                          companyDetails?.professionalDetail && (
                            <th
                              rowSpan={2}
                              className="border-y border-[#D2D4DA]  p-2 text-center"
                            >
                              Serving Notice
                            </th>
                          )}
                        <RoleBasedAccessControl>
                          <th
                            rowSpan={2}
                            className="border-y border-[#D2D4DA]  p-2 text-center"
                          >
                            Salary Fitment
                          </th>
                        </RoleBasedAccessControl>
                        <th
                          rowSpan={2}
                          className="border-y border-[#D2D4DA] text-center p-2"
                        >
                          Actions
                        </th>
                      </tr>
                      {/* ----------- Subheader row (only if expanded) ----------- */}
                      {expandingRows && companyDetails?.professionalDetail && (
                        <tr>
                          <th
                            className="border-y cursor-pointer border-[#D2D4DA] text-center p-2"
                            onClick={() =>
                              sortByNumericString(
                                "tenthscore",
                                allApplicants,
                                (arr) => setAllApplicants(arr),
                                resetPageOnSortChange,
                              )
                            }
                          >
                            {" "}
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                              }}
                            >
                              Score
                              {sortedBy === "tenthscore" && union && (
                                <img
                                  src={union}
                                  style={{ width: 12, marginLeft: 4 }}
                                />
                              )}
                            </span>
                          </th>
                          <th className="border-y border-[#D2D4DA] text-center p-2">
                            Year
                          </th>
                          <th
                            className="border-y cursor-pointer border-[#D2D4DA] text-center p-2"
                            onClick={() =>
                              sortByNumericString(
                                "twelvethscore",
                                allApplicants,
                                (arr) => setAllApplicants(arr),
                                resetPageOnSortChange,
                              )
                            }
                          >
                            {" "}
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                              }}
                            >
                              Score
                              {sortedBy === "twelvethscore" && union && (
                                <img
                                  src={union}
                                  style={{ width: 12, marginLeft: 4 }}
                                />
                              )}
                            </span>
                          </th>
                          <th className="border-y border-[#D2D4DA] text-center p-2">
                            Year
                          </th>
                          <th
                            className="border-y cursor-pointer border-[#D2D4DA] text-center p-2"
                            onClick={() =>
                              sortByNumericString(
                                "coursefinalscore",
                                allApplicants,
                                (arr) => setAllApplicants(arr),
                                resetPageOnSortChange,
                              )
                            }
                          >
                            {" "}
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                              }}
                            >
                              Score
                              {sortedBy === "coursefinalscore" && union && (
                                <img
                                  src={union}
                                  style={{ width: 12, marginLeft: 4 }}
                                />
                              )}
                            </span>
                          </th>
                          <th className="border-y border-[#D2D4DA] text-center p-2">
                            Year
                          </th>
                          <th className="border-y border-[#D2D4DA] text-center p-2">
                            Degree
                          </th>
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      {[...allApplicants].map((a, i) => {
                        const rank =
                          allApplicants.findIndex(
                            (applicant) => applicant.uuid === a.uuid,
                          ) + 1;
                        return (
                          <tr key={a.uuid || i} className="text-sm">
                            {/* Checkbox */}
                            <td className={"border-y  text-center p-2"}>
                              <input
                                type="checkbox"
                                checked={handleAllApplicantCheck(
                                  selectedApplicants,
                                  a.uuid,
                                )}
                                onClick={() => {
                                  addCandidate(
                                    selectedApplicants,
                                    setSelectedApplicants,
                                    a.uuid,
                                  );
                                }}
                              ></input>
                            </td>
                            {/* Name */}
                            <td className="border-y p-2 text-left text-[#148EFF]">
                              <div className="">
                                <p className="flex items-center">
                                  <button
                                    className="text-left"
                                    onClick={() => {
                                      dispatch(updateSortedBy(sortedBy));
                                      dispatch(
                                        updateCandidateFilters({
                                          sourceFilter: sourceFilter,
                                          fitmentFilter: fitmentFilter,
                                          timeToJoinFilter: timeToJoinFilter,
                                          preferredLocationFilter:
                                            preferredLocationFilter,
                                          startDate: startDate,
                                          endDate: endDate,
                                          updated: true,
                                          page: pageDets.page,
                                          page_size: pageDets.page_size,
                                        }),
                                      );
                                      navigate("/jobs/candidates/about", {
                                        state: { uuid: a.uuid, id: id },
                                      });
                                      // sessionStorage.setItem('currentPage', currentPage)
                                    }}
                                  >
                                    {a.name}
                                  </button>
                                  {(["northstarz.ai", "northstarz"].includes(
                                    a?.source?.toLowerCase(),
                                  ) ||
                                    ["northstarz.ai", "northstarz"].includes(
                                      a?.heardaboutus?.toLowerCase(),
                                    )) && (
                                      <div className="group relative">
                                        <img
                                          src={sparkle}
                                          className="h-4 mx-1"
                                          alt="sparkle"
                                        ></img>
                                        <div className="absolute transition-all left-3 top-3 text-left p-2 z-30 border-2 border-[#7C3AED] scale-0 rounded-lg bg-[#111827] w-[180px] shadow-lg text-[0.65rem] text-white group-hover:scale-100">
                                          Northstarz sourced applicant
                                        </div>
                                      </div>
                                    )}
                                  <div className="group relative">
                                    <img src={mail} className="h-4 mx-1"></img>
                                    <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem]  group-hover:scale-100">
                                      <a
                                        href={`mailto:${a.email}`}
                                        className="truncate"
                                      >
                                        {a.email}
                                      </a>
                                    </div>
                                  </div>
                                </p>
                                <p className="text-black text-xs my-1">
                                  {a.countrycode} {a.phone}
                                </p>
                              </div>
                            </td>
                            {/* Resume Score */}
                            <td className="border-y text-center p-2">
                              {a.resumescore === 0 ? "-" : a.resumescore}
                            </td>

                            {/* EXPANDED Cells */}
                            {expandingRows ? (
                              companyDetails?.newProffesionalKeys ? (
                                <>
                                  <td className="border-y text-center p-2">
                                    {getCurrencySymbol(companyCountryCode) +
                                      " " +
                                      (
                                        Number(
                                          a.currentsalary?.split(" ")?.[1],
                                        ) / 12 || 0
                                      ).toFixed(0) || "-"}
                                  </td>
                                  <td className="border-y text-center p-2">
                                    {a.willing_to_work_6_days || "-"}
                                  </td>
                                  <td className="border-y text-center p-2">
                                    {a.edtech_experience || "-"}
                                  </td>
                                  <td className="border-y text-center p-2">
                                    {a.remote_work || "-"}
                                  </td>
                                </>
                              ) : companyDetails?.is_zeroharm ? (
                                <>
                                  <td className="border-y text-center p-2">
                                    {a.willing_to_work_6_days || "-"}
                                  </td>
                                  <td className="border-y text-center p-2">
                                    {a.willing_to_relocate_hyderabad || "-"}
                                  </td>
                                  <td className="border-y text-center p-2">
                                    {a.comfortable_7_day_roster || "-"}
                                  </td>
                                </>
                              ) : companyDetails?.from_acfl ? (
                                <>
                                  <td className="border-y text-center p-2">
                                    {a.dob
                                      ? Math.floor(
                                        (new Date() - new Date(a.dob)) /
                                        31557600000,
                                      )
                                      : "-"}
                                  </td>
                                  <td className="border-y text-center p-2">
                                    {a.qualification || "-"}
                                  </td>
                                </>
                              ) : companyDetails?.is_everestIMS ? (
                                <>
                                  <td className="border-y text-center p-2">
                                    {a.willing_to_work_5_days_office ? (
                                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-[#E7F6EC] text-[#1B8A4A]">
                                        Yes
                                      </span>
                                    ) : (
                                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-[#FDEAEA] text-[#C93636]">
                                        No
                                      </span>
                                    )}
                                  </td>
                                  {(() => {
                                    const skillData = a.skill_experiences;
                                    let skillMap = null;

                                    if (
                                      skillData &&
                                      typeof skillData === "object" &&
                                      !Array.isArray(skillData)
                                    ) {
                                      skillMap = skillData;
                                    } else if (typeof skillData === "string") {
                                      try {
                                        const parsed = JSON.parse(skillData);
                                        if (
                                          parsed &&
                                          typeof parsed === "object" &&
                                          !Array.isArray(parsed)
                                        ) {
                                          skillMap = parsed;
                                        }
                                      } catch (e) {
                                        skillMap = null;
                                      }
                                    }

                                    const requiredSkills = Array.isArray(
                                      job?.required_skills,
                                    )
                                      ? job.required_skills
                                      : [];

                                    return requiredSkills.map(
                                      (requiredSkill) => {
                                        const skillName = requiredSkill?.skill;
                                        const exp = skillName
                                          ? skillMap?.[skillName]
                                          : undefined;
                                        const hasValue =
                                          exp !== undefined &&
                                          exp !== null &&
                                          exp !== "";

                                        return (
                                          <td
                                            key={`${a.uuid}-${skillName || "skill-value"}`}
                                            className="border-y text-center p-2"
                                          >
                                            {hasValue ? (
                                              <span className="inline-flex items-center rounded-md border border-[#DDE2F0] bg-[#F8FAFF] px-2 py-1 text-xs font-medium text-[#1F2A44]">
                                                {exp}y
                                              </span>
                                            ) : (
                                              <span className="text-[#8F94A1]">
                                                -
                                              </span>
                                            )}
                                          </td>
                                        );
                                      },
                                    );
                                  })()}
                                </>
                              ) : companyDetails?.is_socketAI ? (
                                <>
                                  <td className="border-y text-center p-2">
                                    {a.willing_to_work_5_days_office ? (
                                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-[#E7F6EC] text-[#1B8A4A]">
                                        Yes
                                      </span>
                                    ) : (
                                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-[#FDEAEA] text-[#C93636]">
                                        No
                                      </span>
                                    )}
                                  </td>
                                  <td className="border-y text-center p-2">
                                    {a.noticeperiod ? (
                                      <span className="inline-flex items-center rounded-md border border-[#DDE2F0] bg-[#F8FAFF] px-2 py-1 text-xs font-medium text-[#1F2A44]">
                                        {a.noticeperiod} days
                                      </span>
                                    ) : (
                                      <span className="text-[#8F94A1]">-</span>
                                    )}
                                  </td>
                                  {(() => {
                                    const skillData = a.skill_experiences;
                                    let skillMap = null;

                                    if (
                                      skillData &&
                                      typeof skillData === "object" &&
                                      !Array.isArray(skillData)
                                    ) {
                                      skillMap = skillData;
                                    } else if (typeof skillData === "string") {
                                      try {
                                        const parsed = JSON.parse(skillData);
                                        if (
                                          parsed &&
                                          typeof parsed === "object" &&
                                          !Array.isArray(parsed)
                                        ) {
                                          skillMap = parsed;
                                        }
                                      } catch (e) {
                                        skillMap = null;
                                      }
                                    }

                                    const requiredSkills = Array.isArray(job?.required_skills)
                                      ? job.required_skills
                                      : [];

                                    return requiredSkills.map((requiredSkill) => {
                                      const skillName = requiredSkill?.skill;
                                      const exp = skillName ? skillMap?.[skillName] : undefined;
                                      const hasValue = exp !== undefined && exp !== null && exp !== "";

                                      return (
                                        <td
                                          key={`${a.uuid}-socket-${skillName || "skill-value"}`}
                                          className="border-y text-center p-2"
                                        >
                                          {hasValue ? (
                                            <span className="inline-flex items-center rounded-md border border-[#DDE2F0] bg-[#F8FAFF] px-2 py-1 text-xs font-medium text-[#1F2A44]">
                                              {exp}y
                                            </span>
                                          ) : (
                                            <span className="text-[#8F94A1]">-</span>
                                          )}
                                        </td>
                                      );
                                    });
                                  })()}
                                </>
                              ) : (
                                <>
                                  {/* Sample: you must update these with real data access! */}
                                  {/* 10th */}
                                  <td className="border-y text-center p-2">
                                    {a.tenthscore || "-"}
                                  </td>
                                  <td className="border-y text-center p-2 group relative">
                                    {a.tenthyearofpassing || "-"}{" "}
                                    <div
                                      className="absolute transition-all left-3 top-10 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-[15rem] max-w-[20rem] shadow-md text-[0.7rem] group-hover:scale-100 break-words"
                                      style={{ whiteSpace: "normal" }}
                                    >
                                      <span>{a.tenthschoolname}</span>
                                    </div>
                                  </td>
                                  {/* 12th */}
                                  <td className="border-y text-center p-2">
                                    {a.twelvethscore || "-"}
                                  </td>
                                  <td className="border-y text-center p-2 group relative">
                                    {a.twelvethyearofpassing || "-"}{" "}
                                    <div
                                      className="absolute transition-all left-3 top-10 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-[15rem] max-w-[20rem] shadow-md text-[0.7rem] group-hover:scale-100 break-words"
                                      style={{ whiteSpace: "normal" }}
                                    >
                                      <span>{a.twelvethschoolname}</span>
                                    </div>
                                  </td>
                                  {/* Bachelors */}
                                  <td className="border-y text-center p-2">
                                    {a.coursefinalscore || "-"}
                                  </td>
                                  <td className="border-y text-center p-2 group relative">
                                    {a.courseyearofpassing || "-"}
                                    <div
                                      className="absolute transition-all left-3 top-10 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-[15rem] max-w-[20rem] shadow-md text-[0.7rem] group-hover:scale-100 break-words"
                                      style={{ whiteSpace: "normal" }}
                                    >
                                      <span>{a.institutename}</span>
                                    </div>
                                  </td>

                                  <td className="border-y text-center p-2 max-w-[8rem] break-words whitespace-normal">
                                    {a.coursename || "-"}
                                  </td>
                                </>
                              )
                            ) : (
                              <>
                                {/* COLLAPSED cells */}
                                <td className="border-y px-[20px] py-4 text-center  ">
                                  {(() => {
                                    const date = new Date(a.createdat);

                                    const year = date.getFullYear();
                                    const month = String(
                                      date.getMonth() + 1,
                                    ).padStart(2, "0"); // Months are zero-based
                                    const day = String(date.getDate()).padStart(
                                      2,
                                      "0",
                                    );
                                    const formattedDate = `${year}-${month}-${day}`;

                                    return formattedDate;
                                  })()}
                                </td>
                                {/* AI Score */}
                                {job.aiinterviewenabled && (
                                  <td className="border-y text-center p-2">
                                    <div className="flex justify-center items-center">
                                      {/* Show aggregate or "-" */}
                                      <div className="ml-2">
                                        {a.aggregate == 0 ||
                                          a.interviewdate == ""
                                          ? "-"
                                          : `${a.aggregate}`}
                                      </div>

                                      {/* Cheat detection flag */}
                                      <div className="w-6 flex justify-center">
                                        {a?.cheatpercent > 50 ? (
                                          <div className="group relative">
                                            <img
                                              src={cheatflag}
                                              className="h-4"
                                              alt="flag"
                                            />
                                            <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem] group-hover:scale-100">
                                              <span className="truncate text-red-600">
                                                Unusual behaviour detected
                                              </span>
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="h-4 w-4"></div>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                )}

                                {/* Avg Rating */}
                                <td className="border-y p-2 text-center">
                                  <div className="flex justify-center">
                                    {!(
                                      Object.keys(
                                        a?.interviewrattingsobject || {},
                                      )?.length > 1
                                    ) ? (
                                      "-"
                                    ) : (
                                      <div className="bg-[#FFEBD6] group relative flex justify-center align-center rounded-sm w-[50%] gap-2">
                                        <p className="text-[#FE7F00] font-bold">
                                          {calculateAvgRating(
                                            a.interviewrattingsobject,
                                          )}
                                        </p>
                                        <img src={rattingstar} />
                                        <div className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                          {structuredClone(a.roundsinfo)
                                            .reverse()
                                            .map((i) => {
                                              if (!i.star) {
                                                return null;
                                              }
                                              return (
                                                <div className="mb-3">
                                                  {i.star ? (
                                                    <div className="flex justify-between items-center">
                                                      <div className="flex items-center gap-1">
                                                        <p className="font-semibold">
                                                          Round {i.roundfrom} :
                                                        </p>
                                                        <p>
                                                          {
                                                            i.functionalmanagername
                                                          }
                                                        </p>
                                                      </div>

                                                      <div className="bg-[#FFEBD6] group relative flex justify-center align-center rounded-sm w-1/4 gap-2">
                                                        <p className="text-[#FE7F00] font-bold">
                                                          {i.star}
                                                        </p>
                                                        <img
                                                          src={rattingstar}
                                                        />
                                                      </div>
                                                    </div>
                                                  ) : null}
                                                  <p className="text-ellipsis line-clamp-3">
                                                    {i.feedback ||
                                                      i.interviewSummary}
                                                  </p>
                                                </div>
                                              );
                                            })}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </td>
                                {/* Status */}
                                <td
                                  className={`border-y text-center font-medium px-2 py-[23px] max-w-[9rem] w-[9rem] break-words ${a.status === "Acceptance Awaited"
                                    ? "text-[#FE9933]"
                                    : a.status === "Accepted"
                                      ? "text-[#40B2B7E5]"
                                      : a.status === "Offer Rejected" ||
                                        a.status === "Offer Revoked"
                                        ? "text-[#E95060]"
                                        : // : a.status == "Joined"
                                        // ? "text-white absolute bg-[#40B2B7E5]"
                                        a.status === "Pending"
                                          ? "text-[#444D63]"
                                          : a.status === "Interviewed"
                                            ? "text-[#FE9933]"
                                            : a.status === "Selected"
                                              ? "text-[#40B2B7E5]"
                                              : a.status === "Rejected"
                                                ? "text-[#E95060]"
                                                : a.status === "Onhold"
                                                  ? "text-[#444D63]"
                                                  : a.status?.includes(
                                                    "Interviewed R",
                                                  )
                                                    ? "text-[#FE9933]"
                                                    : "text-[#FE9933]"
                                    }`}
                                >
                                  {a.status != "Joined" ? (
                                    <div className="flex items-center gap-px w-fit mx-auto">
                                      {a.status === "Pending"
                                        ? job.aiinterviewenabled
                                          ? "Pending AI Interview"
                                          : "Pending"
                                        : a.status === "Interviewed"
                                          ? "AI Interview"
                                          : a.status === "Selected"
                                            ? "Selected"
                                            : a.status === "Rejected"
                                              ? "Rejected"
                                              : a.status === "Onhold"
                                                ? "On-hold"
                                                : a.status?.includes(
                                                  "Interviewed R",
                                                )
                                                  ? "Round " +
                                                  a.status.split("R")[1]
                                                  : `${a.status}`}
                                      {a.resume_threshold_fails ? (
                                        <Tooltip tooltip="Experience Out of Range">
                                          <IoInformationCircle />
                                        </Tooltip>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  ) : (
                                    <div className="text-white w-fit mx-auto px-3 py-1 rounded-lg bg-[#40B2B7E5]">
                                      Joined
                                    </div>
                                  )}
                                </td>
                              </>
                            )}
                            {expandingRows &&
                              companyDetails?.professionalDetail && (
                                <td className="border-y text-center p-2 max-w-[8rem] break-words whitespace-normal">
                                  {a.isServingNotice || "-"}
                                </td>
                              )}
                            {/* Salary Fitment */}
                            <RoleBasedAccessControl>
                              <td className="border-y">
                                <div className="group relative  flex justify-center">
                                  <button>
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) < minSalary && (
                                        <div className="text-[#8F94A1]">
                                          <p className="text-[0.6rem]">
                                            Below Range
                                          </p>
                                          <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                            <div
                                              className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                              style={{ width: `33%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )}
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) >= minSalary &&
                                      parseInt(
                                        a?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", ""),
                                      ) <= maxSalary && (
                                        <div className="text-[#40B2B7]">
                                          <p className="text-[0.7rem]">
                                            Within Range
                                          </p>
                                          <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                            <div
                                              className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                              style={{ width: `50%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )}
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) > maxSalary && (
                                        <div className="text-[#E95060]">
                                          <p className="text-[0.7rem]">
                                            Above Range
                                          </p>
                                          <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                            <div
                                              className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                              style={{ width: `66%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )}
                                    {!a.expectedsalary && <p>-</p>}
                                  </button>
                                  {parseInt(
                                    a?.expectedsalary
                                      ?.split(" ")[1]
                                      ?.replaceAll(",", ""),
                                  ) < minSalary && (
                                      <div className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1] scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                        <p className="mb-1">
                                          <b>Current Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.currentsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                        <p>
                                          <b>Expected Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.expectedsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                      </div>
                                    )}
                                  {parseInt(
                                    a?.expectedsalary
                                      ?.split(" ")[1]
                                      ?.replaceAll(",", ""),
                                  ) >= minSalary &&
                                    parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) <= maxSalary && (
                                      <div className="absolute transition-all left-10 top-1-left text-left p-3 shadow-md z-20 border-2 border-[#40B2B7] scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                        <p className="mb-1">
                                          <b>Current Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.currentsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                        <p>
                                          <b>Expected Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.expectedsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                      </div>
                                    )}
                                  {parseInt(
                                    a?.expectedsalary
                                      ?.split(" ")[1]
                                      ?.replaceAll(",", ""),
                                  ) > maxSalary && (
                                      <div className="absolute transition-all left-10 top-1-left p-3 text-left shadow-md z-20 border-2 border-[#E95060] scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                        <p className="mb-1">
                                          <b>Current Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.currentsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                        <p>
                                          <b>Expected Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.expectedsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                      </div>
                                    )}
                                </div>
                              </td>
                            </RoleBasedAccessControl>
                            {/* Actions */}
                            <td className="border-y">
                              <Select
                                {...selectPortalToBodyProps}
                                styles={selectPortalStyles}
                                className="text-xs border-y"
                                onChange={(option) => {
                                  // setAction(option.value);
                                  // setActiveApplicant(a);
                                  // setOpenInterviewModal(true);
                                  shouldModalOpen(option, a);
                                }}
                                options={allAplicantTabOptions(
                                  a.status,
                                  a.roundsinfo,
                                  a,
                                )}
                              ></Select>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
                {tab == 1 && (
                  <div className="bg-[#F1F4FB] rounded-t-lg pt-2">
                    <div className="flex flex-wrap justify-start items-center ">
                      {/* changes needed here */}
                      {roundsMap["AI Interview"] !== undefined &&
                        roundsMap["AI Interview"] >= 0 ? (
                        <button
                          onClick={() => {
                            changeTabUpdateFilters(() =>
                              setActiveInterviewedTab(0),
                            );
                            dispatch(updateActiveInterviewedTab(0));
                          }}
                          className={
                            activeInterviewedTab == 0
                              ? "px-6 py-3 bg-white rounded-t-2xl"
                              : "px-6 py-3 bg-[#F1F4FB] rounded-t-2xl"
                          }
                        >
                          {" "}
                          AI Interview{" "}
                          <span className="bg-[#148EFF] text-white px-2 py-1 rounded-full">
                            {roundsMap["AI Interview"]}
                          </span>
                        </button>
                      ) : null}
                      {Object.keys(roundsMap)
                        .filter((r) => r !== "AI Interview" && r !== "Selected")
                        .map((r) => {
                          return (
                            <button
                              onClick={() => {
                                changeTabUpdateFilters(() =>
                                  setActiveInterviewedTab(
                                    parseInt(r.replace("Round ", "")),
                                  ),
                                );
                                dispatch(
                                  updateActiveInterviewedTab(
                                    parseInt(r.replace("Round ", "")),
                                  ),
                                );
                              }}
                              className={
                                activeInterviewedTab ==
                                  parseInt(r.replace("Round ", ""))
                                  ? "px-6 py-3 bg-white rounded-t-2xl"
                                  : "px-6 py-3 bg-[#F1F4FB] rounded-t-2xl"
                              }
                            >
                              {r}{" "}
                              <span className="bg-[#148EFF] text-white px-2 py-1 rounded-full">
                                {/* changed here */}
                                {roundsMap[r]}
                              </span>
                            </button>
                          );
                        })}
                      <button
                        onClick={() => {
                          changeTabUpdateFilters(() =>
                            setActiveInterviewedTab(99),
                          );
                          dispatch(updateActiveInterviewedTab(99));
                        }}
                        className={
                          activeInterviewedTab == 99
                            ? "px-6 py-3 bg-white rounded-t-2xl"
                            : "px-6 py-3 bg-[#F1F4FB] rounded-t-2xl"
                        }
                      >
                        Selected{" "}
                        <span className="bg-[#148EFF] text-white px-2 py-1 rounded-full">
                          {roundsMap["Selected"]}
                        </span>
                      </button>
                    </div>

                    {
                      {
                        0: (
                          <div className="pt-5 bg-white">
                            <div className="w-1/5 float-right mb-4">
                              <Select
                                onChange={(option) => {
                                  // setAction(option.value);
                                  // setActiveApplicant(a);
                                  // setOpenInterviewModal(true);
                                  // shouldModalOpen(option, a);

                                  if (option.value == "select") {
                                    setOpenSelectedModalForBulkInterviewed(
                                      true,
                                    );
                                  } else {
                                    bulkAiOptions(option.value);
                                  }
                                }}
                                className="text-[#148EFF] "
                                options={interviewedOptions("Interviewed")}
                              ></Select>
                            </div>
                            <Table>
                              <Thead className="text-center text-sm sticky font-semibold top-0 z-30  ">
                                <Tr>
                                  <Th className="border-y border-[#D2D4DA] py-5 px-4 text-center ">
                                    <input
                                      type="checkbox"
                                      checked={aiAllChecked}
                                      onClick={() => {
                                        setAiAllChecked(!aiAllChecked);
                                      }}
                                    ></input>
                                  </Th>
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left ">
                                    Applicant Name
                                  </Th>
                                  <Th
                                    onClick={() => {
                                      sortBy(
                                        "resumescore",
                                        allApplicants,
                                        (arr) => setAllApplicants(arr),
                                        resetPageOnSortChange,
                                      );
                                    }}
                                    className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                                  >
                                    <div className="flex items-center justify-center  space-x-4 w-full">
                                      Resume Score
                                      {sortedBy == "resumescore" && (
                                        <img
                                          src={union}
                                          className="w-3 h-3 ml-2"
                                        ></img>
                                      )}
                                    </div>
                                  </Th>
                                  <Th
                                    onClick={() => {
                                      sortBy(
                                        "aiscore",
                                        allApplicants,
                                        (arr) => setAllApplicants(arr),
                                        resetPageOnSortChange,
                                      );
                                    }}
                                    className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                                  >
                                    <div className="flex items-center justify-center  space-x-4 w-full">
                                      Employability Score
                                      {sortedBy == "aiscore" && (
                                        <img
                                          src={union}
                                          className="w-3 h-3 ml-2"
                                        ></img>
                                      )}
                                    </div>
                                  </Th>
                                  <Th
                                    onClick={() => {
                                      sortBy(
                                        "technicalscore",
                                        allApplicants,
                                        (arr) => setAllApplicants(arr),
                                        resetPageOnSortChange,
                                      );
                                    }}
                                    className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                                  >
                                    <div className="flex items-center justify-center  space-x-4 w-full">
                                      Technical Score
                                      {sortedBy == "technicalscore" && (
                                        <img
                                          src={union}
                                          className="w-3 h-3 ml-2"
                                        ></img>
                                      )}
                                    </div>
                                  </Th>
                                  <Th
                                    onClick={() => {
                                      sortBy(
                                        "voiceanalysisscore",
                                        allApplicants,
                                        (arr) => setAllApplicants(arr),
                                        resetPageOnSortChange,
                                      );
                                    }}
                                    className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                                  >
                                    <div className="flex items-center justify-center  space-x-4 w-full">
                                      Voice Score
                                      {sortedBy == "voiceanalysisscore" && (
                                        <img
                                          src={union}
                                          className="w-3 h-3 ml-2"
                                        ></img>
                                      )}
                                    </div>
                                  </Th>
                                  <Th
                                    onClick={() => {
                                      sortBy(
                                        "aggregate",
                                        allApplicants,
                                        (arr) => setAllApplicants(arr),
                                        resetPageOnSortChange,
                                      );
                                    }}
                                    className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                                  >
                                    <div className="flex items-center justify-center  space-x-4 w-full">
                                      Aggregate AI Score
                                      {sortedBy == "aggregate" && (
                                        <img
                                          src={union}
                                          className="w-3 h-3 ml-2"
                                        ></img>
                                      )}
                                    </div>
                                  </Th>
                                  <RoleBasedAccessControl>
                                    <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                      Salary Fitment
                                    </Th>
                                  </RoleBasedAccessControl>
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                    Actions
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {allApplicants.map((a) => {
                                  return (
                                    <Tr className="text-sm">
                                      <Td
                                        className={"border-y  text-center p-2"}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={handleAiInterviewCheck(
                                            selectedAiApplicants,
                                            a.uuid,
                                          )}
                                          onClick={() => {
                                            addAiCandidate(
                                              selectedAiApplicants,
                                              setSelectedAiApplicants,
                                              a,
                                            );
                                          }}
                                        ></input>
                                      </Td>
                                      <Td className="border-y p-2 text-left text-[#148EFF]">
                                        <div className="">
                                          <p className="flex items-center">
                                            <button
                                              className="text-left"
                                              onClick={() => {
                                                dispatch(
                                                  updateSortedBy(sortedBy),
                                                );
                                                dispatch(
                                                  updateCandidateFilters({
                                                    sourceFilter: sourceFilter,
                                                    fitmentFilter:
                                                      fitmentFilter,
                                                    timeToJoinFilter:
                                                      timeToJoinFilter,
                                                    preferredLocationFilter:
                                                      preferredLocationFilter,
                                                    startDate: startDate,
                                                    endDate: endDate,
                                                    updated: true,
                                                    page: pageDets.page,
                                                    page_size:
                                                      pageDets.page_size,
                                                  }),
                                                );
                                                navigate(
                                                  "/jobs/candidates/about",
                                                  {
                                                    state: {
                                                      uuid: a.uuid,
                                                      id: id,
                                                    },
                                                  },
                                                );
                                                // sessionStorage.setItem('currentPage', currentPage)
                                              }}
                                            >
                                              {a.name}
                                            </button>
                                            {([
                                              "northstarz.ai",
                                              "northstarz",
                                            ].includes(
                                              a?.source?.toLowerCase(),
                                            ) ||
                                              [
                                                "northstarz.ai",
                                                "northstarz",
                                              ].includes(
                                                a?.heardaboutus?.toLowerCase(),
                                              )) && (
                                                <div className="group relative">
                                                  <img
                                                    src={sparkle}
                                                    className="h-4 mx-1"
                                                    alt="sparkle"
                                                  ></img>
                                                  <div className="absolute transition-all left-3 top-3 text-left p-2 z-30 border-2 border-[#7C3AED] scale-0 rounded-lg bg-[#111827] w-[180px] shadow-lg text-[0.65rem] text-white group-hover:scale-100">
                                                    This candidate is sourced
                                                    through Northstarz Outreach
                                                    agent.
                                                  </div>
                                                </div>
                                              )}
                                            <div className="group relative">
                                              <img
                                                src={mail}
                                                className="h-4 mx-1"
                                              ></img>
                                              <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem]  group-hover:scale-100">
                                                <a
                                                  href={`mailto:${a.email}`}
                                                  className="truncate"
                                                >
                                                  {a.email}
                                                </a>
                                              </div>
                                            </div>
                                          </p>
                                          <p className="text-black text-xs my-1">
                                            {a.countrycode} {a.phone}
                                          </p>
                                        </div>
                                      </Td>
                                      <Td className="border-y  text-center p-2">
                                        {a.resumescore}
                                      </Td>
                                      <Td className="border-y  text-center p-2">
                                        {a.aiscore}
                                      </Td>
                                      <Td className="border-y text-center p-2">
                                        {a.technicalscore}
                                      </Td>
                                      <Td className="border-y text-center p-2">
                                        {a.voiceanalysisscore}
                                      </Td>
                                      <Td className="border-y text-center p-2">
                                        <div className="flex justify-center items-center">
                                          <div className="ml-2 ">
                                            {" "}
                                            {a.aggregate == 0 ||
                                              a.interviewdate == ""
                                              ? "-"
                                              : `${a.aggregate}`}
                                          </div>
                                          <div className="w-6 flex justify-center">
                                            {a?.cheatpercent > 50 ? (
                                              <div className="group relative">
                                                <img
                                                  src={cheatflag}
                                                  className="h-4"
                                                  alt="flag"
                                                />
                                                <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem] group-hover:scale-100">
                                                  <span className="truncate text-red-600">
                                                    Unusual behaviour detected
                                                  </span>
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="h-4 w-4"></div>
                                            )}
                                          </div>
                                        </div>
                                      </Td>
                                      <RoleBasedAccessControl>
                                        <Td className="border-y">
                                          <div className="group relative  flex justify-center">
                                            <button>
                                              {parseInt(
                                                a?.expectedsalary
                                                  ?.split(" ")[1]
                                                  ?.replaceAll(",", ""),
                                              ) < minSalary && (
                                                  <div className="text-[#8F94A1]">
                                                    <p className="text-[0.6rem]">
                                                      Below Range
                                                    </p>
                                                    <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                      <div
                                                        className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                        style={{ width: `33%` }}
                                                      ></div>
                                                    </div>
                                                  </div>
                                                )}
                                              {parseInt(
                                                a?.expectedsalary
                                                  ?.split(" ")[1]
                                                  ?.replaceAll(",", ""),
                                              ) >= minSalary &&
                                                parseInt(
                                                  a?.expectedsalary
                                                    ?.split(" ")[1]
                                                    ?.replaceAll(",", ""),
                                                ) <= maxSalary && (
                                                  <div className="text-[#40B2B7]">
                                                    <p className="text-[0.7rem]">
                                                      Within Range
                                                    </p>
                                                    <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                      <div
                                                        className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                        style={{ width: `50%` }}
                                                      ></div>
                                                    </div>
                                                  </div>
                                                )}
                                              {parseInt(
                                                a?.expectedsalary
                                                  ?.split(" ")[1]
                                                  ?.replaceAll(",", ""),
                                              ) > maxSalary && (
                                                  <div className="text-[#E95060]">
                                                    <p className="text-[0.7rem]">
                                                      Above Range
                                                    </p>
                                                    <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                      <div
                                                        className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                        style={{ width: `66%` }}
                                                      ></div>
                                                    </div>
                                                  </div>
                                                )}
                                              {!a.expectedsalary && <p>-</p>}
                                            </button>
                                            {parseInt(
                                              a?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", ""),
                                            ) < minSalary && (
                                                <div
                                                  textv
                                                  className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                                >
                                                  <p className="mb-1">
                                                    <b>Current Salary: </b>
                                                    {getCurrencySymbol(
                                                      companyCountryCode,
                                                    )}{" "}
                                                    {formatSalary(
                                                      a.currentsalary,
                                                      companyCountryCode,
                                                    )}
                                                  </p>
                                                  <p>
                                                    <b>Expected Salary: </b>
                                                    {getCurrencySymbol(
                                                      companyCountryCode,
                                                    )}{" "}
                                                    {formatSalary(
                                                      a.expectedsalary,
                                                      companyCountryCode,
                                                    )}
                                                  </p>
                                                </div>
                                              )}
                                            {parseInt(
                                              a?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", ""),
                                            ) > minSalary &&
                                              parseInt(
                                                a?.expectedsalary
                                                  ?.split(" ")[1]
                                                  ?.replaceAll(",", ""),
                                              ) < maxSalary && (
                                                <div
                                                  textv
                                                  className="absolute transition-all left-10 top-1-left text-left p-3 shadow-md z-20 border-2 border-[#40B2B7]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                                >
                                                  <p className="mb-1">
                                                    <b>Current Salary: </b>
                                                    {getCurrencySymbol(
                                                      companyCountryCode,
                                                    )}{" "}
                                                    {formatSalary(
                                                      a.currentsalary,
                                                      companyCountryCode,
                                                    )}
                                                  </p>
                                                  <p>
                                                    <b>Expected Salary: </b>
                                                    {getCurrencySymbol(
                                                      companyCountryCode,
                                                    )}{" "}
                                                    {formatSalary(
                                                      a.expectedsalary,
                                                      companyCountryCode,
                                                    )}
                                                  </p>
                                                </div>
                                              )}
                                            {parseInt(
                                              a?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", ""),
                                            ) > maxSalary && (
                                                <div
                                                  textv
                                                  className="absolute transition-all left-10 top-1-left p-3 text-left shadow-md z-20 border-2 border-[#E95060]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                                >
                                                  <p className="mb-1">
                                                    <b>Current Salary: </b>
                                                    {getCurrencySymbol(
                                                      companyCountryCode,
                                                    )}{" "}
                                                    {formatSalary(
                                                      a.currentsalary,
                                                      companyCountryCode,
                                                    )}
                                                  </p>
                                                  <p>
                                                    <b>Expected Salary: </b>
                                                    {getCurrencySymbol(
                                                      companyCountryCode,
                                                    )}{" "}
                                                    {formatSalary(
                                                      a.expectedsalary,
                                                      companyCountryCode,
                                                    )}
                                                  </p>
                                                </div>
                                              )}
                                          </div>
                                        </Td>
                                      </RoleBasedAccessControl>
                                      <Td>
                                        <Select
                                          {...selectPortalToBodyProps}
                                          styles={selectPortalStyles}
                                          onChange={(option) => {
                                            shouldModalOpen(option, a);
                                          }}
                                          options={allAplicantTabOptions(
                                            a.status,
                                            a.roundInfo,
                                            a,
                                          )}
                                        ></Select>
                                      </Td>
                                    </Tr>
                                  );
                                })}
                              </Tbody>
                            </Table>
                          </div>
                        ),
                      }[activeInterviewedTab]
                    }
                    {activeInterviewedTab > 0 && activeInterviewedTab < 99 && (
                      <div className="bg-white pt-5 text-sm">
                        {/* <div className="w-1/5 float-right mb-5">
                          <Select
                            onChange={(option) => {
                              // setAction(option.value);
                              // setActiveApplicant(a);
                              // setOpenInterviewModal(true);
                              // shouldModalOpen(option, a);
                              setAction(option.value);
                            }}
                            className="text-[#148EFF] "
                            options={interviewedOptions(
                              `Interviewed R${activeInterviewedTab}`
                            )}
                          ></Select>
                        </div> */}
                        <Table>
                          <Thead>
                            <Tr>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                <input
                                  type="checkbox"
                                  checked={roundAllChecked}
                                  onClick={() => {
                                    setRoundAllChecked(!roundAllChecked);
                                  }}
                                ></input>
                              </Th>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left ">
                                Applicant Name
                              </Th>
                              {job.aiinterviewenabled ? (
                                <Th
                                  onClick={() => {
                                    sortBy(
                                      "aggregate",
                                      allApplicants,
                                      (arr) => setAllApplicants(arr),
                                      resetPageOnSortChange,
                                    );
                                  }}
                                  className="border-y border-[#D2D4DA] py-5 px-2 text-center "
                                >
                                  <div className="flex items-center justify-center  space-x-4 w-full">
                                    Aggregate AI Score
                                    {sortedBy == "aggregate" && (
                                      <img
                                        src={union}
                                        className="w-3 h-3 ml-2"
                                      ></img>
                                    )}
                                  </div>
                                </Th>
                              ) : (
                                <Th
                                  onClick={() => {
                                    sortBy(
                                      "resumescore",
                                      allApplicants,
                                      (arr) => setAllApplicants(arr),
                                      resetPageOnSortChange,
                                    );
                                  }}
                                  className="border-y border-[#D2D4DA] py-5 px-2 text-center "
                                >
                                  <div className="flex items-center justify-center  space-x-4 w-full">
                                    Resume Score
                                    {sortedBy == "resumescore" && (
                                      <img
                                        src={union}
                                        className="w-3 h-3 ml-2"
                                      ></img>
                                    )}
                                  </div>
                                </Th>
                              )}
                              {((job?.aiinterviewenabled &&
                                activeInterviewedTab === 3) ||
                                (!job?.aiinterviewenabled &&
                                  activeInterviewedTab === 2)) && (
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                    Round {activeInterviewedTab - 1} rating
                                  </Th>
                                )}
                              {((job.aiinterviewenabled &&
                                activeInterviewedTab >= 4) ||
                                (!job.aiinterviewenabled &&
                                  activeInterviewedTab >= 3)) && (
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                    <div className="flex items-center justify-center  space-x-4 w-full">
                                      Average Rating
                                      {sortedBy == "avgRating" && (
                                        <img
                                          src={union}
                                          className="w-3 h-3 ml-2"
                                        ></img>
                                      )}
                                    </div>
                                  </Th>
                                )}
                              <RoleBasedAccessControl>
                                <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                  Salary Fitment
                                </Th>
                              </RoleBasedAccessControl>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                Interview Date
                              </Th>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                Interviewer
                              </Th>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                Actions
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {/* changes to be done here */}
                            {allApplicants?.map((a) => {
                              return (
                                <Tr className="text-sm">
                                  <Td className={"border-y  text-center p-2"}>
                                    <input
                                      type="checkbox"
                                      checked={handleAiInterviewCheck(
                                        selectedRoundApplicants,
                                        a.uuid,
                                      )}
                                      onClick={() => {
                                        addAiCandidate(
                                          selectedRoundApplicants,
                                          setSelectedRoundApplicants,
                                          a,
                                        );
                                      }}
                                    ></input>
                                  </Td>
                                  <Td className="border-y p-2 text-left text-[#148EFF]">
                                    <div className="">
                                      <p className="flex items-center">
                                        <button
                                          className="text-left"
                                          onClick={() => {
                                            dispatch(updateSortedBy(sortedBy));
                                            dispatch(
                                              updateCandidateFilters({
                                                sourceFilter: sourceFilter,
                                                fitmentFilter: fitmentFilter,
                                                timeToJoinFilter:
                                                  timeToJoinFilter,
                                                preferredLocationFilter:
                                                  preferredLocationFilter,
                                                startDate: startDate,
                                                endDate: endDate,
                                                updated: true,
                                                page: pageDets.page,
                                                page_size: pageDets.page_size,
                                              }),
                                            );
                                            navigate("/jobs/candidates/about", {
                                              state: { uuid: a.uuid, id: id },
                                            });
                                            // sessionStorage.setItem('currentPage', currentPage)
                                          }}
                                        >
                                          {a.name}
                                        </button>
                                        {([
                                          "northstarz.ai",
                                          "northstarz",
                                        ].includes(a?.source?.toLowerCase()) ||
                                          [
                                            "northstarz.ai",
                                            "northstarz",
                                          ].includes(
                                            a?.heardaboutus?.toLowerCase(),
                                          )) && (
                                            <div className="group relative">
                                              <img
                                                src={sparkle}
                                                className="h-4 mx-1"
                                                alt="sparkle"
                                              ></img>
                                              <div className="absolute transition-all left-3 top-3 text-left p-2 z-30 border-2 border-[#7C3AED] scale-0 rounded-lg bg-[#111827] w-[180px] shadow-lg text-[0.65rem] text-white group-hover:scale-100">
                                                Northstarz sourced applicant
                                              </div>
                                            </div>
                                          )}
                                        <div className="group relative">
                                          <img
                                            src={mail}
                                            className="h-4 mx-1"
                                          ></img>
                                          <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem]  group-hover:scale-100">
                                            <a
                                              href={`mailto:${a.email}`}
                                              className="truncate"
                                            >
                                              {a.email}
                                            </a>
                                          </div>
                                        </div>
                                      </p>
                                      <p className="text-black text-xs my-1">
                                        {a.countrycode} {a.phone}
                                      </p>
                                    </div>
                                  </Td>
                                  <Td className="border-y text-center p-2">
                                    <div className="flex justify-center items-center">
                                      {/* Show aggregate if AI interview enabled, else resume score */}
                                      <div className="ml-2">
                                        {job.aiinterviewenabled
                                          ? a.aggregate == 0 ||
                                            a.interviewdate == ""
                                            ? "-"
                                            : `${a.aggregate}`
                                          : a.resumescore == 0
                                            ? "-"
                                            : `${a.resumescore}`}
                                      </div>

                                      {/* Cheat detection flag */}
                                      <div className="w-6 flex justify-center">
                                        {a?.cheatpercent > 50 ? (
                                          <div className="group relative">
                                            <img
                                              src={cheatflag}
                                              className="h-4"
                                              alt="flag"
                                            />
                                            <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem] group-hover:scale-100">
                                              <span className="truncate text-red-600">
                                                Unusual behaviour detected
                                              </span>
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="h-4 w-4"></div>
                                        )}
                                      </div>
                                    </div>
                                  </Td>

                                  {((job?.aiinterviewenabled &&
                                    activeInterviewedTab === 3) ||
                                    (!job?.aiinterviewenabled &&
                                      activeInterviewedTab === 2)) && (
                                      <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                        <div className="flex justify-center">
                                          <div className="bg-[#FFEBD6] flex justify-center align-center rounded-sm w-[50%] gap-2">
                                            <p className="text-[#FE7F00] font-bold">
                                              {
                                                a.interviewrattingsobject[
                                                activeInterviewedTab - 1
                                                ]
                                              }
                                            </p>
                                            <img src={rattingstar} />
                                          </div>
                                          {/* {act} */}
                                        </div>
                                      </Th>
                                    )}
                                  {((job?.aiinterviewenabled &&
                                    activeInterviewedTab >= 4) ||
                                    (!job?.aiinterviewenabled &&
                                      activeInterviewedTab >= 3)) && (
                                      <Td className="border-y text-center p-2">
                                        <div className="flex justify-center">
                                          {!(
                                            Object.keys(
                                              a?.interviewrattingsobject,
                                            )?.length > 1
                                          ) ? (
                                            "-"
                                          ) : (
                                            <div className="bg-[#FFEBD6] relative group flex justify-center align-center rounded-sm w-[50%] gap-2">
                                              <p className="text-[#FE7F00] font-bold">
                                                {Math.round(
                                                  getAvgRatingForSort(
                                                    a,
                                                    activeInterviewedTab,
                                                    job?.aiinterviewenabled,
                                                  ),
                                                )}
                                              </p>
                                              <img src={rattingstar} />
                                              <div className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                                {structuredClone(a.roundsinfo)
                                                  .reverse()
                                                  .map((i) => {
                                                    if (!i.star) {
                                                      return null;
                                                    }
                                                    return (
                                                      <div className="mb-3">
                                                        {i.roundfrom != "1" && (
                                                          <div className="flex justify-between items-center">
                                                            <div className="flex items-center gap-1">
                                                              <p className="font-semibold">
                                                                Round{" "}
                                                                {i.roundfrom} :
                                                              </p>
                                                              <p>
                                                                {
                                                                  i.functionalmanagername
                                                                }
                                                              </p>
                                                            </div>

                                                            <div className="bg-[#FFEBD6] group relative flex justify-center align-center rounded-sm w-1/4 gap-2">
                                                              <p className="text-[#FE7F00] font-bold">
                                                                {i.star}
                                                              </p>
                                                              <img
                                                                src={rattingstar}
                                                              />
                                                            </div>
                                                          </div>
                                                        )}
                                                        <p>{i.feedback}</p>
                                                      </div>
                                                    );
                                                  })}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </Td>
                                    )}
                                  <RoleBasedAccessControl>
                                    <Td className="border-y">
                                      <div className="group relative flex justify-center">
                                        <button>
                                          {parseInt(
                                            a?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", ""),
                                          ) < minSalary && (
                                              <div className="text-[#8F94A1]">
                                                <p className="text-[0.6rem]">
                                                  Below Range
                                                </p>
                                                <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                  <div
                                                    className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                    style={{ width: `33%` }}
                                                  ></div>
                                                </div>
                                              </div>
                                            )}
                                          {parseInt(
                                            a?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", ""),
                                          ) >= minSalary &&
                                            parseInt(
                                              a?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", ""),
                                            ) <= maxSalary && (
                                              <div className="text-[#40B2B7]">
                                                <p className="text-[0.7rem]">
                                                  Within Range
                                                </p>
                                                <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                  <div
                                                    className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                    style={{ width: `50%` }}
                                                  ></div>
                                                </div>
                                              </div>
                                            )}
                                          {parseInt(
                                            a?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", ""),
                                          ) > maxSalary && (
                                              <div className="text-[#E95060]">
                                                <p className="text-[0.7rem]">
                                                  Above Range
                                                </p>
                                                <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                  <div
                                                    className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                    style={{ width: `66%` }}
                                                  ></div>
                                                </div>
                                              </div>
                                            )}
                                          {!a.expectedsalary && <p>-</p>}
                                        </button>
                                        {parseInt(
                                          a?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", ""),
                                        ) < minSalary && (
                                            <div
                                              textv
                                              className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                            >
                                              <p className="mb-1">
                                                <b>Current Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.currentsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                              <p>
                                                <b>Expected Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.expectedsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                            </div>
                                          )}
                                        {parseInt(
                                          a?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", ""),
                                        ) > minSalary &&
                                          parseInt(
                                            a?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", ""),
                                          ) < maxSalary && (
                                            <div
                                              textv
                                              className="absolute transition-all left-10 top-1-left text-left p-3 shadow-md z-20 border-2 border-[#40B2B7]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                            >
                                              <p className="mb-1">
                                                <b>Current Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.currentsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                              <p>
                                                <b>Expected Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.expectedsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                            </div>
                                          )}
                                        {parseInt(
                                          a?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", ""),
                                        ) > maxSalary && (
                                            <div
                                              textv
                                              className="absolute transition-all left-10 top-1-left p-3 text-left shadow-md z-20 border-2 border-[#E95060]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                            >
                                              <p className="mb-1">
                                                <b>Current Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.currentsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                              <p>
                                                <b>Expected Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.expectedsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                            </div>
                                          )}
                                      </div>
                                    </Td>
                                  </RoleBasedAccessControl>
                                  <Td className="text-center relative mx-auto items-center justify-center border-y">
                                    <div className="flex items-center justify-center gap-1.5 group">
                                      <div className="flex items-center">
                                        <MdOutlineDateRange
                                          className={`${dateFocused
                                            ? "text-[#FFFFFF]"
                                            : "text-[#8f94a1]"
                                            } w-5 h-5`}
                                        />
                                        {Array.isArray(a.roundsinfo) &&
                                          a.roundsinfo.length > 0 &&
                                          a.roundsinfo[a.roundsinfo.length - 1]
                                            .assigneedate !== "" ? (
                                          <span className="text-[14px] text-gray-700">
                                            {a.roundsinfo[
                                              a.roundsinfo.length - 1
                                            ].assigneedate
                                              ?.slice(0, 10)
                                              ?.split("-")
                                              ?.reverse()
                                              ?.join("-")}
                                          </span>
                                        ) : (
                                          <button
                                            className="single-date w-fit text-center justify-center px-2 h-9 flex items-center text-[#8f94a1] text-[14px]"
                                            onClick={() => {
                                              const isRoundInfoEmpty =
                                                !Array.isArray(a.roundsinfo) ||
                                                a.roundsinfo.length === 0;
                                              const lastRound =
                                                !isRoundInfoEmpty
                                                  ? a.roundsinfo[
                                                  a.roundsinfo.length - 1
                                                  ]
                                                  : null;

                                              if (
                                                isRoundInfoEmpty ||
                                                (lastRound &&
                                                  lastRound.assigneedate === "")
                                              ) {
                                                openScheduleDrawer(a, false);
                                              }

                                              setActiveRoundid(
                                                lastRound?.roundid,
                                              );
                                              setActiveApplicant(a);
                                              setCandidateEmail(a.email);
                                              setCandidateName(a.name || "");
                                              setCalenderCondition(false);
                                            }}
                                          >
                                            {"Select Date"}
                                          </button>
                                        )}
                                      </div>
                                      {Array.isArray(a.roundsinfo) &&
                                        a.roundsinfo.length > 0 &&
                                        a.roundsinfo[a.roundsinfo.length - 1]
                                          .assigneedate !== "" && (
                                          <button
                                            className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-gray-100 rounded text-blue-600"
                                            title="Reschedule Interview"
                                            onClick={() =>
                                              openScheduleDrawer(a, true)
                                            }
                                          >
                                            <FiEdit2 size={14} />
                                          </button>
                                        )}
                                    </div>
                                  </Td>

                                  <Td className="border-y px-4">
                                    <div className="flex h-full items-center justify-center gap-2">
                                      <div className="relative w-[17px] h-[17px] rounded-full bg-[#D2D4DA] overflow-hidden">
                                        <img
                                          src={pp}
                                          className="w-full h-full object-cover"
                                        />
                                      </div>
                                      {Array.isArray(a.roundsinfo) &&
                                        a.roundsinfo.length > 0 &&
                                        a.roundsinfo[a.roundsinfo.length - 1]
                                          .assignedInterviewerUuid &&
                                        a.roundsinfo[a.roundsinfo.length - 1]
                                          .assignedInterviewerUuid !== "" ? (
                                        a.roundsinfo[a.roundsinfo.length - 1]
                                          .assignedInterviewerName
                                      ) : (
                                        <div className="multi-select">
                                          <div className="flex items-center justify-center w-full h-full p-0">
                                            <div className="interviwer-div">
                                              <Select
                                                {...selectPortalToBodyProps}
                                                className="text-[14px] text-center"
                                                options={userOptions}
                                                defaultValue={
                                                  Array.isArray(a.roundsinfo) &&
                                                    a.roundsinfo.length > 0 &&
                                                    a.roundsinfo[
                                                      a.roundsinfo.length - 1
                                                    ].assignedInterviewerUuid
                                                    ? {
                                                      value:
                                                        a.roundsinfo[
                                                          a.roundsinfo
                                                            .length - 1
                                                        ]
                                                          .assignedInterviewerUuid,
                                                      label:
                                                        a.roundsinfo[
                                                          a.roundsinfo
                                                            .length - 1
                                                        ]
                                                          .assignedInterviewerName,
                                                    }
                                                    : null
                                                }
                                                onChange={(option) => {
                                                  setInterviewers({
                                                    ...interviewers,
                                                    [a.uuid]: option,
                                                  });
                                                  setHiringManager(option);
                                                }}
                                                menuPlacement="auto"
                                                styles={selectPortalStyles}
                                                placeholder="Select Interviewer"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </Td>

                                  <Td>
                                    <Select
                                      {...selectPortalToBodyProps}
                                      styles={selectPortalStyles}
                                      onChange={(option) => {
                                        setAction(option.value);
                                        setActiveApplicant(a);
                                        setOpenInterviewModal(true);
                                        // setInterviewDate(
                                        //   interviewDates.hasOwnProperty(a.uuid)
                                        //     ? interviewDates[a.uuid]
                                        //     : ""
                                        // );
                                      }}
                                      options={allAplicantTabOptions(
                                        a.status,
                                        a.roundsinfo,
                                        a,
                                      )}
                                    ></Select>
                                  </Td>
                                </Tr>
                              );
                            })}
                          </Tbody>
                        </Table>
                      </div>
                    )}
                    {activeInterviewedTab == 99 && (
                      <div className="bg-white pt-10">
                        <Table>
                          <Thead className="text-center text-sm sticky font-semibold top-0 z-30  bg-white">
                            <Tr>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left ">
                                Applicant Name
                              </Th>
                              {job.aiinterviewenabled ? (
                                <Th
                                  onClick={() => {
                                    sortBy(
                                      "aggregate",
                                      allApplicants,
                                      (arr) => setAllApplicants(arr),
                                      resetPageOnSortChange,
                                    );
                                  }}
                                  className="border-y text-center cursor-pointer border-[#D2D4DA] py-5 px-2  "
                                >
                                  <div className="flex items-center justify-center  space-x-4 w-full">
                                    Aggregate AI Score
                                    {sortedBy == "aggregate" && (
                                      <img
                                        src={union}
                                        className="w-3 h-3 ml-2"
                                      ></img>
                                    )}
                                  </div>
                                </Th>
                              ) : (
                                <Th
                                  onClick={() => {
                                    sortBy(
                                      "resumescore",
                                      allApplicants,
                                      (arr) => setAllApplicants(arr),
                                      resetPageOnSortChange,
                                    );
                                  }}
                                  className="border-y text-center cursor-pointer border-[#D2D4DA] py-5 px-2  "
                                >
                                  <div className="flex items-center justify-center  space-x-4 w-full">
                                    Resume Score
                                    {sortedBy == "resumescore" && (
                                      <img
                                        src={union}
                                        className="w-3 h-3 ml-2"
                                      ></img>
                                    )}
                                  </div>
                                </Th>
                              )}
                              {maxRo > 3 && (
                                <>
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                    Round {maxRo - 2} Rating
                                  </Th>
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                    Round {maxRo - 1} Rating
                                  </Th>
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                    Round {maxRo} Rating
                                  </Th>
                                </>
                              )}

                              {maxRo == 3 && (
                                <>
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                    Round {maxRo - 1} Rating
                                  </Th>
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                    Round {maxRo} Rating
                                  </Th>
                                </>
                              )}
                              {maxRo == 2 && (
                                <>
                                  <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                    Round {maxRo} Rating
                                  </Th>
                                </>
                              )}

                              <Th
                                onClick={() => {
                                  sortByAvgRating(
                                    allApplicants,
                                    setAllApplicants,
                                    activeInterviewedTab,
                                    job?.aiinterviewenabled,
                                    resetPageOnSortChange,
                                  );
                                }}
                                className="border-y cursor-pointer text-center border-[#D2D4DA] py-5 px-2 "
                              >
                                <div className="flex items-center justify-center  space-x-4 w-full">
                                  Average Rating
                                  {sortedBy == "avgRating" && (
                                    <img
                                      src={union}
                                      className="w-3 h-3 ml-2"
                                    ></img>
                                  )}
                                </div>
                              </Th>
                              <RoleBasedAccessControl>
                                <Th className="border-y  border-[#D2D4DA] py-5 px-2 text-center ">
                                  Salary Fitment
                                </Th>
                              </RoleBasedAccessControl>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                Actions
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody classNmae="bg-white">
                            {/* changes needs to be done here */}
                            {allApplicants.map((a) => {
                              return (
                                <Tr className="text-sm">
                                  <Td className="border-y p-2 text-left text-[#148EFF]">
                                    <div className="">
                                      <p className="flex items-center">
                                        <button
                                          className="text-left"
                                          onClick={() => {
                                            dispatch(updateSortedBy(sortedBy));
                                            dispatch(
                                              updateCandidateFilters({
                                                sourceFilter: sourceFilter,
                                                fitmentFilter: fitmentFilter,
                                                timeToJoinFilter:
                                                  timeToJoinFilter,
                                                preferredLocationFilter:
                                                  preferredLocationFilter,
                                                startDate: startDate,
                                                endDate: endDate,
                                                updated: true,
                                                page: pageDets.page,
                                                page_size: pageDets.page_size,
                                              }),
                                            );
                                            navigate("/jobs/candidates/about", {
                                              state: { uuid: a.uuid, id: id },
                                            });
                                            // sessionStorage.setItem('currentPage', currentPage)
                                          }}
                                        >
                                          {a.name}
                                        </button>
                                        {([
                                          "northstarz.ai",
                                          "northstarz",
                                        ].includes(a?.source?.toLowerCase()) ||
                                          [
                                            "northstarz.ai",
                                            "northstarz",
                                          ].includes(
                                            a?.heardaboutus?.toLowerCase(),
                                          )) && (
                                            <div className="group relative">
                                              <img
                                                src={sparkle}
                                                className="h-4 mx-1"
                                                alt="sparkle"
                                              ></img>
                                              <div className="absolute transition-all left-3 top-3 text-left p-2 z-30 border-2 border-[#7C3AED] scale-0 rounded-lg bg-[#111827] w-[180px] shadow-lg text-[0.65rem] text-white group-hover:scale-100">
                                                Northstarz sourced applicant
                                              </div>
                                            </div>
                                          )}
                                        <div className="group relative">
                                          <img
                                            src={mail}
                                            className="h-4 mx-1"
                                          ></img>
                                          <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem]  group-hover:scale-100">
                                            <a
                                              href={`mailto:${a.email}`}
                                              className="truncate"
                                            >
                                              {a.email}
                                            </a>
                                          </div>
                                        </div>
                                      </p>
                                      <p className="text-black text-xs my-1">
                                        {a.countrycode} {a.phone}
                                      </p>
                                    </div>
                                  </Td>
                                  <Td className="border-y text-center p-2">
                                    <div className="flex justify-center items-center">
                                      {/* Show aggregate if AI interview enabled, else resume score */}
                                      <div className="ml-2">
                                        {job.aiinterviewenabled
                                          ? a.aggregate == 0 ||
                                            a.interviewdate == ""
                                            ? "-"
                                            : `${a.aggregate}`
                                          : a.resumescore == 0
                                            ? "-"
                                            : `${a.resumescore}`}
                                      </div>

                                      {/* Cheat detection flag */}
                                      <div className="w-6 flex justify-center">
                                        {a?.cheatpercent > 50 ? (
                                          <div className="group relative">
                                            <img
                                              src={cheatflag}
                                              className="h-4"
                                              alt="flag"
                                            />
                                            <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem] group-hover:scale-100">
                                              <span className="truncate text-red-600">
                                                Unusual behaviour detected
                                              </span>
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="h-4 w-4"></div>
                                        )}
                                      </div>
                                    </div>
                                  </Td>

                                  {maxRo > 3 && (
                                    <>
                                      <Td className="border-y text-center p-2">
                                        {a.interviewrattingsobject.hasOwnProperty(
                                          maxRo - 3,
                                        )
                                          ? a.interviewrattingsobject[maxRo - 3]
                                          : "-"}
                                      </Td>
                                      <Td className="border-y text-center p-2">
                                        {a.interviewrattingsobject.hasOwnProperty(
                                          maxRo - 2,
                                        )
                                          ? a.interviewrattingsobject[maxRo - 2]
                                          : "-"}
                                      </Td>
                                      <Td className="border-y text-center p-2">
                                        {a.interviewrattingsobject.hasOwnProperty(
                                          maxRo - 1,
                                        )
                                          ? a.interviewrattingsobject[maxRo - 1]
                                          : "-"}
                                      </Td>
                                    </>
                                  )}

                                  {maxRo == 3 && (
                                    <>
                                      <Td className="border-y text-center p-2">
                                        {a.interviewrattingsobject.hasOwnProperty(
                                          maxRo - 2,
                                        )
                                          ? a.interviewrattingsobject[maxRo - 2]
                                          : "-"}
                                      </Td>
                                      <Td className="border-y text-center p-2">
                                        {a.interviewrattingsobject.hasOwnProperty(
                                          maxRo - 1,
                                        )
                                          ? a.interviewrattingsobject[maxRo - 1]
                                          : "-"}
                                      </Td>
                                    </>
                                  )}
                                  {roundNo == 2 && (
                                    <>
                                      <Td className="border-y text-center p-2">
                                        {a.interviewrattingsobject.hasOwnProperty(
                                          maxRo - 1,
                                        )
                                          ? a.interviewrattingsobject[maxRo - 1]
                                          : "-"}
                                      </Td>
                                    </>
                                  )}
                                  <Td className="border-y text-center p-2">
                                    <div className="flex justify-center">
                                      {!(
                                        Object.keys(a?.interviewrattingsobject)
                                          ?.length > 1
                                      ) ? (
                                        "-"
                                      ) : (
                                        <div className="bg-[#FFEBD6] group relative flex justify-center align-center rounded-sm w-[50%] gap-2">
                                          <p className="text-[#FE7F00] font-bold">
                                            {calculateAvgRating(
                                              a.interviewrattingsobject,
                                            )}
                                          </p>
                                          <img src={rattingstar} />
                                          <div className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                            {structuredClone(a.roundsinfo)
                                              .reverse()
                                              .map((i) => {
                                                if (!i.star) {
                                                  return null;
                                                }
                                                return (
                                                  <div className="mb-3">
                                                    {i.roundfrom != "1" && (
                                                      <div className="flex justify-between items-center">
                                                        <div className="flex items-center gap-1">
                                                          <p className="font-semibold">
                                                            Round {i.roundfrom}{" "}
                                                            :
                                                          </p>
                                                          <p>
                                                            {
                                                              i.functionalmanagername
                                                            }
                                                          </p>
                                                        </div>

                                                        <div className="bg-[#FFEBD6] group relative flex justify-center align-center rounded-sm w-1/4 gap-2">
                                                          <p className="text-[#FE7F00] font-bold">
                                                            {i.star}
                                                          </p>
                                                          <img
                                                            src={rattingstar}
                                                          />
                                                        </div>
                                                      </div>
                                                    )}
                                                    <p>{i.feedback}</p>
                                                  </div>
                                                );
                                              })}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </Td>
                                  <RoleBasedAccessControl>
                                    <Td className="border-y">
                                      <div className="group  flex justify-center">
                                        <button>
                                          {parseInt(
                                            a?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", ""),
                                          ) < minSalary && (
                                              <div className="text-[#8F94A1]">
                                                <p className="text-[0.6rem]">
                                                  Below Range
                                                </p>
                                                <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                  <div
                                                    className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                    style={{ width: `33%` }}
                                                  ></div>
                                                </div>
                                              </div>
                                            )}
                                          {parseInt(
                                            a?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", ""),
                                          ) >= minSalary &&
                                            parseInt(
                                              a?.expectedsalary
                                                ?.split(" ")[1]
                                                ?.replaceAll(",", ""),
                                            ) <= maxSalary && (
                                              <div className="text-[#40B2B7]">
                                                <p className="text-[0.7rem]">
                                                  Within Range
                                                </p>
                                                <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                  <div
                                                    className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                    style={{ width: `50%` }}
                                                  ></div>
                                                </div>
                                              </div>
                                            )}
                                          {parseInt(
                                            a?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", ""),
                                          ) > maxSalary && (
                                              <div className="text-[#E95060]">
                                                <p className="text-[0.7rem]">
                                                  Above Range
                                                </p>
                                                <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                                  <div
                                                    className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                    style={{ width: `66%` }}
                                                  ></div>
                                                </div>
                                              </div>
                                            )}
                                          {!a.expectedsalary && <p>-</p>}
                                        </button>
                                        {parseInt(
                                          a?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", ""),
                                        ) < minSalary && (
                                            <div
                                              textv
                                              className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                            >
                                              <p className="mb-1">
                                                <b>Current Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.currentsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                              <p>
                                                <b>Expected Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.expectedsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                            </div>
                                          )}
                                        {parseInt(
                                          a?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", ""),
                                        ) > minSalary &&
                                          parseInt(
                                            a?.expectedsalary
                                              ?.split(" ")[1]
                                              ?.replaceAll(",", ""),
                                          ) < maxSalary && (
                                            <div
                                              textv
                                              className="absolute transition-all left-10 top-1-left text-left p-3 shadow-md z-20 border-2 border-[#40B2B7]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                            >
                                              <p className="mb-1">
                                                <b>Current Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.currentsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                              <p>
                                                <b>Expected Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.expectedsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                            </div>
                                          )}
                                        {parseInt(
                                          a?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", ""),
                                        ) > maxSalary && (
                                            <div
                                              textv
                                              className="absolute transition-all left-10 top-1-left p-3 text-left shadow-md z-20 border-2 border-[#E95060]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                            >
                                              <p className="mb-1">
                                                <b>Current Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.currentsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                              <p>
                                                <b>Expected Salary: </b>
                                                {getCurrencySymbol(
                                                  companyCountryCode,
                                                )}{" "}
                                                {formatSalary(
                                                  a.expectedsalary,
                                                  companyCountryCode,
                                                )}
                                              </p>
                                            </div>
                                          )}
                                      </div>
                                    </Td>
                                  </RoleBasedAccessControl>
                                  <Td>
                                    <Select
                                      {...selectPortalToBodyProps}
                                      styles={selectPortalStyles}
                                      options={allAplicantTabOptions(
                                        a.status,
                                        a.roundInfo,
                                        a,
                                      )}
                                      onChange={(option) => {
                                        // setAction(option.value);
                                        // setActiveApplicant(a);
                                        // setOpenInterviewModal(true);
                                        shouldModalOpen(option, a);
                                      }}
                                    ></Select>
                                  </Td>
                                </Tr>
                              );
                            })}
                          </Tbody>
                        </Table>
                      </div>
                    )}
                  </div>
                )}
                {tab == 2 && (
                  <Table>
                    <Thead className="text-center text-sm sticky font-semibold top-0 z-30  bg-white">
                      <Tr>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left ">
                          Applicant Name
                        </Th>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Applied On
                        </Th>
                        {job.aiinterviewenabled ? (
                          <Th
                            onClick={() => {
                              sortBy(
                                "aggregate",
                                allApplicants,
                                (arr) => setAllApplicants(arr),
                                resetPageOnSortChange,
                              );
                            }}
                            className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                          >
                            <div className="flex items-center justify-center  space-x-4 w-full">
                              Aggregate AI Score
                              {sortedBy == "aggregate" && (
                                <img src={union} className="w-3 h-3 ml-2"></img>
                              )}
                            </div>
                          </Th>
                        ) : (
                          <Th
                            onClick={() => {
                              sortBy(
                                "resumescore",
                                allApplicants,
                                (arr) => setAllApplicants(arr),
                                resetPageOnSortChange,
                              );
                            }}
                            className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                          >
                            <div className="flex items-center justify-center  space-x-4 w-full">
                              Resume Score
                              {sortedBy == "resumescore" && (
                                <img src={union} className="w-3 h-3 ml-2"></img>
                              )}
                            </div>
                          </Th>
                        )}
                        <Th
                          onClick={() => {
                            sortByAvgRating(
                              allApplicants,
                              setAllApplicants,
                              activeInterviewedTab,
                              job?.aiinterviewenabled,
                              resetPageOnSortChange,
                            );
                          }}
                          className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                        >
                          <div className="flex items-center justify-center  space-x-4 w-full">
                            Average Rating
                            {sortedBy == "avgRating" && (
                              <img src={union} className="w-3 h-3 ml-2"></img>
                            )}
                          </div>
                        </Th>
                        <RoleBasedAccessControl>
                          <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                            Salary Fitment
                          </Th>
                        </RoleBasedAccessControl>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Current Status
                        </Th>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Actions
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {allApplicants.map((a) => {
                        return (
                          <Tr className="text-sm">
                            <Td className="border-y p-2 text-left text-[#148EFF]">
                              <div className="">
                                <p className="flex items-center">
                                  <button
                                    className="text-left"
                                    onClick={() => {
                                      dispatch(updateSortedBy(sortedBy));
                                      dispatch(
                                        updateCandidateFilters({
                                          sourceFilter: sourceFilter,
                                          fitmentFilter: fitmentFilter,
                                          timeToJoinFilter: timeToJoinFilter,
                                          preferredLocationFilter:
                                            preferredLocationFilter,
                                          startDate: startDate,
                                          endDate: endDate,
                                          updated: true,
                                          page: pageDets.page,
                                          page_size: pageDets.page_size,
                                        }),
                                      );
                                      navigate("/jobs/candidates/about", {
                                        state: { uuid: a.uuid, id: id },
                                      });
                                      // sessionStorage.setItem('currentPage', currentPage)
                                    }}
                                  >
                                    {a.name}
                                  </button>
                                  {(["northstarz.ai", "northstarz"].includes(
                                    a?.source?.toLowerCase(),
                                  ) ||
                                    ["northstarz.ai", "northstarz"].includes(
                                      a?.heardaboutus?.toLowerCase(),
                                    )) && (
                                      <div className="group relative">
                                        <img
                                          src={sparkle}
                                          className="h-4 mx-1"
                                          alt="sparkle"
                                        ></img>
                                        <div className="absolute transition-all left-3 top-3 text-left p-2 z-30 border-2 border-[#7C3AED] scale-0 rounded-lg bg-[#111827] w-[180px] shadow-lg text-[0.65rem] text-white group-hover:scale-100">
                                          Northstarz sourced applicant
                                        </div>
                                      </div>
                                    )}
                                  <div className="group relative">
                                    <img src={mail} className="h-4 mx-1"></img>
                                    <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem]  group-hover:scale-100">
                                      <a
                                        href={`mailto:${a.email}`}
                                        className="truncate"
                                      >
                                        {a.email}
                                      </a>
                                    </div>
                                  </div>
                                </p>
                                <p className="text-black text-xs my-1">
                                  {a.countrycode} {a.phone}
                                </p>
                              </div>
                            </Td>
                            <Td className="border-y px-[20px] py-4 text-center  ">
                              {(() => {
                                const date = new Date(a.createdat);

                                const year = date.getFullYear();
                                const month = String(
                                  date.getMonth() + 1,
                                ).padStart(2, "0"); // Months are zero-based
                                const day = String(date.getDate()).padStart(
                                  2,
                                  "0",
                                );
                                const formattedDate = `${year}-${month}-${day}`;

                                return formattedDate;
                              })()}
                            </Td>
                            <Td className="border-y text-center p-2">
                              <div className="flex justify-center items-center">
                                {/* Show aggregate if AI interview enabled, else resume score */}
                                <div className="ml-2">
                                  {job.aiinterviewenabled
                                    ? a.aggregate == 0 || a.interviewdate == ""
                                      ? "-"
                                      : `${a.aggregate}`
                                    : a.resumescore == 0
                                      ? "-"
                                      : `${a.resumescore}`}
                                </div>

                                {/* Cheat detection flag */}
                                <div className="w-6 flex justify-center">
                                  {a?.cheatpercent > 50 ? (
                                    <div className="group relative">
                                      <img
                                        src={cheatflag}
                                        className="h-4"
                                        alt="flag"
                                      />
                                      <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem] group-hover:scale-100">
                                        <span className="truncate text-red-600">
                                          Unusual behaviour detected
                                        </span>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="h-4 w-4"></div>
                                  )}
                                </div>
                              </div>
                            </Td>

                            <Td className="border-y p-2 text-center">
                              <div className="flex justify-center">
                                {!(
                                  Object.keys(a?.interviewrattingsobject)
                                    ?.length > 1
                                ) ? (
                                  "-"
                                ) : (
                                  <div className="bg-[#FFEBD6] relative group flex justify-center align-center rounded-sm w-[50%] gap-2">
                                    <p className="text-[#FE7F00] font-bold">
                                      {calculateAvgRating(
                                        a.interviewrattingsobject,
                                      )}
                                    </p>
                                    <img src={rattingstar} />
                                    <div className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                      {structuredClone(a.roundsinfo)
                                        .reverse()
                                        .map((i) => {
                                          if (!i.star) {
                                            return null;
                                          }
                                          return (
                                            <div className="mb-3">
                                              {i.roundfrom != "1" && (
                                                <div className="flex justify-between items-center">
                                                  <div className="flex items-center gap-1">
                                                    <p className="font-semibold">
                                                      Round {i.roundfrom} :
                                                    </p>
                                                    <p>
                                                      {i.functionalmanagername}
                                                    </p>
                                                  </div>

                                                  <div className="bg-[#FFEBD6] group relative flex justify-center align-center rounded-sm w-1/4 gap-2">
                                                    <p className="text-[#FE7F00] font-bold">
                                                      {i.star}
                                                    </p>
                                                    <img src={rattingstar} />
                                                  </div>
                                                </div>
                                              )}
                                              <p>{i.feedback}</p>
                                            </div>
                                          );
                                        })}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </Td>
                            <RoleBasedAccessControl>
                              <Td className="border-y">
                                <div className="group relative flex justify-center">
                                  <button>
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) < minSalary && (
                                        <div className="text-[#8F94A1]">
                                          <p className="text-[0.6rem]">
                                            Below Range
                                          </p>
                                          <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                            <div
                                              className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                              style={{ width: `33%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )}
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) >= minSalary &&
                                      parseInt(
                                        a?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", ""),
                                      ) <= maxSalary && (
                                        <div className="text-[#40B2B7]">
                                          <p className="text-[0.7rem]">
                                            Within Range
                                          </p>
                                          <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                            <div
                                              className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                              style={{ width: `50%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )}
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) > maxSalary && (
                                        <div className="text-[#E95060]">
                                          <p className="text-[0.7rem]">
                                            Above Range
                                          </p>
                                          <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                            <div
                                              className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                              style={{ width: `66%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )}
                                    {!a.expectedsalary && <p>-</p>}
                                  </button>
                                  {parseInt(
                                    a?.expectedsalary
                                      ?.split(" ")[1]
                                      ?.replaceAll(",", ""),
                                  ) < minSalary && (
                                      <div
                                        textv
                                        className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                      >
                                        <p className="mb-1">
                                          <b>Current Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.currentsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                        <p>
                                          <b>Expected Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.expectedsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                      </div>
                                    )}
                                  {parseInt(
                                    a?.expectedsalary
                                      ?.split(" ")[1]
                                      ?.replaceAll(",", ""),
                                  ) > minSalary &&
                                    parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) < maxSalary && (
                                      <div
                                        textv
                                        className="absolute transition-all left-10 top-1-left text-left p-3 shadow-md z-20 border-2 border-[#40B2B7]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                      >
                                        <p className="mb-1">
                                          <b>Current Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.currentsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                        <p>
                                          <b>Expected Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.expectedsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                      </div>
                                    )}
                                  {parseInt(
                                    a?.expectedsalary
                                      ?.split(" ")[1]
                                      ?.replaceAll(",", ""),
                                  ) > maxSalary && (
                                      <div
                                        textv
                                        className="absolute transition-all left-10 top-1-left p-3 text-left shadow-md z-20 border-2 border-[#E95060]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                      >
                                        <p className="mb-1">
                                          <b>Current Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.currentsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                        <p>
                                          <b>Expected Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.expectedsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                      </div>
                                    )}
                                </div>
                              </Td>
                            </RoleBasedAccessControl>
                            <Td
                              className={`border-y text-center font-medium px-4 py-[23px] ${a.status === "Pending"
                                ? "text-[#444D63]"
                                : a.status === "Interviewed"
                                  ? "text-[#FE9933]"
                                  : a.status === "Selected"
                                    ? "text-[#40B2B7E5]"
                                    : a.status === "Rejected"
                                      ? "text-[#E95060]"
                                      : a.status === "Onhold"
                                        ? "text-[#444D63]"
                                        : a.status?.includes("Interviewed R")
                                          ? "text-[#FE9933]"
                                          : "text-[#FE9933]"
                                }`}
                            >
                              {a.status === "Pending"
                                ? "Application"
                                : a.status === "Interviewed"
                                  ? "AI Interview"
                                  : a.status === "Selected"
                                    ? "Selected"
                                    : a.status === "Rejected"
                                      ? "Rejected"
                                      : a.status === "Onhold"
                                        ? "On-hold"
                                        : a.status?.includes("Interviewed R")
                                          ? "Round " + a.status.split("R")[1]
                                          : `${a.status}`}
                            </Td>
                            <Td className="border-y">
                              <Select
                                {...selectPortalToBodyProps}
                                styles={selectPortalStyles}
                                className="text-xs border-y"
                                onChange={(option) => {
                                  // setAction(option.value);
                                  // setActiveApplicant(a);
                                  // setOpenInterviewModal(true);
                                  shouldModalOpen(option, a);
                                }}
                                options={allAplicantTabOptions(
                                  a.status,
                                  a.roundsinfo,
                                  a,
                                )}
                              ></Select>
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                )}
                {tab == 3 && (
                  <Table>
                    <Thead className="text-center text-sm sticky font-semibold top-0 z-30  bg-white">
                      <Tr>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          <input
                            type="checkbox"
                            checked={hiredChecked}
                            onChange={() => setHiredChecked(!hiredChecked)}
                          ></input>
                        </Th>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left ">
                          Applicant Name
                        </Th>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Department
                        </Th>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Salary Offered
                        </Th>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Date of joining
                        </Th>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Diversity
                        </Th>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Offer Status
                        </Th>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Actions
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {allApplicants.map((a) => {
                        return (
                          <Tr className="text-sm">
                            <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                              <input
                                type="checkbox"
                                checked={handleAllApplicantCheck(
                                  selectedHired,
                                  a.uuid,
                                )}
                                onChange={() =>
                                  addCandidate(
                                    selectedHired,
                                    setSelectedHired,
                                    a.uuid,
                                  )
                                }
                              ></input>
                            </Th>
                            <Td className="border-y p-2 text-left text-[#148EFF]">
                              <div className="">
                                <p className="flex items-center">
                                  <button
                                    className="text-left"
                                    onClick={() => {
                                      dispatch(updateSortedBy(sortedBy));
                                      dispatch(
                                        updateCandidateFilters({
                                          sourceFilter: sourceFilter,
                                          fitmentFilter: fitmentFilter,
                                          timeToJoinFilter: timeToJoinFilter,
                                          preferredLocationFilter:
                                            preferredLocationFilter,
                                          startDate: startDate,
                                          endDate: endDate,
                                          updated: true,
                                          page: pageDets.page,
                                          page_size: pageDets.page_size,
                                        }),
                                      );
                                      navigate("/jobs/candidates/about", {
                                        state: { uuid: a.uuid, id: id },
                                      });
                                      // sessionStorage.setItem('currentPage', currentPage)
                                    }}
                                  >
                                    {a.name}
                                  </button>
                                  {(["northstarz.ai", "northstarz"].includes(
                                    a?.source?.toLowerCase(),
                                  ) ||
                                    ["northstarz.ai", "northstarz"].includes(
                                      a?.heardaboutus?.toLowerCase(),
                                    )) && (
                                      <div className="group relative">
                                        <img
                                          src={sparkle}
                                          className="h-4 mx-1"
                                          alt="sparkle"
                                        ></img>
                                        <div className="absolute transition-all left-3 top-3 text-left p-2 z-30 border-2 border-[#7C3AED] scale-0 rounded-lg bg-[#111827] w-[180px] shadow-lg text-[0.65rem] text-white group-hover:scale-100">
                                          Northstarz sourced applicant
                                        </div>
                                      </div>
                                    )}
                                  <div className="group relative">
                                    <img src={mail} className="h-4 mx-1"></img>
                                    <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem]  group-hover:scale-100">
                                      <a
                                        href={`mailto:${a.email}`}
                                        className="truncate"
                                      >
                                        {a.email}
                                      </a>
                                    </div>
                                  </div>
                                </p>
                                <p className="text-black text-xs my-1">
                                  {a.countrycode} {a.phone}
                                </p>
                              </div>
                            </Td>
                            <Td className="border-y text-center p-2">
                              {a.department}
                            </Td>
                            <Td className="border-y text-center p-2">
                              {userPrivilege !== "Hiring Manager"
                                ? a.salaryoffered
                                : ""}
                            </Td>

                            <Td className="border-y text-center p-2">
                              {formatDateInIst(a.joiningdate)}
                            </Td>
                            <Td className="border-y text-center p-2">
                              {
                                {
                                  M: "Male",
                                  F: "Female",
                                  O: "Others",
                                }[a.gender]
                              }
                            </Td>
                            <Td
                              className={`border-y text-center relative font-medium px-4 py-[23px] ${a.status === "Acceptance Awaited"
                                ? "text-[#FE9933]"
                                : a.status === "Accepted"
                                  ? "text-[#40B2B7E5]"
                                  : a.status === "Offer Rejected" ||
                                    a.status === "Offer Revoked"
                                    ? "text-[#E95060]"
                                    : // : a.status == "Joined"
                                    // ? "text-white absolute bg-[#40B2B7E5]"
                                    "text-[#FE9933]"
                                }`}
                            >
                              {a.status != "Joined" ? (
                                `${a.status}`
                              ) : (
                                <div className="text-white w-fit mx-auto px-3 py-1 rounded-lg bg-[#40B2B7E5]">
                                  Joined
                                </div>
                              )}
                            </Td>
                            <Td className="border-y p-2">
                              <Select
                                {...selectPortalToBodyProps}
                                styles={selectPortalStyles}
                                onChange={(option) => {
                                  shouldModalOpen(option, a);
                                }}
                                options={allAplicantTabOptions(
                                  a.status,
                                  a.roundsinfo,
                                  a,
                                )}
                              ></Select>
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                )}
                {tab == 4 && (
                  <Table>
                    <Thead className="text-center text-sm sticky font-semibold top-0 z-30  bg-white">
                      <Tr>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left ">
                          Applicant Name
                        </Th>
                        <Th
                          onClick={() => {
                            sortBy(
                              "aggregate",
                              allApplicants,
                              (arr) => setAllApplicants(arr),
                              resetPageOnSortChange,
                            );
                          }}
                          className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                        >
                          <div className="flex items-center justify-center  space-x-4 w-full">
                            Aggregate AI Score
                            {sortedBy == "aggregate" && (
                              <img src={union} className="w-3 h-3 ml-2"></img>
                            )}
                          </div>
                        </Th>
                        {maxRo > 2 && (
                          <>
                            <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                              Round {maxRo - 1} Rating
                            </Th>
                            <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                              Round {maxRo} Rating
                            </Th>
                          </>
                        )}
                        {maxRo == 2 && (
                          <>
                            <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                              Round {maxRo} Rating
                            </Th>
                          </>
                        )}
                        <RoleBasedAccessControl>
                          <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                            Salary Fitment
                          </Th>
                        </RoleBasedAccessControl>
                        <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                          Actions
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {allApplicants.map((a) => {
                        return (
                          <Tr className="text-sm">
                            <Td className="border-y p-2 text-left text-[#148EFF]">
                              <div className="">
                                <p className="flex items-center">
                                  <button
                                    className="text-left"
                                    onClick={() => {
                                      dispatch(updateSortedBy(sortedBy));
                                      dispatch(
                                        updateCandidateFilters({
                                          sourceFilter: sourceFilter,
                                          fitmentFilter: fitmentFilter,
                                          timeToJoinFilter: timeToJoinFilter,
                                          preferredLocationFilter:
                                            preferredLocationFilter,
                                          startDate: startDate,
                                          endDate: endDate,
                                          updated: true,
                                          page: pageDets.page,
                                          page_size: pageDets.page_size,
                                        }),
                                      );
                                      navigate("/jobs/candidates/about", {
                                        state: { uuid: a.uuid, id: id },
                                      });
                                      // sessionStorage.setItem('currentPage', currentPage)
                                    }}
                                  >
                                    {a.name}
                                  </button>
                                  {(["northstarz.ai", "northstarz"].includes(
                                    a?.source?.toLowerCase(),
                                  ) ||
                                    ["northstarz.ai", "northstarz"].includes(
                                      a?.heardaboutus?.toLowerCase(),
                                    )) && (
                                      <div className="group relative">
                                        <img
                                          src={sparkle}
                                          className="h-4 mx-1"
                                          alt="sparkle"
                                        ></img>
                                        <div className="absolute transition-all left-3 top-3 text-left p-2 z-30 border-2 border-[#7C3AED] scale-0 rounded-lg bg-[#111827] w-[180px] shadow-lg text-[0.65rem] text-white group-hover:scale-100">
                                          Northstarz sourced applicant
                                        </div>
                                      </div>
                                    )}
                                  <div className="group relative">
                                    <img src={mail} className="h-4 mx-1"></img>
                                    <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem]  group-hover:scale-100">
                                      <a
                                        href={`mailto:${a.email}`}
                                        className="truncate"
                                      >
                                        {a.email}
                                      </a>
                                    </div>
                                  </div>
                                </p>
                                <p className="text-black text-xs my-1">
                                  {a.countrycode} {a.phone}
                                </p>
                              </div>
                            </Td>
                            <Td className="border-y text-center p-2">
                              <div className="flex justify-center items-center">
                                {/* Show aggregate or "-" if empty/zero */}
                                <div className="ml-2">
                                  {a.aggregate == 0 || a.interviewdate == ""
                                    ? "-"
                                    : `${a.aggregate}`}
                                </div>

                                {/* Cheat detection flag */}
                                <div className="w-6 flex justify-center">
                                  {a?.cheatpercent > 50 ? (
                                    <div className="group relative">
                                      <img
                                        src={cheatflag}
                                        className="h-4"
                                        alt="flag"
                                      />
                                      <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem] group-hover:scale-100">
                                        <span className="truncate text-red-600">
                                          Unusual behaviour detected
                                        </span>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="h-4 w-4"></div>
                                  )}
                                </div>
                              </div>
                            </Td>

                            {maxRo > 2 && (
                              <>
                                <Td className="border-y text-center p-2">
                                  {a.interviewrattingsobject.hasOwnProperty(
                                    maxRo - 2,
                                  )
                                    ? a.interviewrattingsobject[maxRo - 2]
                                    : "-"}
                                </Td>
                                <Td className="border-y text-center p-2">
                                  {a.interviewrattingsobject.hasOwnProperty(
                                    maxRo - 1,
                                  )
                                    ? a.interviewrattingsobject[maxRo - 1]
                                    : "-"}
                                </Td>
                              </>
                            )}
                            {maxRo == 2 && (
                              <>
                                <Td className="border-y text-center p-2">
                                  {a.interviewrattingsobject.hasOwnProperty(
                                    maxRo - 1,
                                  )
                                    ? a.interviewrattingsobject[maxRo - 1]
                                    : "-"}
                                </Td>
                              </>
                            )}
                            <RoleBasedAccessControl>
                              <Td className="border-y text-center p-2">
                                <div className="group relative flex justify-center">
                                  <button>
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) < minSalary && (
                                        <div className="text-[#8F94A1]">
                                          <p className="text-[0.6rem]">
                                            Below Range
                                          </p>
                                          <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                            <div
                                              className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                              style={{ width: `33%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )}
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) >= minSalary &&
                                      parseInt(
                                        a?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", ""),
                                      ) <= maxSalary && (
                                        <div className="text-[#40B2B7]">
                                          <p className="text-[0.7rem]">
                                            Within Range
                                          </p>
                                          <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                            <div
                                              className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                              style={{ width: `50%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )}
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) > maxSalary && (
                                        <div className="text-[#E95060]">
                                          <p className="text-[0.7rem]">
                                            Above Range
                                          </p>
                                          <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                            <div
                                              className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                              style={{ width: `66%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )}
                                    {!a.expectedsalary && <p>-</p>}
                                  </button>
                                  {parseInt(
                                    a?.expectedsalary
                                      ?.split(" ")[1]
                                      ?.replaceAll(",", ""),
                                  ) < minSalary && (
                                      <div
                                        textv
                                        className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                      >
                                        <p className="mb-1">
                                          <b>Current Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.currentsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                        <p>
                                          <b>Expected Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.expectedsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                      </div>
                                    )}
                                  {parseInt(
                                    a?.expectedsalary
                                      ?.split(" ")[1]
                                      ?.replaceAll(",", ""),
                                  ) > minSalary &&
                                    parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) < maxSalary && (
                                      <div
                                        textv
                                        className="absolute transition-all left-10 top-1-left text-left p-3 shadow-md z-20 border-2 border-[#40B2B7]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                      >
                                        <p className="mb-1">
                                          <b>Current Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.currentsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                        <p>
                                          <b>Expected Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.expectedsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                      </div>
                                    )}
                                  {parseInt(
                                    a?.expectedsalary
                                      ?.split(" ")[1]
                                      ?.replaceAll(",", ""),
                                  ) > maxSalary && (
                                      <div
                                        textv
                                        className="absolute transition-all left-10 top-1-left p-3 text-left shadow-md z-20 border-2 border-[#E95060]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                      >
                                        <p className="mb-1">
                                          <b>Current Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.currentsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                        <p>
                                          <b>Expected Salary: </b>
                                          {getCurrencySymbol(
                                            companyCountryCode,
                                          )}{" "}
                                          {formatSalary(
                                            a.expectedsalary,
                                            companyCountryCode,
                                          )}
                                        </p>
                                      </div>
                                    )}
                                </div>
                              </Td>
                            </RoleBasedAccessControl>
                            <Td className="border-y p-2">
                              <Select
                                {...selectPortalToBodyProps}
                                styles={selectPortalStyles}
                                className=" "
                                onChange={(option) => {
                                  // setAction(option.value);
                                  // setActiveApplicant(a);
                                  // setOpenInterviewModal(true);
                                  shouldModalOpen(option, a);
                                }}
                                options={allAplicantTabOptions(
                                  a.status,
                                  a.roundsinfo,
                                  a,
                                )}
                              ></Select>
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                )}
                {tab == 5 && (
                  <div>
                    <Table>
                      <Thead className="text-center text-sm sticky font-semibold top-0 z-30  bg-white">
                        <Tr>
                          <Th className="border-y border-[#D2D4DA] py-5 px-2 text-left ">
                            Applicant Name
                          </Th>
                          <Th
                            onClick={() =>
                              sortBy(
                                "aggregate",
                                allApplicants,
                                (arr) => setAllApplicants(arr),
                                resetPageOnSortChange,
                              )
                            }
                            className="border-y cursor-pointer border-[#D2D4DA] py-5 px-2 text-center "
                          >
                            <div className="flex items-center justify-center  space-x-4 w-full">
                              Aggregate AI Score
                              {sortedBy == "aggregate" && (
                                <img src={union} className="w-3 h-3 ml-2"></img>
                              )}
                            </div>
                          </Th>
                          {maxRo > 2 && (
                            <>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                Round {maxRo - 1} Rating
                              </Th>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                Round {maxRo} Rating
                              </Th>
                            </>
                          )}
                          {maxRo == 2 && (
                            <>
                              <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                                Round {maxRo} Rating
                              </Th>
                            </>
                          )}
                          <RoleBasedAccessControl>
                            <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                              Salary Fitment
                            </Th>
                          </RoleBasedAccessControl>
                          <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                            Rejected Reason
                          </Th>
                          {!companyDetails?.from_acfl && (
                            <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                              Actions
                            </Th>
                          )}
                        </Tr>
                      </Thead>
                      <Tbody>
                        {allApplicants.map((a, index) => {
                          return (
                            <Tr className="text-sm">
                              <Td className="border-y p-2 text-left text-[#148EFF]">
                                <div className="">
                                  <p className="flex items-center">
                                    <button
                                      className="text-left"
                                      onClick={() => {
                                        dispatch(updateSortedBy(sortedBy));
                                        dispatch(
                                          updateCandidateFilters({
                                            sourceFilter: sourceFilter,
                                            fitmentFilter: fitmentFilter,
                                            timeToJoinFilter: timeToJoinFilter,
                                            preferredLocationFilter:
                                              preferredLocationFilter,
                                            startDate: startDate,
                                            endDate: endDate,
                                            updated: true,
                                            page: pageDets.page,
                                            page_size: pageDets.page_size,
                                          }),
                                        );
                                        navigate("/jobs/candidates/about", {
                                          state: { uuid: a.uuid, id: id },
                                        });
                                        // sessionStorage.setItem('currentPage', currentPage)
                                      }}
                                    >
                                      {a.name}
                                    </button>
                                    {(["northstarz.ai", "northstarz"].includes(
                                      a?.source?.toLowerCase(),
                                    ) ||
                                      ["northstarz.ai", "northstarz"].includes(
                                        a?.heardaboutus?.toLowerCase(),
                                      )) && (
                                        <div className="group relative">
                                          <img
                                            src={sparkle}
                                            className="h-4 mx-1"
                                            alt="sparkle"
                                          ></img>
                                          <div className="absolute transition-all left-3 top-3 text-left p-2 z-30 border-2 border-[#7C3AED] scale-0 rounded-lg bg-[#111827] w-[180px] shadow-lg text-[0.65rem] text-white group-hover:scale-100">
                                            Northstarz sourced applicant
                                          </div>
                                        </div>
                                      )}
                                    <div className="group relative">
                                      <img
                                        src={mail}
                                        className="h-4 mx-1"
                                      ></img>
                                      <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2  border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem]  group-hover:scale-100">
                                        <a
                                          href={`mailto:${a.email}`}
                                          className="truncate"
                                        >
                                          {a.email}
                                        </a>
                                      </div>
                                    </div>
                                  </p>
                                </div>
                                <p className="text-black text-xs my-1">
                                  {a.countrycode} {a.phone}
                                </p>
                              </Td>
                              <Td className="border-y text-center p-2">
                                <div className="flex justify-center items-center">
                                  {/* Show aggregate or "-" if empty/zero */}
                                  <div className="ml-2">
                                    {a.aggregate == 0 || a.interviewdate == ""
                                      ? "-"
                                      : `${a.aggregate}`}
                                  </div>

                                  {/* Cheat detection flag */}
                                  <div className="w-6 flex justify-center">
                                    {a?.cheatpercent > 50 ? (
                                      <div className="group relative">
                                        <img
                                          src={cheatflag}
                                          className="h-4"
                                          alt="flag"
                                        />
                                        <div className="absolute transition-all left-3 top-3 text-left p-3 z-20 border-2 border-light-blue scale-0 rounded-lg bg-white w-fit shadow-md text-[0.7rem] group-hover:scale-100">
                                          <span className="truncate text-red-600">
                                            Unusual behaviour detected
                                          </span>
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="h-4 w-4"></div>
                                    )}
                                  </div>
                                </div>
                              </Td>

                              {maxRo > 2 && (
                                <>
                                  <Td className="border-y text-center p-2">
                                    {a.interviewrattingsobject.hasOwnProperty(
                                      maxRo - 2,
                                    ) ? (
                                      <div className="bg-[#FFEBD6] relative group flex justify-center align-center rounded-sm w-[50%] gap-2">
                                        <p className="text-[#FE7F00] font-bold">
                                          {a.interviewrattingsobject[maxRo - 2]}
                                        </p>
                                        <img src={rattingstar} />
                                        <div className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                          {a.roundsinfo.reverse().map((i) => {
                                            return (
                                              <div className="mb-3">
                                                {i.roundfrom != "1" && (
                                                  <div className="flex justify-between items-center">
                                                    <div className="flex items-center gap-1">
                                                      <p className="font-semibold">
                                                        Round {i.roundfrom} :
                                                      </p>
                                                      <p>
                                                        {
                                                          i.functionalmanagername
                                                        }
                                                      </p>
                                                    </div>

                                                    <div className="bg-[#FFEBD6] group relative flex justify-center align-center rounded-sm w-1/4 gap-2">
                                                      <p className="text-[#FE7F00] font-bold">
                                                        {i.star}
                                                      </p>
                                                      <img src={rattingstar} />
                                                    </div>
                                                  </div>
                                                )}
                                                <p>{i.feedback}</p>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    ) : (
                                      "-"
                                    )}
                                  </Td>
                                  <Td className="border-y text-center p-2">
                                    {a.interviewrattingsobject.hasOwnProperty(
                                      maxRo - 1,
                                    ) ? (
                                      // a.interviewrattingsobject[maxRo - 1]
                                      <div className="bg-[#FFEBD6] relative group flex justify-center align-center rounded-sm w-[50%] gap-2">
                                        <p className="text-[#FE7F00] font-bold">
                                          {a.interviewrattingsobject[maxRo - 1]}
                                        </p>
                                        <img src={rattingstar} />
                                        <div className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                          {a.roundsinfo.reverse().map((i) => {
                                            return (
                                              <div className="mb-3">
                                                {i.roundfrom != "1" && (
                                                  <div className="flex justify-between items-center">
                                                    <div className="flex items-center gap-1">
                                                      <p className="font-semibold">
                                                        Round {i.roundfrom} :
                                                      </p>
                                                      <p>
                                                        {
                                                          i.functionalmanagername
                                                        }
                                                      </p>
                                                    </div>

                                                    <div className="bg-[#FFEBD6] group relative flex justify-center align-center rounded-sm w-1/4 gap-2">
                                                      <p className="text-[#FE7F00] font-bold">
                                                        {i.star}
                                                      </p>
                                                      <img src={rattingstar} />
                                                    </div>
                                                  </div>
                                                )}
                                                <p>{i.feedback}</p>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    ) : (
                                      "-"
                                    )}
                                  </Td>
                                </>
                              )}
                              {maxRo == 2 && (
                                <>
                                  <Td className="border-y text-center p-2">
                                    {a.interviewrattingsobject.hasOwnProperty(
                                      maxRo - 1,
                                    ) ? (
                                      // a.interviewrattingsobject[maxRo - 1]
                                      <div className="bg-[#FFEBD6] relative group flex justify-center align-center rounded-sm w-[50%] gap-2">
                                        <p className="text-[#FE7F00] font-bold">
                                          {a.interviewrattingsobject[maxRo - 1]}
                                        </p>
                                        <img src={rattingstar} />
                                        <div className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem] group-hover:scale-100">
                                          {a.roundsinfo.reverse().map((i) => {
                                            return (
                                              <div className="mb-3">
                                                {i.roundfrom != "1" && (
                                                  <div className="flex justify-between items-center">
                                                    <div className="flex items-center gap-1">
                                                      <p className="font-semibold">
                                                        Round {i.roundfrom} :
                                                      </p>
                                                      <p>
                                                        {
                                                          i.functionalmanagername
                                                        }
                                                      </p>
                                                    </div>

                                                    <div className="bg-[#FFEBD6] group relative flex justify-center align-center rounded-sm w-1/4 gap-2">
                                                      <p className="text-[#FE7F00] font-bold">
                                                        {i.star}
                                                      </p>
                                                      <img src={rattingstar} />
                                                    </div>
                                                  </div>
                                                )}
                                                <p>{i.feedback}</p>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    ) : (
                                      "-"
                                    )}
                                  </Td>
                                </>
                              )}
                              <RoleBasedAccessControl>
                                <Td className="border-y text-center p-2">
                                  <div className="group relative flex justify-center">
                                    <button>
                                      {parseInt(
                                        a?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", ""),
                                      ) < minSalary && (
                                          <div className="text-[#8F94A1]">
                                            <p className="text-[0.6rem]">
                                              Below Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#8F94A1] h-[0.5rem] rounded-lg`}
                                                style={{ width: `33%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {parseInt(
                                        a?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", ""),
                                      ) >= minSalary &&
                                        parseInt(
                                          a?.expectedsalary
                                            ?.split(" ")[1]
                                            ?.replaceAll(",", ""),
                                        ) <= maxSalary && (
                                          <div className="text-[#40B2B7]">
                                            <p className="text-[0.7rem]">
                                              Within Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#40B2B7] h-[0.5rem] rounded-lg`}
                                                style={{ width: `50%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {parseInt(
                                        a?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", ""),
                                      ) > maxSalary && (
                                          <div className="text-[#E95060]">
                                            <p className="text-[0.7rem]">
                                              Above Range
                                            </p>
                                            <div className="bg-[#E9EBFA] h-[0.5rem] relative my-1 rounded-lg w-[3.9rem] mx-auto">
                                              <div
                                                className={`absolute bg-[#E95060] h-[0.5rem] rounded-lg`}
                                                style={{ width: `66%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )}
                                      {!a.expectedsalary && <p>-</p>}
                                    </button>
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) < minSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-10 text-left top-1-left p-3 shadow-md z-20 border-2 border-[#8F94A1]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                        >
                                          <p className="mb-1">
                                            <b>Current Salary: </b>
                                            {getCurrencySymbol(
                                              companyCountryCode,
                                            )}{" "}
                                            {formatSalary(
                                              a.currentsalary,
                                              companyCountryCode,
                                            )}
                                          </p>
                                          <p>
                                            <b>Expected Salary: </b>
                                            {getCurrencySymbol(
                                              companyCountryCode,
                                            )}{" "}
                                            {formatSalary(
                                              a.expectedsalary,
                                              companyCountryCode,
                                            )}
                                          </p>
                                        </div>
                                      )}
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) > minSalary &&
                                      parseInt(
                                        a?.expectedsalary
                                          ?.split(" ")[1]
                                          ?.replaceAll(",", ""),
                                      ) < maxSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-10 top-1-left text-left p-3 shadow-md z-20 border-2 border-[#40B2B7]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                        >
                                          <p className="mb-1">
                                            <b>Current Salary: </b>
                                            {getCurrencySymbol(
                                              companyCountryCode,
                                            )}{" "}
                                            {formatSalary(
                                              a.currentsalary,
                                              companyCountryCode,
                                            )}
                                          </p>
                                          <p>
                                            <b>Expected Salary: </b>
                                            {getCurrencySymbol(
                                              companyCountryCode,
                                            )}{" "}
                                            {formatSalary(
                                              a.expectedsalary,
                                              companyCountryCode,
                                            )}
                                          </p>
                                        </div>
                                      )}
                                    {parseInt(
                                      a?.expectedsalary
                                        ?.split(" ")[1]
                                        ?.replaceAll(",", ""),
                                    ) > maxSalary && (
                                        <div
                                          textv
                                          className="absolute transition-all left-10 top-1-left p-3 text-left shadow-md z-20 border-2 border-[#E95060]  scale-0 rounded-lg bg-white w-[13rem] text-[0.7rem]  group-hover:scale-100"
                                        >
                                          <p className="mb-1">
                                            <b>Current Salary: </b>
                                            {getCurrencySymbol(
                                              companyCountryCode,
                                            )}{" "}
                                            {formatSalary(
                                              a.currentsalary,
                                              companyCountryCode,
                                            )}
                                          </p>
                                          <p>
                                            <b>Expected Salary: </b>
                                            {getCurrencySymbol(
                                              companyCountryCode,
                                            )}{" "}
                                            {formatSalary(
                                              a.expectedsalary,
                                              companyCountryCode,
                                            )}
                                          </p>
                                        </div>
                                      )}
                                  </div>
                                </Td>
                              </RoleBasedAccessControl>
                              <Td className="border-y p-2 text-center">
                                {a?.rejection_reason ||
                                  a?.rejectionreason ||
                                  "-"}
                              </Td>
                              {!companyDetails?.from_acfl && (
                                <Td className="border-y p-2">
                                  <Select
                                    {...selectPortalToBodyProps}
                                    styles={selectPortalStyles}
                                    className=" "
                                    menuPlacement="bottom"
                                    onChange={(option) => {
                                      //    setAction(option.value);
                                      // setActiveApplicant(a);
                                      // setOpenInterviewModal(true);

                                      shouldModalOpen(option, a);
                                    }}
                                    options={allAplicantTabOptions(
                                      a.status,
                                      a.roundsinfo,
                                      a,
                                    )}
                                  ></Select>
                                </Td>
                              )}
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>
                )}
              </div>

              <nav className="bg-white px-4 py-6 flex items-center justify-between border-t border-gray-200 sm:px-6">
                {/* Left side: Page size selector */}
                <div className="hidden sm:block">
                  <label
                    htmlFor="pageSize"
                    className="text-sm text-gray-700 mr-2"
                  >
                    Candidates per page:
                  </label>
                  <select
                    id="pageSize"
                    value={pageDets.page_size}
                    onChange={(e) => {
                      dispatch(
                        updateCandidateFilters({
                          ...filters,
                          page_size: Number(e.target.value),
                        }),
                      );
                      setPageDets({
                        ...pageDets,
                        page_size: Number(e.target.value),
                      });
                    }}
                    className="border border-gray-300 rounded-md px-3 py-1 text-sm"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>

                {/* Right side: Pagination */}
                <div className="flex justify-between sm:justify-end gap-1">
                  <button
                    onClick={() => {
                      dispatch(
                        updateCandidateFilters({
                          ...filters,
                          page: pageDets.page - 1,
                        }),
                      );
                      setPageDets({ ...pageDets, page: pageDets.page - 1 });
                    }}
                    disabled={pageDets.page === 1}
                    className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${pageDets.page === 1 ? "opacity-50" : "hover:bg-gray-50"
                      }`}
                  >
                    Previous
                  </button>

                  <div className="flex space-x-2">
                    {pageDets.page > 4 && (
                      <>
                        <button
                          onClick={() => {
                            dispatch(
                              updateCandidateFilters({ ...filters, page: 1 }),
                            );
                            setPageDets({ ...pageDets, page: 1 });
                          }}
                          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${pageDets.page === 1
                            ? "bg-light-blue text-white"
                            : ""
                            }`}
                        >
                          1
                        </button>
                        <button
                          onClick={() => {
                            dispatch(
                              updateCandidateFilters({ ...filters, page: 2 }),
                            );
                            setPageDets({ ...pageDets, page: 2 });
                          }}
                          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${pageDets.page === 2
                            ? "bg-light-blue text-white"
                            : ""
                            }`}
                        >
                          2
                        </button>
                        <span className="px-2 text-gray-500 text-4xl flex">
                          ...
                        </span>
                      </>
                    )}

                    {getPageRange().map((page) => (
                      <button
                        key={page}
                        onClick={() => {
                          dispatch(
                            updateCandidateFilters({ ...filters, page: page }),
                          );
                          setPageDets({ ...pageDets, page: page });
                        }}
                        className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${pageDets.page === page
                          ? "bg-light-blue text-white"
                          : ""
                          }`}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => {
                      setPageDets({ ...pageDets, page: pageDets.page + 1 });
                      dispatch(
                        updateCandidateFilters({
                          ...filters,
                          page: pageDets.page + 1,
                        }),
                      );
                    }}
                    disabled={pageDets.page === totalPages || totalPages === 0}
                    className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${pageDets.page === totalPages || totalPages === 0
                      ? "opacity-50"
                      : "hover:bg-gray-50"
                      }`}
                  >
                    Next
                  </button>
                </div>
              </nav>
            </div>
          </div>
        </div>

        {withResumeModal && (
          <div className="bg-white border-[1.4px] border-[#D2D4DA] rounded-lg  fixed shadow-2xl p-8 z-50 w-1/4 left-1/2 top-1/2 -translate-x-1/2  -translate-y-1/2">
            <p className="mb-3 w-full text-base font-medium">
              Do you want to add applicants?
            </p>
            <div className="flex w-full justify-between font-semibold ">
              <div className="flex text-[14px] font-medium justify-start space-x-3">
                <input
                  type="radio"
                  checked={withResume}
                  onClick={() => {
                    setWithResume(!withResume);
                  }}
                ></input>
                <p>With Resume</p>
              </div>
              <div className="flex text-[14px] font-medium justify-start space-x-3">
                <input
                  type="radio"
                  checked={!withResume}
                  onClick={() => {
                    setWithResume(!withResume);
                  }}
                ></input>
                <p>Without Resume</p>
              </div>
            </div>
            <div className="flex w-full justify-between mt-6">
              <button
                onClick={() => {
                  setWithResumeModal(false);
                }}
                className="py-2 px-5 rounded-[4px] bg-white text-[#148EFF] border-[#148EFF]  border-[1.4px]"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (!withResume) {
                    setWithResumeModal(false);
                    setCsvUploadApplicantModalOpen(true);
                    setIsCsvFlow(true);
                  } else {
                    setWithResumeModal(false);
                    setModalBulkUploadOpen(true);
                    setIsCsvFlow(false);
                  }
                }}
                className="py-2   bg-[#148EFF] text-white px-5 rounded-[4px]"
              >
                Continue
              </button>
            </div>
          </div>
        )}

        {modalBulkUploadOpen && (
          <>
            <div className="bg-white rounded-lg fixed shadow-2xl z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="card-header flex justify-between pt-6 px-6 pb-4">
                <div className="text-2xl font-medium">Add New Applicants</div>
                <button
                  className=""
                  onClick={() => {
                    setModalBulkUploadOpen(false);
                    setMultipleResumeFiles([]);
                  }}
                >
                  <img src={cross} style={{ width: "15px" }} alt="Close" />
                </button>
              </div>
              <div className="border w-full"></div>
              <div
                className="card-body p-6 flex flex-col gap-2"
                // onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
              >
                {multipleResumeFiles.length > 0 ? (
                  <>
                    <div className="w-full border-dashed border-2 border-gray-300 rounded-md justify-center flex flex-col flex-wrap items-center gap-5 py-14">
                      <div className="w-full flex flex-wrap gap-2 justify-center">
                        {Array.from(multipleResumeFiles).map((file, i) => {
                          return (
                            <div className="border-2 rounded-md border-gray-300 flex-col flex w-1/4">
                              <span className="flex justify-end p-1">
                                <button
                                  className=""
                                  onClick={() => {
                                    console.log(i);
                                    setMultipleResumeFiles(
                                      Array.from(multipleResumeFiles).filter(
                                        (data, idx) => idx !== i,
                                      ),
                                    );
                                    // setMultipleResumeFiles(arr);
                                  }}
                                >
                                  <img src={cross} alt="Remove" />
                                </button>
                              </span>
                              <div className="flex gap-1 items-center px-6 pb-4">
                                <div>
                                  <img src={file_upload} alt="Uploaded file" />
                                </div>
                                <div className="">
                                  <span>
                                    {file?.name.lenght > 5 ? (
                                      <p>{file?.name}</p>
                                    ) : (
                                      <p>{file?.name.substr(0, 6)}...</p>
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <span
                        className="text-xl font-medium"
                        style={{ color: "#0DCD94" }}
                      >
                        Resume Added Successfully
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-14"
                      onClick={() => {
                        fileInputRef.current.click();
                      }}
                    >
                      <div className="p-6">
                        {/* <img src={Tick_Square} className="" alt="Tick" /> */}
                      </div>
                      <span
                        className="text-xl font-medium"
                        style={{ color: "#0DCD94" }}
                      >
                        Select a .pdf or .docx file to upload
                      </span>
                      <span className="text-sm text-gray-500 pb-2">
                        drag & drop it here
                      </span>
                      <input
                        ref={fileInputRef}
                        type="file"
                        className="hidden"
                        multiple
                        onChange={handleMultipleUploads}
                      />
                    </div>
                    <CSVLink
                      className=""
                      filename={`Candidate bulk upload template`}
                      headers={Tempheaders}
                      data={TempData}
                    >
                      <div className="flex justify-start gap-1">
                        <span className="text-sm text-gray-500 font-normal">
                          *You can upload maximum 10 resume at a time
                        </span>
                      </div>
                    </CSVLink>
                  </>
                )}
              </div>
              <div className="border w-full"></div>
              <div className=" card-footer pb-6 pl-6 pr-6 pt-3 relative">
                <div
                  className={
                    multipleResumeFiles.length > 0
                      ? "flex justify-between"
                      : "flex justify-end"
                  }
                >
                  {multipleResumeFiles.length > 0 && (
                    <>
                      <button
                        className={
                          multipleResumeFiles.length < 10
                            ? "border-[1.4px] border-blue-500 text-blue-500 font-normal py-2 px-5 rounded-[4px]"
                            : " border-[1.4px] border-blue-500 text-blue-500 font-normal py-2 px-5 rounded-[4px] opacity-50"
                        }
                        disabled={multipleResumeFiles.length >= 10}
                        onClick={() => {
                          fileInputRef.current.click();
                        }}
                      >
                        Add File
                      </button>

                      <input
                        ref={fileInputRef}
                        type="file"
                        className="hidden"
                        multiple
                        onChange={handleAdditionalMultipleResumeUpload}
                      />
                    </>
                  )}
                  <button
                    className={
                      !multipleResumeFiles.length > 0
                        ? "bg-blue-500  text-white font-bold py-2 px-5 rounded-[4px] opacity-40"
                        : "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-[4px]"
                    }
                    disabled={!multipleResumeFiles.length > 0}
                    onClick={bulkParse}
                  >
                    {parsedLoader ? "Uploading ..." : "Upload"}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {showCandidates && (
          <>
            <div className="bg-white rounded-lg fixed shadow-2xl  z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="card-header  flex justify-between pt-6 px-6 pb-4">
                <div className="text-2xl font-medium">Review Applicants</div>
                <button
                  className=""
                  onClick={() => {
                    setShowCandidates(false);
                    setParsedData([]);
                    setMultipleResumeFiles([]);
                  }}
                >
                  <img src={cross} style={{ width: "15px" }} alt="Close" />
                </button>
              </div>

              <div className="border w-full"></div>

              <div className="px-6 overflow-y-scroll max-h-[20rem] ">
                <Table className="my-4  border-t rounded-t-xl ">
                  <Thead className="text-center text-sm  sticky rounded-lg bg-white z-30 top-0">
                    <Tr className="text-center">
                      <Th className="border-y  py-3 ">
                        <input
                          type="checkbox"
                          checked={selectedAll}
                          onChange={() => {
                            handleCheckbox();
                          }}
                        />
                      </Th>
                      <Th className="border-y  py-3">Candidate Name</Th>
                      <Th className="border-y  py-3">Source</Th>
                      <Th className="border-y  py-3">Email</Th>
                      <Th className="border-y text-center py-3">
                        Phone Number
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {parsedData.map((p) => {
                      return (
                        <>
                          <Tr className="text-sm">
                            <Td className={"border-y  text-center p-2"}>
                              <span>
                                <input
                                  type="checkbox"
                                  checked={selectedRows?.find(
                                    (row) => row.email === p.email,
                                  )}
                                  onClick={() => {
                                    handleSelectedRow(p);
                                  }}
                                />
                              </span>
                            </Td>

                            <Td className={"border-y  text-left p-3"}>
                              <input
                                value={p["name"]}
                                onChange={(e) => {
                                  p["name"] = e.target.value;
                                  setParsedData([...parsedData]);
                                }}
                                className="outline-none w-full"
                              ></input>
                            </Td>
                            <Td className={"border-y  text-center p-2"}>
                              <select
                                onChange={(e) => {
                                  p["source"] = e.target.value;
                                }}
                                className="px-2 py-1 border w-full  outline-none  rounded-md"
                              >
                                <option value="">Select Source</option>
                                {hearoptions.map((o) => {
                                  return (
                                    <option value={o.value}>{o.label}</option>
                                  );
                                })}
                              </select>
                            </Td>
                            <Td className="border-y text-center p-3">
                              <input
                                value={p["email"]}
                                onChange={(e) => {
                                  p["email"] = e.target.value;
                                  setParsedData([...parsedData]);
                                }}
                                className="outline-none break-words w-full"
                              ></input>
                            </Td>
                            <Td className="border-y text-center p-3">
                              <input
                                value={p["pnum"]}
                                onChange={(e) => {
                                  p["pnum"] = e.target.value;
                                  setParsedData([...parsedData]);
                                }}
                                className="outline-none text-center w-full"
                              ></input>
                            </Td>
                          </Tr>
                        </>
                      );
                    })}
                  </Tbody>
                </Table>
              </div>

              {notParsed.map((p) => {
                return (
                  <>
                    {
                      <div className={"w-full"}>
                        <div className={"border-y  text-left p-3 text-red-500"}>
                          {p.split(0, 10)} could not parsed
                        </div>
                      </div>
                    }
                  </>
                );
              })}
              <div className="border w-full"></div>
              <div className=" card-footer pb-6 pl-6 pr-6 pt-1 relative">
                <div className="flex justify-between pt-2">
                  <div className="flex gap-2">
                    {!isCsvFlow ? (
                      <>
                        <button
                          className={
                            multipleResumeFiles.length < 10
                              ? "border-[1.4px] border-blue-500 text-blue-500 font-normal py-2 px-5 rounded-[4px]"
                              : " border-[1.4px] border-blue-500 text-blue-500 font-normal py-2 px-5 rounded-[4px] opacity-50"
                          }
                          disabled={multipleResumeFiles.length >= 10}
                          onClick={() => {
                            setShowCandidates(false);
                            setModalBulkUploadOpen(true);
                            setParsedData([]);
                            setNotParsed([]);
                          }}
                        >
                          Add
                        </button>
                        <button
                          className={
                            selectedRows.length > 0
                              ? "border-[1.4px] border-blue-500 text-blue-500 font-normal py-2 px-5 rounded-[4px]"
                              : " border-[1.4px] border-blue-500 text-blue-500 font-normal py-2 px-5 rounded-[4px] opacity-50"
                          }
                          disabled={!selectedRows.length > 0}
                          onClick={handleCandidateDelete}
                        >
                          Delete
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            setCsvUploadApplicantModalOpen(true);
                            setCsvBulkUpFile(null);
                            setShowCandidates(false);
                          }}
                          className="border-[#148EFF] border bg-white rounded-[4px] text-[#148EFF] py-2 px-3"
                        >
                          File Re-Upload
                        </button>
                      </>
                    )}
                  </div>

                  <button
                    className={
                      selectedRows.length == 0 || parsedData.length == 0
                        ? "bg-blue-500  text-white font-bold py-2 px-5 rounded-[4px] opacity-40"
                        : "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-[4px]"
                    }
                    onClick={isCsvFlow ? handleBulkSubmit : handleSubmit}
                    disabled={
                      selectedRows.length == 0 || parsedData.length == 0
                    }
                  >
                    {addCandidatesLoader ? "Adding..." : "Add Applicants"}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        {skippedCandidates.length > 0 && (
          <>
            <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
              <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white   rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
                <div className="card-header  flex justify-between pt-6 px-6 pb-4">
                  <div className="text-2xl font-medium">Warning</div>
                  <button
                    className=""
                    onClick={() => {
                      setSkippedCandidates([]);
                    }}
                  >
                    <img src={cross} style={{ width: "15px" }} alt="Close" />
                  </button>
                </div>

                <div className="border w-full"></div>

                <div className="px-6 overflow-y-scroll max-h-[20rem] ">
                  <Table className="my-4  border-t rounded-t-xl ">
                    <Thead className="text-center text-sm  sticky rounded-lg bg-white z-30 top-0">
                      <Tr className="text-center">
                        <Th className="border-y  py-3 ">
                          <input
                            type="checkbox"
                            checked={selectedHackerRankAll}
                            onChange={() => {
                              handleHackerRankCheckbox();
                            }}
                          />
                        </Th>
                        <Th className="border-y  py-3">Candidate Name</Th>
                        <Th className="border-y  py-3">Email</Th>
                        <Th className="border-y text-center py-3">Reason</Th>
                        <Th className="border-y text-center py-3">Action</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {skippedCandidates.map((p) => {
                        const reportCandidateId = p.candidateId || p.hackerrankid;
                        return (
                          <>
                            <Tr className="text-sm">
                              <Td className={"border-y  text-center p-2"}>
                                <span>
                                  <input
                                    type="checkbox"
                                    checked={selectedHackerRankRows?.find(
                                      (row) => row.email === p.email,
                                    )}
                                    onClick={() => {
                                      handleSelectedHackerRankRow(p);
                                    }}
                                  />
                                </span>
                              </Td>

                              <Td className={"border-y  text-left p-3"}>
                                {p.name}
                              </Td>
                              <Td className={"border-y  text-center p-2"}>
                                {p.email}
                              </Td>
                              <Td className="border-y text-center p-3">
                                {p.reason}
                              </Td>
                              <Td className="border-y text-center p-3">
                                <button className="bg-[#148EFF] whitespace-nowrap text-white py-2 px-4 w-fit rounded-lg"
                                  disabled={!reportCandidateId}
                                  onClick={() => {
                                    showReport(reportCandidateId, p.provider);
                                  }}
                                >
                                  View Report
                                </button>
                              </Td>
                            </Tr>
                          </>
                        );
                      })}
                    </Tbody>
                  </Table>
                </div>

                <div className="border w-full"></div>
                <div className=" card-footer pb-6 pl-6 pr-6 pt-1 relative">
                  <div className="flex justify-between pt-2">
                    <button
                      className={
                        selectedHackerRankRows.length == 0 ||
                          skippedCandidates.length == 0
                          ? "bg-blue-500  text-white font-bold py-2 px-5 rounded-[4px] opacity-40"
                          : "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-[4px]"
                      }
                      onClick={mergeHackerRankResult}
                      disabled={
                        selectedHackerRankRows.length == 0 ||
                        skippedCandidates.length == 0
                      }
                    >
                      {mergeCandidatesLoader
                        ? "Merging..."
                        : "Merge Applicants"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* {reportUrl.length>0&& (
          <>
            <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
             <div className="fixed bg-white border shadow-xl md:w-[20%]  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                    <div className="p-3 rounded-xl text-center  flex flex-col space-y-4">
                      <div className="flex flex-col items-center  justify-center">
                      <iframe src={reportUrl} className="w-full h-full"></iframe>
                      </div>
                    </div>
                  </div>
            </div>
          </>
        )} */}

        {hackerRankLoader && (
          <>
            <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
              <div className="fixed bg-white border shadow-xl md:w-[20%]  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="p-3 rounded-xl text-center  flex flex-col space-y-4">
                  <div className="flex flex-col items-center  justify-center">
                    <TailSpin color="black" height="50" width="50"></TailSpin>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {rejectionLoader && (
          <>
            <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
              <div className="fixed bg-white border shadow-xl md:w-[20%]  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="p-3 rounded-xl text-center  flex flex-col space-y-4">
                  <div className="flex flex-col items-center  justify-center">
                    <TailSpin color="black" height="50" width="50"></TailSpin>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {csvUploadApplicantModalOpen && (
          <>
            <div className="bg-white rounded-lg fixed shadow-2xl z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="card-header flex justify-between pt-6 px-6 pb-4">
                <div className="text-2xl font-medium">Add New Applicants</div>
                <button
                  className=""
                  onClick={() => {
                    setCsvUploadApplicantModalOpen(false);
                    setIsCsvFlow(false);
                  }}
                >
                  <img src={cross} style={{ width: "15px" }} alt="Close" />
                </button>
              </div>
              <div className="border w-full"></div>
              <div
                className="card-body p-6 flex flex-col gap-2"
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
              >
                {csvBulkUpFile != null ? (
                  <>
                    <div className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-14 gap-5">
                      <div className="border-2 rounded-md border-gray-300 flex flex-col">
                        <span className="flex justify-end p-1">
                          <button className="" onClick={handleCsvDelete}>
                            <img src={cross} alt="Remove" />
                          </button>
                        </span>
                        <div className="flex gap-1 items-center px-6 pb-4">
                          <div>
                            <img src={file_upload} alt="Uploaded file" />
                          </div>
                          <span>{csvBulkUpFile?.name}</span>
                        </div>
                      </div>
                      <span
                        className="text-xl font-medium"
                        style={{ color: "#0DCD94" }}
                      >
                        File Uploaded Successfully
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-14"
                      onClick={() => {
                        fileInputRef.current.click();
                      }}
                    >
                      <div className="p-6">
                        <img src={Tick_Square} className="" alt="Tick" />
                      </div>
                      <span
                        className="text-xl font-medium"
                        style={{ color: "#0DCD94" }}
                      >
                        Select a CSV file to upload
                      </span>
                      <span className="text-sm text-gray-500 pb-2">
                        drag & drop it here
                      </span>
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".csv"
                        className="hidden"
                        onChange={handleBulkCsvApplicant}
                      />
                    </div>
                    <CSVLink
                      className=""
                      filename={`Candidate bulk upload template`}
                      headers={Tempheaders}
                      data={TempData}
                    >
                      <div className="flex justify-end gap-1">
                        <img src={Download} className="" alt="Download" />

                        <span className="text-sm text-gray-500 font-normal">
                          Download Sample CSV file
                        </span>
                      </div>
                    </CSVLink>
                  </>
                )}
              </div>
              <div className="border w-full"></div>
              <div className=" card-footer pb-6 pl-6 pr-6 pt-3 relative">
                <div
                  className={
                    csvBulkUpFile != null
                      ? "flex justify-between"
                      : "flex justify-end"
                  }
                >
                  {csvBulkUpFile != null && (
                    <button
                      onClick={() => {
                        setCsvUploadApplicantModalOpen(true);
                        setCsvBulkUpFile(null);
                      }}
                      className="border-[#148EFF] border bg-white rounded-[4px] text-[#148EFF] py-2 px-3"
                    >
                      Replace
                    </button>
                  )}
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    disabled={!csvBulkUpFile}
                    onClick={() => {
                      setCsvUploadApplicantModalOpen(false);
                      setShowCandidates(true);
                    }}
                  >
                    {csvBulkUpFile == null ? "Upload" : "Preview"}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {inviteModalIsOpen && (
          <>
            <div className="bg-white rounded-lg fixed shadow-2xl z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="card-header flex justify-between pt-6 px-6 pb-4">
                <div className="text-2xl font-medium">Invite Applicant</div>
                <button
                  className=""
                  onClick={() => {
                    setInviteModalIsOpen(false);
                    setMultipleResumeFiles([]);
                  }}
                >
                  <img src={cross} style={{ width: "15px" }} alt="Close" />
                </button>
              </div>
              <div className="border w-full"></div>
              <div
                className="card-body p-6 flex flex-col gap-2"
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
              >
                {file != null ? (
                  <>
                    <div className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-14 gap-5">
                      <div className="border-2 rounded-md border-gray-300 flex flex-col">
                        <span className="flex justify-end p-1">
                          <button className="" onClick={handleDefault}>
                            <img src={cross} alt="Remove" />
                          </button>
                        </span>
                        <div className="flex gap-2 items-center px-6 pb-4">
                          <div>
                            <img src={file_upload} alt="Uploaded file" />
                          </div>
                          <span>{file?.name}</span>
                        </div>
                      </div>
                      <span
                        className="text-xl font-medium"
                        style={{ color: "#0DCD94" }}
                      >
                        File Uploaded Successfully
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-14"
                      onClick={() => {
                        fileInputRef.current.click();
                      }}
                    >
                      <div className="p-6">
                        <img src={Tick_Square} className="" alt="Tick" />
                      </div>
                      <span
                        className="text-xl font-medium"
                        style={{ color: "#0DCD94" }}
                      >
                        Select a CSV file to upload
                      </span>
                      <span className="text-sm text-gray-500 pb-2">
                        drag & drop it here
                      </span>
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".csv"
                        className="hidden"
                        onChange={handleFileUpload}
                      />
                    </div>
                    <CSVLink
                      className=""
                      filename={`Candidate bulk upload template`}
                      headers={job?.aicalling ? aiCallingHeaders : Tempheaders}
                      data={job?.aicalling ? aiCallingData : TempData}
                      enclosingCharacter={job?.aicalling ? "" : `"`}
                    >
                      <div className="flex justify-end gap-1">
                        <img src={Download} className="" alt="Download" />

                        <span className="text-sm text-gray-500 font-normal">
                          Download correctly formated sample CSV file
                        </span>
                      </div>
                    </CSVLink>
                  </>
                )}
              </div>
              <div className="border w-full"></div>
              <div className=" card-footer pb-6 pl-6 pr-6 pt-3 relative">
                <div
                  className={
                    file != null ? "flex justify-between" : "flex justify-end"
                  }
                >
                  {file != null && (
                    <button
                      onClick={() => {
                        setReadCsvData([]);
                        setReviewCsvData(false);
                        setFile(null);
                        setInviteModalIsOpen(true);
                      }}
                      className="border-[#148EFF] border bg-white rounded-[4px] text-[#148EFF] py-2 px-3"
                    >
                      Replace
                    </button>
                  )}
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-[4px]"
                    disabled={!file || parsedLoader}
                    onClick={() => {
                      if (job?.aicalling) {
                        setParsedLoader(true);
                        const formData = new FormData();
                        formData.append("job_id", id);
                        formData.append("company_id", cid);
                        formData.append("country_code", companyCountryCode);
                        formData.append("file", file);
                        axiosInstance
                          .post(
                            `${server_API}/api/v1/csv-bulk-upload`,
                            formData,
                          )
                          .then((response) => {
                            toast.success("CSV file uploaded successfully");
                            setInviteModalIsOpen(false);
                            setFile(null);
                          })
                          .catch((error) => {
                            toast.error("CSV file upload failed");
                          })
                          .finally(() => {
                            setParsedLoader(false);
                          });
                      } else {
                        setReviewCsvData(true);
                        setInviteModalIsOpen(false);
                        // navigate("/jobs/candidates/upload",{state:{data:readcsvData, Name: file.name, jobid:id }});
                      }
                    }}
                  >
                    {parsedLoader
                      ? "Uploading..."
                      : file == null
                        ? "Upload"
                        : job?.aicalling
                          ? "Upload"
                          : "Preview"}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {reviewCsvData && (
          <div className="bg-white rounded-lg fixed shadow-2xl  z-50  left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            {readcsvData.length > 0 ? (
              <div>
                <div className="card-header flex max-h-screen justify-between pt-6 px-6 pb-4">
                  <div className="text-2xl font-medium">Invite Applicants</div>
                  <button
                    className=""
                    onClick={() => {
                      setReviewCsvData(false);
                      setParsedData([]);
                      setMultipleResumeFiles([]);
                    }}
                  >
                    <img src={cross} style={{ width: "15px" }} alt="Close" />
                  </button>
                </div>
                <div className="border w-full"></div>
                <div className="p-6 mx-auto  overflow-y-scroll max-h-[20rem] ">
                  <Table className="  border rounded-t-xl ">
                    <Thead className="text-center text-sm  sticky rounded-lg bg-white z-30 top-0">
                      <Tr className="text-center">
                        <Th className="">
                          <input
                            type="checkbox"
                            checked={selectCsvAll}
                            onChange={handleSelectAllCsv}
                          />
                        </Th>
                        <Th className="border-y font-semibold text-base p-3">
                          Candidate Name
                        </Th>
                        <Th className="border-y font-semibold text-base p-3">
                          Email
                        </Th>
                        <Th className="border-y font-semibold text-base p-3">
                          Phone Number
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody className="w-full">
                      {readcsvData.map((r) => {
                        return (
                          <Tr>
                            <Td className="border-y text-center p-3 ">
                              <span>
                                <input
                                  type="checkbox"
                                  checked={selectedCsvData?.find(
                                    (row) => row.Email === r.Email,
                                  )}
                                  onChange={() => handleSelectedCsvRow(r)}
                                />
                              </span>
                            </Td>
                            <Td className="text-center border-y p-3">
                              {r.Name}
                            </Td>
                            <Td className="text-center border-y p-3">
                              {r.Email}
                            </Td>
                            <Td className="text-center border-y p-3">
                              {r.Phone}
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </div>
                <div className="border w-full"></div>
                <div className=" card-footer pb-6 pl-6 pr-6 pt-1 relative">
                  <div className="flex justify-between pt-2">
                    <button
                      onClick={() => {
                        setReadCsvData([]);
                        setReviewCsvData(false);
                        setFile(null);
                        setIsOpen(true);
                      }}
                      className="border-[#148EFF] border bg-white rounded-[4px] text-[#148EFF] py-2 px-5"
                    >
                      Replace
                    </button>
                    <button
                      onClick={sendMail}
                      className={
                        selectedCsvData.length > 0
                          ? "bg-[#148EFF] text-white rounded-[4px]  py-2 px-5"
                          : "bg-[#148EFF] text-white rounded-[4px]  py-2 px-5 opacity-40"
                      }
                      disabled={!selectedCsvData.length > 0}
                    >
                      {!loader ? "Send Invite" : "Sending..."}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="py-8 px-8  w-full border-[1.4px] border-[#D2D4DA] rounded-lg">
                <div className="bg-[#FFCCCC] p-3 rounded-lg flex items-center gap-3 ">
                  <img src={error} className="h-6"></img>
                  <div className="flex flex-col">
                    <p>File is uploaded not in correct format</p>
                    <CSVLink
                      filename={`Candidate bulk upload template`}
                      headers={Tempheaders}
                      data={TempData}
                    >
                      <span className="text-[#0072DC] text-xs font-normal">
                        Here's is the correct format
                      </span>
                    </CSVLink>
                  </div>
                </div>

                <div className="mt-3 mb-6">
                  <p className="font-medium text-base text-center">
                    Continue to upload the file in the correct format?
                  </p>
                </div>
                <div className="flex justify-between">
                  <button
                    onClick={() => {
                      setReadCsvData([]);
                      setReviewCsvData(false);
                      setFile(null);
                      setIsOpen(false);
                    }}
                    className="border-[#148EFF] border bg-white rounded-[4px] text-[#148EFF] py-2 px-5"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      setReadCsvData([]);
                      setReviewCsvData(false);
                      setFile(null);
                      setIsOpen(true);
                    }}
                    className="bg-[#148EFF] text-white rounded-[4px] py-2 px-5"
                  >
                    Continue
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {zipModalIsOpen && (
          <div className="bg-white rounded-lg fixed shadow-2xl z-50 w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="card-header flex justify-between pt-6 px-6 pb-4">
              <div className="text-2xl font-medium">Invite Applicant (Zip)</div>
              <button
                className=""
                onClick={() => {
                  setZipModalIsOpen(false);
                  setZipFile(null);
                }}
              >
                <img src={cross} style={{ width: "15px" }} alt="Close" />
              </button>
            </div>
            <div className="border w-full"></div>
            <div className="card-body p-6 flex flex-col gap-2">
              <div
                className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-14 cursor-pointer"
                onClick={() => {
                  document.getElementById("zip-upload").click();
                }}
              >
                {zipFile ? (
                  <>
                    <div className="p-6">
                      <img src={file_upload} alt="Zip file" />
                    </div>
                    <span
                      className="text-xl font-medium"
                      style={{ color: "#0DCD94" }}
                    >
                      {zipFile.name}
                    </span>
                    <span className="text-sm text-gray-500">
                      {(zipFile.size / (1024 * 1024)).toFixed(2)} MB
                    </span>
                  </>
                ) : (
                  <>
                    <div className="p-6">
                      <img src={Tick_Square} className="" alt="Tick" />
                    </div>
                    <span
                      className="text-xl font-medium"
                      style={{ color: "#0DCD94" }}
                    >
                      Select a Zip file to upload (Max 25MB)
                    </span>
                    <span className="text-sm text-gray-500 pb-2">
                      drag & drop it here
                    </span>
                  </>
                )}
                <input
                  id="zip-upload"
                  type="file"
                  accept=".zip"
                  className="hidden"
                  onChange={handleZipUpload}
                />
              </div>
            </div>
            <div className="border w-full"></div>
            <div className="card-footer pb-6 pl-6 pr-6 pt-3 flex justify-end">
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-[4px] disabled:bg-gray-300 flex items-center gap-2"
                disabled={!zipFile || zipLoader}
                onClick={handleZipSubmit}
              >
                {zipLoader ? (
                  <>
                    <TailSpin
                      height="20"
                      width="20"
                      color="white"
                      ariaLabel="loading"
                    />
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        )}
        <ToastContainer></ToastContainer>
      </div>
    );
};

export default TempCandidates;
